import { AGGRID_COLUMN_TYPES } from 'screens/performanceReview/manageAndInsights/TalentPlanning/dataHooks';

export const STAKEHOLDER_OPTIONS_PROPOSER = {
  MANAGER: { value: 'MANAGER', label: 'Manager of employee' },
  SKIP_MANAGER: { value: 'SKIP_MANAGER', label: 'Skip manager of employee' },
  ANY_EMPLOYEE: { value: 'ANY_EMPLOYEE', label: 'Any employee' },
};

export const STAKEHOLDER_OPTIONS_APPROVER = {
  SKIP_MANAGER: { value: 'SKIP_MANAGER', label: 'Skip manager of employee' },
  ANY_EMPLOYEE: { value: 'ANY_EMPLOYEE', label: 'Any employee' },
};

export const STAKEHOLDER_OPTIONS_PUBLISHER = {
  ANY_EMPLOYEE: { value: 'ANY_EMPLOYEE', label: 'Any employee' },
};

export const STAKEHOLDER_OPTIONS_FLAT_LIST = {
  ANY_EMPLOYEE: { value: 'ANY_EMPLOYEE', label: 'Any employee' },
};

// Table view constants
export const TABLE_VIEW_TYPES = {
  FUNCTION_TREE: 'functionTree',
  FLAT_LIST: 'flatList',
} as const;

export const TABLE_VIEW_OPTIONS = [
  { value: TABLE_VIEW_TYPES.FUNCTION_TREE, label: 'Function tree' },
  { value: TABLE_VIEW_TYPES.FLAT_LIST, label: 'Employee list' },
] as const;

export type TableViewType = (typeof TABLE_VIEW_TYPES)[keyof typeof TABLE_VIEW_TYPES];

export const MOCK_COLUMNS_STAKEHOLDER_FLAT_LIST = [
  {
    columnId: 'employee',
    displayName: 'Employees',
    columnType: 'EMPLOYEE',
    flex: 1,
    autoHeight: true,
    metadata: { isEmployeeSubtitle: true },
    headerName: 'Employee',
    minWidth: 240,
    lockPosition: 'left',
  },
];

export const MOCK_ROWS_STAKEHOLDER_FLAT_LIST = [
  {
    employee: {
      id: 16000,
      companyId: 1,
      displayName: 'Allison Hill',
      designation: 'Environmental health practitioner',
      ownerType: null,
      employeeFunction: null,
      email: 'allison.hill@abc.co',
      personalEmail: 'allison.hill@abc.co',
      workEmail: 'allison.hill@abc.co',
      preferredName: 'Allison',
    },
    id: 200,
    publisherSelectedEmployees: [
      {
        label: 'Nicholas Sheppard',
        subTitle: 'nicholas.sheppard@abc.co',
        profilePhoto: null,
        id: 16150,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brent Rodgers',
        subTitle: 'brent.rodgers@abc.co',
        profilePhoto: null,
        id: 16286,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Amanda Diaz',
        subTitle: 'amanda.diaz@abc.co',
        profilePhoto: null,
        id: 16346,
      },
    ],
  },
  {
    employee: {
      id: 16001,
      companyId: 2,
      displayName: 'Brian Yang',
      designation: 'Sports administrator',
      ownerType: null,
      employeeFunction: null,
      email: 'brian.yang@abc.co',
      personalEmail: 'brian.yang@abc.co',
      workEmail: 'brian.yang@abc.co',
      preferredName: 'Brian',
    },
    id: 201,
    publisherSelectedEmployees: [
      {
        label: 'Kelly Campbell',
        subTitle: 'kelly.campbell@abc.co',
        profilePhoto: null,
        id: 16166,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sandra Aguilar',
        subTitle: 'sandra.aguilar@abc.co',
        profilePhoto: null,
        id: 16080,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Annette Miles',
        subTitle: 'annette.miles@abc.co',
        profilePhoto: null,
        id: 16281,
      },
    ],
  },
  {
    employee: {
      id: 16002,
      companyId: 3,
      displayName: 'Javier Johnson',
      designation: 'Engineering geologist',
      ownerType: null,
      employeeFunction: null,
      email: 'javier.johnson@abc.co',
      personalEmail: 'javier.johnson@abc.co',
      workEmail: 'javier.johnson@abc.co',
      preferredName: 'Javier',
    },
    id: 202,
    publisherSelectedEmployees: [
      {
        label: 'Alicia Gilmore',
        subTitle: 'alicia.gilmore@abc.co',
        profilePhoto: null,
        id: 16125,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Zachary Moore',
        subTitle: 'zachary.moore@abc.co',
        profilePhoto: null,
        id: 16342,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Alexandra Le',
        subTitle: 'alexandra.le@abc.co',
        profilePhoto: null,
        id: 16026,
      },
    ],
  },
  {
    employee: {
      id: 16003,
      companyId: 1,
      displayName: 'Lance Hoffman',
      designation: 'Sports administrator',
      ownerType: null,
      employeeFunction: null,
      email: 'lance.hoffman@abc.co',
      personalEmail: 'lance.hoffman@abc.co',
      workEmail: 'lance.hoffman@abc.co',
      preferredName: 'Lance',
    },
    id: 203,
    publisherSelectedEmployees: [
      {
        label: 'Vernon Huff',
        subTitle: 'vernon.huff@abc.co',
        profilePhoto: null,
        id: 16190,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Nathan Freeman',
        subTitle: 'nathan.freeman@abc.co',
        profilePhoto: null,
        id: 16158,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Edward Fuller',
        subTitle: 'edward.fuller@abc.co',
        profilePhoto: null,
        id: 16009,
      },
    ],
  },
  {
    employee: {
      id: 16004,
      companyId: 2,
      displayName: 'Jerry Ramirez',
      designation: 'Accounting technician',
      ownerType: null,
      employeeFunction: null,
      email: 'jerry.ramirez@abc.co',
      personalEmail: 'jerry.ramirez@abc.co',
      workEmail: 'jerry.ramirez@abc.co',
      preferredName: 'Jerry',
    },
    id: 204,
    publisherSelectedEmployees: [
      {
        label: 'Diane Beck',
        subTitle: 'diane.beck@abc.co',
        profilePhoto: null,
        id: 16107,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Crystal Pham',
        subTitle: 'crystal.pham@abc.co',
        profilePhoto: null,
        id: 16240,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kaitlyn Harvey',
        subTitle: 'kaitlyn.harvey@abc.co',
        profilePhoto: null,
        id: 16253,
      },
    ],
  },
  {
    employee: {
      id: 16005,
      companyId: 3,
      displayName: 'Caitlin Henderson',
      designation: 'Health physicist',
      ownerType: null,
      employeeFunction: null,
      email: 'caitlin.henderson@abc.co',
      personalEmail: 'caitlin.henderson@abc.co',
      workEmail: 'caitlin.henderson@abc.co',
      preferredName: 'Caitlin',
    },
    id: 205,
    publisherSelectedEmployees: [
      {
        label: 'James Powers',
        subTitle: 'james.powers@abc.co',
        profilePhoto: null,
        id: 16065,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kathryn Farrell',
        subTitle: 'kathryn.farrell@abc.co',
        profilePhoto: null,
        id: 16059,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Laura Barnett',
        subTitle: 'laura.barnett@abc.co',
        profilePhoto: null,
        id: 16154,
      },
    ],
  },
  {
    employee: {
      id: 16006,
      companyId: 1,
      displayName: 'Tyler Rogers',
      designation: 'Chief Executive Officer',
      ownerType: null,
      employeeFunction: null,
      email: 'tyler.rogers@abc.co',
      personalEmail: 'tyler.rogers@abc.co',
      workEmail: 'tyler.rogers@abc.co',
      preferredName: 'Tyler',
    },
    id: 206,
    publisherSelectedEmployees: [
      {
        label: 'Gary Santiago',
        subTitle: 'gary.santiago@abc.co',
        profilePhoto: null,
        id: 16195,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michelle Pierce',
        subTitle: 'michelle.pierce@abc.co',
        profilePhoto: null,
        id: 16399,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Raymond Shelton',
        subTitle: 'raymond.shelton@abc.co',
        profilePhoto: null,
        id: 16333,
      },
    ],
  },
  {
    employee: {
      id: 16007,
      companyId: 2,
      displayName: 'Ian Cooper',
      designation: 'Geneticist, molecular',
      ownerType: null,
      employeeFunction: null,
      email: 'ian.cooper@abc.co',
      personalEmail: 'ian.cooper@abc.co',
      workEmail: 'ian.cooper@abc.co',
      preferredName: 'Ian',
    },
    id: 207,
    publisherSelectedEmployees: [
      {
        label: 'Michael Romero',
        subTitle: 'michael.romero@abc.co',
        profilePhoto: null,
        id: 16340,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Benjamin Beck',
        subTitle: 'benjamin.beck@abc.co',
        profilePhoto: null,
        id: 16099,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Cindy Carr',
        subTitle: 'cindy.carr@abc.co',
        profilePhoto: null,
        id: 16396,
      },
    ],
  },
  {
    employee: {
      id: 16008,
      companyId: 3,
      displayName: 'Monica Herrera',
      designation: 'Multimedia specialist',
      ownerType: null,
      employeeFunction: null,
      email: 'monica.herrera@abc.co',
      personalEmail: 'monica.herrera@abc.co',
      workEmail: 'monica.herrera@abc.co',
      preferredName: 'Monica',
    },
    id: 208,
    publisherSelectedEmployees: [
      {
        label: 'Patrick Rivera',
        subTitle: 'patrick.rivera@abc.co',
        profilePhoto: null,
        id: 16162,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brenda Lawson',
        subTitle: 'brenda.lawson@abc.co',
        profilePhoto: null,
        id: 16389,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Nicholas Mcbride',
        subTitle: 'nicholas.mcbride@abc.co',
        profilePhoto: null,
        id: 16048,
      },
    ],
  },
  {
    employee: {
      id: 16009,
      companyId: 1,
      displayName: 'Edward Fuller',
      designation: 'Medical illustrator',
      ownerType: null,
      employeeFunction: null,
      email: 'edward.fuller@abc.co',
      personalEmail: 'edward.fuller@abc.co',
      workEmail: 'edward.fuller@abc.co',
      preferredName: 'Edward',
    },
    id: 209,
    publisherSelectedEmployees: [
      {
        label: 'Kelly Campbell',
        subTitle: 'kelly.campbell@abc.co',
        profilePhoto: null,
        id: 16166,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jennifer Russo',
        subTitle: 'jennifer.russo@abc.co',
        profilePhoto: null,
        id: 16288,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Marissa Webster',
        subTitle: 'marissa.webster@abc.co',
        profilePhoto: null,
        id: 16137,
      },
    ],
  },
  {
    employee: {
      id: 16010,
      companyId: 2,
      displayName: 'Michele Williams',
      designation: 'Estate agent',
      ownerType: null,
      employeeFunction: null,
      email: 'michele.williams@abc.co',
      personalEmail: 'michele.williams@abc.co',
      workEmail: 'michele.williams@abc.co',
      preferredName: 'Michele',
    },
    id: 210,
    publisherSelectedEmployees: [
      {
        label: 'Ashley Wise',
        subTitle: 'ashley.wise@abc.co',
        profilePhoto: null,
        id: 16343,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mrs. Rachel Gibson',
        subTitle: 'mrs..rachel.gibson@abc.co',
        profilePhoto: null,
        id: 16055,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Alexandra Le',
        subTitle: 'alexandra.le@abc.co',
        profilePhoto: null,
        id: 16026,
      },
    ],
  },
  {
    employee: {
      id: 16011,
      companyId: 3,
      displayName: 'Victoria Wyatt',
      designation: 'Chiropractor',
      ownerType: null,
      employeeFunction: null,
      email: 'victoria.wyatt@abc.co',
      personalEmail: 'victoria.wyatt@abc.co',
      workEmail: 'victoria.wyatt@abc.co',
      preferredName: 'Victoria',
    },
    id: 211,
    publisherSelectedEmployees: [
      {
        label: 'Kaitlyn Harvey',
        subTitle: 'kaitlyn.harvey@abc.co',
        profilePhoto: null,
        id: 16253,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kelly Campbell',
        subTitle: 'kelly.campbell@abc.co',
        profilePhoto: null,
        id: 16166,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Corey Murphy',
        subTitle: 'corey.murphy@abc.co',
        profilePhoto: null,
        id: 16091,
      },
    ],
  },
  {
    employee: {
      id: 16012,
      companyId: 1,
      displayName: 'Jesse Flowers',
      designation: 'Designer, textile',
      ownerType: null,
      employeeFunction: null,
      email: 'jesse.flowers@abc.co',
      personalEmail: 'jesse.flowers@abc.co',
      workEmail: 'jesse.flowers@abc.co',
      preferredName: 'Jesse',
    },
    id: 212,
    publisherSelectedEmployees: [
      {
        label: 'David Martinez',
        subTitle: 'david.martinez@abc.co',
        profilePhoto: null,
        id: 16163,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Maria Jones',
        subTitle: 'maria.jones@abc.co',
        profilePhoto: null,
        id: 16334,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Chad Jones',
        subTitle: 'chad.jones@abc.co',
        profilePhoto: null,
        id: 16397,
      },
    ],
  },
  {
    employee: {
      id: 16013,
      companyId: 2,
      displayName: 'Daniel Adams',
      designation: 'Building surveyor',
      ownerType: null,
      employeeFunction: null,
      email: 'daniel.adams@abc.co',
      personalEmail: 'daniel.adams@abc.co',
      workEmail: 'daniel.adams@abc.co',
      preferredName: 'Daniel',
    },
    id: 213,
    publisherSelectedEmployees: [
      {
        label: 'Kimberly Smith',
        subTitle: 'kimberly.smith@abc.co',
        profilePhoto: null,
        id: 16052,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Monica Herrera',
        subTitle: 'monica.herrera@abc.co',
        profilePhoto: null,
        id: 16008,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Christine Wright',
        subTitle: 'christine.wright@abc.co',
        profilePhoto: null,
        id: 16082,
      },
    ],
  },
  {
    employee: {
      id: 16014,
      companyId: 3,
      displayName: 'Carolyn Daniel',
      designation: 'Development worker, community',
      ownerType: null,
      employeeFunction: null,
      email: 'carolyn.daniel@abc.co',
      personalEmail: 'carolyn.daniel@abc.co',
      workEmail: 'carolyn.daniel@abc.co',
      preferredName: 'Carolyn',
    },
    id: 214,
    publisherSelectedEmployees: [
      {
        label: 'Melissa Martinez',
        subTitle: 'melissa.martinez@abc.co',
        profilePhoto: null,
        id: 16169,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Susan Smith',
        subTitle: 'susan.smith@abc.co',
        profilePhoto: null,
        id: 16361,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Victor Vaughn',
        subTitle: 'victor.vaughn@abc.co',
        profilePhoto: null,
        id: 16234,
      },
    ],
  },
  {
    employee: {
      id: 16015,
      companyId: 1,
      displayName: 'Devin Schaefer',
      designation: 'Surveyor, hydrographic',
      ownerType: null,
      employeeFunction: null,
      email: 'devin.schaefer@abc.co',
      personalEmail: 'devin.schaefer@abc.co',
      workEmail: 'devin.schaefer@abc.co',
      preferredName: 'Devin',
    },
    id: 215,
    publisherSelectedEmployees: [
      {
        label: 'Victoria Wyatt',
        subTitle: 'victoria.wyatt@abc.co',
        profilePhoto: null,
        id: 16011,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Richard Baker',
        subTitle: 'richard.baker@abc.co',
        profilePhoto: null,
        id: 16221,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Devin Schaefer',
        subTitle: 'devin.schaefer@abc.co',
        profilePhoto: null,
        id: 16015,
      },
    ],
  },
  {
    employee: {
      id: 16016,
      companyId: 2,
      displayName: 'Frederick Tate',
      designation: 'Banker',
      ownerType: null,
      employeeFunction: null,
      email: 'frederick.tate@abc.co',
      personalEmail: 'frederick.tate@abc.co',
      workEmail: 'frederick.tate@abc.co',
      preferredName: 'Frederick',
    },
    id: 216,
    publisherSelectedEmployees: [
      {
        label: 'Elizabeth Ortiz',
        subTitle: 'elizabeth.ortiz@abc.co',
        profilePhoto: null,
        id: 16255,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kelly Bishop MD',
        subTitle: 'kelly.bishop.md@abc.co',
        profilePhoto: null,
        id: 16332,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Brent Rodgers',
        subTitle: 'brent.rodgers@abc.co',
        profilePhoto: null,
        id: 16286,
      },
    ],
  },
  {
    employee: {
      id: 16017,
      companyId: 3,
      displayName: 'Andrew Stewart',
      designation: 'Geologist, wellsite',
      ownerType: null,
      employeeFunction: null,
      email: 'andrew.stewart@abc.co',
      personalEmail: 'andrew.stewart@abc.co',
      workEmail: 'andrew.stewart@abc.co',
      preferredName: 'Andrew',
    },
    id: 217,
    publisherSelectedEmployees: [
      {
        label: 'Kelly Bishop MD',
        subTitle: 'kelly.bishop.md@abc.co',
        profilePhoto: null,
        id: 16332,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Bobby Franklin',
        subTitle: 'bobby.franklin@abc.co',
        profilePhoto: null,
        id: 16278,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jill Miller',
        subTitle: 'jill.miller@abc.co',
        profilePhoto: null,
        id: 16398,
      },
    ],
  },
  {
    employee: {
      id: 16018,
      companyId: 1,
      displayName: 'Thomas Bradley',
      designation: 'International aid/development worker',
      ownerType: null,
      employeeFunction: null,
      email: 'thomas.bradley@abc.co',
      personalEmail: 'thomas.bradley@abc.co',
      workEmail: 'thomas.bradley@abc.co',
      preferredName: 'Thomas',
    },
    id: 218,
    publisherSelectedEmployees: [
      {
        label: 'Justin Riley',
        subTitle: 'justin.riley@abc.co',
        profilePhoto: null,
        id: 16321,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Andrew Diaz',
        subTitle: 'andrew.diaz@abc.co',
        profilePhoto: null,
        id: 16081,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Dwayne Gilmore',
        subTitle: 'dwayne.gilmore@abc.co',
        profilePhoto: null,
        id: 16202,
      },
    ],
  },
  {
    employee: {
      id: 16019,
      companyId: 2,
      displayName: 'Jonathan Wilkerson',
      designation: 'Proofreader',
      ownerType: null,
      employeeFunction: null,
      email: 'jonathan.wilkerson@abc.co',
      personalEmail: 'jonathan.wilkerson@abc.co',
      workEmail: 'jonathan.wilkerson@abc.co',
      preferredName: 'Jonathan',
    },
    id: 219,
    publisherSelectedEmployees: [
      {
        label: 'Kathleen Aguilar',
        subTitle: 'kathleen.aguilar@abc.co',
        profilePhoto: null,
        id: 16230,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Danielle Odonnell',
        subTitle: 'danielle.odonnell@abc.co',
        profilePhoto: null,
        id: 16075,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kimberly Ball',
        subTitle: 'kimberly.ball@abc.co',
        profilePhoto: null,
        id: 16098,
      },
    ],
  },
  {
    employee: {
      id: 16020,
      companyId: 3,
      displayName: 'Charles Mcgee',
      designation: 'Solicitor',
      ownerType: null,
      employeeFunction: null,
      email: 'charles.mcgee@abc.co',
      personalEmail: 'charles.mcgee@abc.co',
      workEmail: 'charles.mcgee@abc.co',
      preferredName: 'Charles',
    },
    id: 220,
    publisherSelectedEmployees: [
      {
        label: 'Stephen Taylor',
        subTitle: 'stephen.taylor@abc.co',
        profilePhoto: null,
        id: 16257,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jason Daniels',
        subTitle: 'jason.daniels@abc.co',
        profilePhoto: null,
        id: 16123,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Samantha Morse',
        subTitle: 'samantha.morse@abc.co',
        profilePhoto: null,
        id: 16186,
      },
    ],
  },
  {
    employee: {
      id: 16021,
      companyId: 1,
      displayName: 'Kevin Hurst',
      designation: 'Oceanographer',
      ownerType: null,
      employeeFunction: null,
      email: 'kevin.hurst@abc.co',
      personalEmail: 'kevin.hurst@abc.co',
      workEmail: 'kevin.hurst@abc.co',
      preferredName: 'Kevin',
    },
    id: 221,
    publisherSelectedEmployees: [
      {
        label: 'Bobby Franklin',
        subTitle: 'bobby.franklin@abc.co',
        profilePhoto: null,
        id: 16278,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Ashley Singleton',
        subTitle: 'ashley.singleton@abc.co',
        profilePhoto: null,
        id: 16353,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Betty Alvarez',
        subTitle: 'betty.alvarez@abc.co',
        profilePhoto: null,
        id: 16036,
      },
    ],
  },
  {
    employee: {
      id: 16022,
      companyId: 2,
      displayName: 'Zachary Taylor',
      designation: 'Research officer, political party',
      ownerType: null,
      employeeFunction: null,
      email: 'zachary.taylor@abc.co',
      personalEmail: 'zachary.taylor@abc.co',
      workEmail: 'zachary.taylor@abc.co',
      preferredName: 'Zachary',
    },
    id: 222,
    publisherSelectedEmployees: [
      {
        label: 'Erica Miller',
        subTitle: 'erica.miller@abc.co',
        profilePhoto: null,
        id: 16384,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 16001,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sarah Morgan',
        subTitle: 'sarah.morgan@abc.co',
        profilePhoto: null,
        id: 16210,
      },
    ],
  },
  {
    employee: {
      id: 16023,
      companyId: 3,
      displayName: 'Anthony Rodriguez',
      designation: 'Designer, jewellery',
      ownerType: null,
      employeeFunction: null,
      email: 'anthony.rodriguez@abc.co',
      personalEmail: 'anthony.rodriguez@abc.co',
      workEmail: 'anthony.rodriguez@abc.co',
      preferredName: 'Anthony',
    },
    id: 223,
    publisherSelectedEmployees: [
      {
        label: 'Ronald Spencer',
        subTitle: 'ronald.spencer@abc.co',
        profilePhoto: null,
        id: 16267,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Andrew Diaz',
        subTitle: 'andrew.diaz@abc.co',
        profilePhoto: null,
        id: 16081,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Tiffany Barnes',
        subTitle: 'tiffany.barnes@abc.co',
        profilePhoto: null,
        id: 16127,
      },
    ],
  },
  {
    employee: {
      id: 16024,
      companyId: 1,
      displayName: 'Jennifer Brown',
      designation: 'Museum/gallery curator',
      ownerType: null,
      employeeFunction: null,
      email: 'jennifer.brown@abc.co',
      personalEmail: 'jennifer.brown@abc.co',
      workEmail: 'jennifer.brown@abc.co',
      preferredName: 'Jennifer',
    },
    id: 224,
    publisherSelectedEmployees: [
      {
        label: 'Patrick Rivera',
        subTitle: 'patrick.rivera@abc.co',
        profilePhoto: null,
        id: 16162,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Emily Douglas',
        subTitle: 'emily.douglas@abc.co',
        profilePhoto: null,
        id: 16337,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Amanda Diaz',
        subTitle: 'amanda.diaz@abc.co',
        profilePhoto: null,
        id: 16346,
      },
    ],
  },
  {
    employee: {
      id: 16025,
      companyId: 2,
      displayName: 'Julie King',
      designation: 'Surgeon',
      ownerType: null,
      employeeFunction: null,
      email: 'julie.king@abc.co',
      personalEmail: 'julie.king@abc.co',
      workEmail: 'julie.king@abc.co',
      preferredName: 'Julie',
    },
    id: 225,
    publisherSelectedEmployees: [
      {
        label: 'Danielle Odonnell',
        subTitle: 'danielle.odonnell@abc.co',
        profilePhoto: null,
        id: 16075,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Leonard Holland',
        subTitle: 'leonard.holland@abc.co',
        profilePhoto: null,
        id: 16254,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Carolyn Daniel',
        subTitle: 'carolyn.daniel@abc.co',
        profilePhoto: null,
        id: 16014,
      },
    ],
  },
  {
    employee: {
      id: 16026,
      companyId: 3,
      displayName: 'Alexandra Le',
      designation: 'Software engineer',
      ownerType: null,
      employeeFunction: null,
      email: 'alexandra.le@abc.co',
      personalEmail: 'alexandra.le@abc.co',
      workEmail: 'alexandra.le@abc.co',
      preferredName: 'Alexandra',
    },
    id: 226,
    publisherSelectedEmployees: [
      {
        label: 'Dr. Steven Martin',
        subTitle: 'dr..steven.martin@abc.co',
        profilePhoto: null,
        id: 16054,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Elizabeth Ortiz',
        subTitle: 'elizabeth.ortiz@abc.co',
        profilePhoto: null,
        id: 16255,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Nicholas Adams',
        subTitle: 'nicholas.adams@abc.co',
        profilePhoto: null,
        id: 16152,
      },
    ],
  },
  {
    employee: {
      id: 16027,
      companyId: 1,
      displayName: 'Patricia Peterson',
      designation: 'Hospital doctor',
      ownerType: null,
      employeeFunction: null,
      email: 'patricia.peterson@abc.co',
      personalEmail: 'patricia.peterson@abc.co',
      workEmail: 'patricia.peterson@abc.co',
      preferredName: 'Patricia',
    },
    id: 227,
    publisherSelectedEmployees: [
      {
        label: 'Mr. Jeremiah Reeves',
        subTitle: 'mr..jeremiah.reeves@abc.co',
        profilePhoto: null,
        id: 16120,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Lance Hoffman',
        subTitle: 'lance.hoffman@abc.co',
        profilePhoto: null,
        id: 16003,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sherry Shields',
        subTitle: 'sherry.shields@abc.co',
        profilePhoto: null,
        id: 16209,
      },
    ],
  },
  {
    employee: {
      id: 16028,
      companyId: 2,
      displayName: 'Jesse Mckay',
      designation: 'General practice doctor',
      ownerType: null,
      employeeFunction: null,
      email: 'jesse.mckay@abc.co',
      personalEmail: 'jesse.mckay@abc.co',
      workEmail: 'jesse.mckay@abc.co',
      preferredName: 'Jesse',
    },
    id: 228,
    publisherSelectedEmployees: [
      {
        label: 'Michelle Schmitt',
        subTitle: 'michelle.schmitt@abc.co',
        profilePhoto: null,
        id: 16289,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kimberly Ball',
        subTitle: 'kimberly.ball@abc.co',
        profilePhoto: null,
        id: 16098,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Aaron Gomez',
        subTitle: 'aaron.gomez@abc.co',
        profilePhoto: null,
        id: 16367,
      },
    ],
  },
  {
    employee: {
      id: 16029,
      companyId: 3,
      displayName: 'Pamela Romero',
      designation: 'Claims inspector/assessor',
      ownerType: null,
      employeeFunction: null,
      email: 'pamela.romero@abc.co',
      personalEmail: 'pamela.romero@abc.co',
      workEmail: 'pamela.romero@abc.co',
      preferredName: 'Pamela',
    },
    id: 229,
    publisherSelectedEmployees: [
      {
        label: 'David Walsh',
        subTitle: 'david.walsh@abc.co',
        profilePhoto: null,
        id: 16119,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'James Lewis',
        subTitle: 'james.lewis@abc.co',
        profilePhoto: null,
        id: 16133,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Brian Gregory',
        subTitle: 'brian.gregory@abc.co',
        profilePhoto: null,
        id: 16303,
      },
    ],
  },
  {
    employee: {
      id: 16030,
      companyId: 1,
      displayName: 'Elizabeth Fowler',
      designation: 'Transport planner',
      ownerType: null,
      employeeFunction: null,
      email: 'elizabeth.fowler@abc.co',
      personalEmail: 'elizabeth.fowler@abc.co',
      workEmail: 'elizabeth.fowler@abc.co',
      preferredName: 'Elizabeth',
    },
    id: 230,
    publisherSelectedEmployees: [
      {
        label: 'Kara Davis',
        subTitle: 'kara.davis@abc.co',
        profilePhoto: null,
        id: 16285,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jeff Hill',
        subTitle: 'jeff.hill@abc.co',
        profilePhoto: null,
        id: 16076,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Gavin Zhang',
        subTitle: 'gavin.zhang@abc.co',
        profilePhoto: null,
        id: 16266,
      },
    ],
  },
  {
    employee: {
      id: 16031,
      companyId: 2,
      displayName: 'James Martin',
      designation: 'Set designer',
      ownerType: null,
      employeeFunction: null,
      email: 'james.martin@abc.co',
      personalEmail: 'james.martin@abc.co',
      workEmail: 'james.martin@abc.co',
      preferredName: 'James',
    },
    id: 231,
    publisherSelectedEmployees: [
      {
        label: 'Stephanie Freeman',
        subTitle: 'stephanie.freeman@abc.co',
        profilePhoto: null,
        id: 16128,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Stephanie Simmons',
        subTitle: 'stephanie.simmons@abc.co',
        profilePhoto: null,
        id: 16117,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Tyler Garcia',
        subTitle: 'tyler.garcia@abc.co',
        profilePhoto: null,
        id: 16178,
      },
    ],
  },
  {
    employee: {
      id: 16032,
      companyId: 3,
      displayName: 'Linda Burns',
      designation: 'Clinical research associate',
      ownerType: null,
      employeeFunction: null,
      email: 'linda.burns@abc.co',
      personalEmail: 'linda.burns@abc.co',
      workEmail: 'linda.burns@abc.co',
      preferredName: 'Linda',
    },
    id: 232,
    publisherSelectedEmployees: [
      {
        label: 'Brian Romero',
        subTitle: 'brian.romero@abc.co',
        profilePhoto: null,
        id: 16290,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Ricardo Young',
        subTitle: 'ricardo.young@abc.co',
        profilePhoto: null,
        id: 16363,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'John Mcintyre',
        subTitle: 'john.mcintyre@abc.co',
        profilePhoto: null,
        id: 16216,
      },
    ],
  },
  {
    employee: {
      id: 16033,
      companyId: 1,
      displayName: 'Sherry Decker',
      designation: 'Information systems manager',
      ownerType: null,
      employeeFunction: null,
      email: 'sherry.decker@abc.co',
      personalEmail: 'sherry.decker@abc.co',
      workEmail: 'sherry.decker@abc.co',
      preferredName: 'Sherry',
    },
    id: 233,
    publisherSelectedEmployees: [
      {
        label: 'Megan Young',
        subTitle: 'megan.young@abc.co',
        profilePhoto: null,
        id: 16061,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'James Martin',
        subTitle: 'james.martin@abc.co',
        profilePhoto: null,
        id: 16031,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Matthew Hoover',
        subTitle: 'matthew.hoover@abc.co',
        profilePhoto: null,
        id: 16217,
      },
    ],
  },
  {
    employee: {
      id: 16034,
      companyId: 2,
      displayName: 'David Bradley',
      designation: 'Careers information officer',
      ownerType: null,
      employeeFunction: null,
      email: 'david.bradley@abc.co',
      personalEmail: 'david.bradley@abc.co',
      workEmail: 'david.bradley@abc.co',
      preferredName: 'David',
    },
    id: 234,
    publisherSelectedEmployees: [
      {
        label: 'Julie King',
        subTitle: 'julie.king@abc.co',
        profilePhoto: null,
        id: 16025,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Robert Contreras',
        subTitle: 'robert.contreras@abc.co',
        profilePhoto: null,
        id: 16115,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Robert Potter',
        subTitle: 'robert.potter@abc.co',
        profilePhoto: null,
        id: 16108,
      },
    ],
  },
  {
    employee: {
      id: 16035,
      companyId: 3,
      displayName: 'John Jones',
      designation: 'Site engineer',
      ownerType: null,
      employeeFunction: null,
      email: 'john.jones@abc.co',
      personalEmail: 'john.jones@abc.co',
      workEmail: 'john.jones@abc.co',
      preferredName: 'John',
    },
    id: 235,
    publisherSelectedEmployees: [
      {
        label: 'Desiree Smith',
        subTitle: 'desiree.smith@abc.co',
        profilePhoto: null,
        id: 16157,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Tiffany Vance',
        subTitle: 'tiffany.vance@abc.co',
        profilePhoto: null,
        id: 16116,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Chad Jones',
        subTitle: 'chad.jones@abc.co',
        profilePhoto: null,
        id: 16397,
      },
    ],
  },
  {
    employee: {
      id: 16036,
      companyId: 1,
      displayName: 'Betty Alvarez',
      designation: 'Stage manager',
      ownerType: null,
      employeeFunction: null,
      email: 'betty.alvarez@abc.co',
      personalEmail: 'betty.alvarez@abc.co',
      workEmail: 'betty.alvarez@abc.co',
      preferredName: 'Betty',
    },
    id: 236,
    publisherSelectedEmployees: [
      {
        label: 'Kathryn Farrell',
        subTitle: 'kathryn.farrell@abc.co',
        profilePhoto: null,
        id: 16059,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Miss Patricia Gibson',
        subTitle: 'miss.patricia.gibson@abc.co',
        profilePhoto: null,
        id: 16110,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sydney White',
        subTitle: 'sydney.white@abc.co',
        profilePhoto: null,
        id: 16193,
      },
    ],
  },
  {
    employee: {
      id: 16037,
      companyId: 2,
      displayName: 'Joseph Obrien',
      designation: 'Engineer, mining',
      ownerType: null,
      employeeFunction: null,
      email: 'joseph.obrien@abc.co',
      personalEmail: 'joseph.obrien@abc.co',
      workEmail: 'joseph.obrien@abc.co',
      preferredName: 'Joseph',
    },
    id: 237,
    publisherSelectedEmployees: [
      {
        label: 'Maria Henry',
        subTitle: 'maria.henry@abc.co',
        profilePhoto: null,
        id: 16159,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Denise Davenport',
        subTitle: 'denise.davenport@abc.co',
        profilePhoto: null,
        id: 16207,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Timothy Kane',
        subTitle: 'timothy.kane@abc.co',
        profilePhoto: null,
        id: 16214,
      },
    ],
  },
  {
    employee: {
      id: 16038,
      companyId: 3,
      displayName: 'Nicole Vaughn',
      designation: 'Insurance underwriter',
      ownerType: null,
      employeeFunction: null,
      email: 'nicole.vaughn@abc.co',
      personalEmail: 'nicole.vaughn@abc.co',
      workEmail: 'nicole.vaughn@abc.co',
      preferredName: 'Nicole',
    },
    id: 238,
    publisherSelectedEmployees: [
      {
        label: 'Haley Arnold',
        subTitle: 'haley.arnold@abc.co',
        profilePhoto: null,
        id: 16213,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Robert Contreras',
        subTitle: 'robert.contreras@abc.co',
        profilePhoto: null,
        id: 16115,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Bryan Charles',
        subTitle: 'bryan.charles@abc.co',
        profilePhoto: null,
        id: 16264,
      },
    ],
  },
  {
    employee: {
      id: 16039,
      companyId: 1,
      displayName: 'Michael Brooks',
      designation: 'Scientist, forensic',
      ownerType: null,
      employeeFunction: null,
      email: 'michael.brooks@abc.co',
      personalEmail: 'michael.brooks@abc.co',
      workEmail: 'michael.brooks@abc.co',
      preferredName: 'Michael',
    },
    id: 239,
    publisherSelectedEmployees: [
      {
        label: 'Samuel White',
        subTitle: 'samuel.white@abc.co',
        profilePhoto: null,
        id: 16155,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jerry Ramirez',
        subTitle: 'jerry.ramirez@abc.co',
        profilePhoto: null,
        id: 16004,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Joshua Holland',
        subTitle: 'joshua.holland@abc.co',
        profilePhoto: null,
        id: 16184,
      },
    ],
  },
  {
    employee: {
      id: 16040,
      companyId: 2,
      displayName: 'David Brown',
      designation: 'Advertising art director',
      ownerType: null,
      employeeFunction: null,
      email: 'david.brown@abc.co',
      personalEmail: 'david.brown@abc.co',
      workEmail: 'david.brown@abc.co',
      preferredName: 'David',
    },
    id: 240,
    publisherSelectedEmployees: [
      {
        label: 'Tammy Young',
        subTitle: 'tammy.young@abc.co',
        profilePhoto: null,
        id: 16084,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Nicholas Sheppard',
        subTitle: 'nicholas.sheppard@abc.co',
        profilePhoto: null,
        id: 16150,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Stephanie Freeman',
        subTitle: 'stephanie.freeman@abc.co',
        profilePhoto: null,
        id: 16128,
      },
    ],
  },
  {
    employee: {
      id: 16041,
      companyId: 3,
      displayName: 'Crystal Robinson',
      designation: 'Building services engineer',
      ownerType: null,
      employeeFunction: null,
      email: 'crystal.robinson@abc.co',
      personalEmail: 'crystal.robinson@abc.co',
      workEmail: 'crystal.robinson@abc.co',
      preferredName: 'Crystal',
    },
    id: 241,
    publisherSelectedEmployees: [
      {
        label: 'Sabrina Briggs',
        subTitle: 'sabrina.briggs@abc.co',
        profilePhoto: null,
        id: 16318,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michele Gibson',
        subTitle: 'michele.gibson@abc.co',
        profilePhoto: null,
        id: 16182,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Stephanie Gilbert',
        subTitle: 'stephanie.gilbert@abc.co',
        profilePhoto: null,
        id: 16103,
      },
    ],
  },
  {
    employee: {
      id: 16042,
      companyId: 1,
      displayName: 'Amy Jones',
      designation: 'Ambulance person',
      ownerType: null,
      employeeFunction: null,
      email: 'amy.jones@abc.co',
      personalEmail: 'amy.jones@abc.co',
      workEmail: 'amy.jones@abc.co',
      preferredName: 'Amy',
    },
    id: 242,
    publisherSelectedEmployees: [
      {
        label: 'Cody Cox',
        subTitle: 'cody.cox@abc.co',
        profilePhoto: null,
        id: 16200,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Tammy Young',
        subTitle: 'tammy.young@abc.co',
        profilePhoto: null,
        id: 16084,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Matthew Miller',
        subTitle: 'matthew.miller@abc.co',
        profilePhoto: null,
        id: 16368,
      },
    ],
  },
  {
    employee: {
      id: 16043,
      companyId: 2,
      displayName: 'Andrea Young',
      designation: 'Radiographer, diagnostic',
      ownerType: null,
      employeeFunction: null,
      email: 'andrea.young@abc.co',
      personalEmail: 'andrea.young@abc.co',
      workEmail: 'andrea.young@abc.co',
      preferredName: 'Andrea',
    },
    id: 243,
    publisherSelectedEmployees: [
      {
        label: 'Mrs. Diane Reyes',
        subTitle: 'mrs..diane.reyes@abc.co',
        profilePhoto: null,
        id: 16350,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Chad Jones',
        subTitle: 'chad.jones@abc.co',
        profilePhoto: null,
        id: 16397,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Elizabeth Sutton',
        subTitle: 'elizabeth.sutton@abc.co',
        profilePhoto: null,
        id: 16145,
      },
    ],
  },
  {
    employee: {
      id: 16044,
      companyId: 3,
      displayName: 'Carlos Walls',
      designation: 'Teacher, English as a foreign language',
      ownerType: null,
      employeeFunction: null,
      email: 'carlos.walls@abc.co',
      personalEmail: 'carlos.walls@abc.co',
      workEmail: 'carlos.walls@abc.co',
      preferredName: 'Carlos',
    },
    id: 244,
    publisherSelectedEmployees: [
      {
        label: 'Ross Price',
        subTitle: 'ross.price@abc.co',
        profilePhoto: null,
        id: 16124,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Andrew Diaz',
        subTitle: 'andrew.diaz@abc.co',
        profilePhoto: null,
        id: 16081,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Ross Price',
        subTitle: 'ross.price@abc.co',
        profilePhoto: null,
        id: 16124,
      },
    ],
  },
  {
    employee: {
      id: 16045,
      companyId: 1,
      displayName: 'Dana Kennedy',
      designation: 'Optometrist',
      ownerType: null,
      employeeFunction: null,
      email: 'dana.kennedy@abc.co',
      personalEmail: 'dana.kennedy@abc.co',
      workEmail: 'dana.kennedy@abc.co',
      preferredName: 'Dana',
    },
    id: 245,
    publisherSelectedEmployees: [
      {
        label: 'Patrick Rivera',
        subTitle: 'patrick.rivera@abc.co',
        profilePhoto: null,
        id: 16162,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christopher Gonzalez',
        subTitle: 'christopher.gonzalez@abc.co',
        profilePhoto: null,
        id: 16351,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Christopher Hensley',
        subTitle: 'christopher.hensley@abc.co',
        profilePhoto: null,
        id: 16118,
      },
    ],
  },
  {
    employee: {
      id: 16046,
      companyId: 2,
      displayName: 'Brent Jordan',
      designation: 'Pharmacologist',
      ownerType: null,
      employeeFunction: null,
      email: 'brent.jordan@abc.co',
      personalEmail: 'brent.jordan@abc.co',
      workEmail: 'brent.jordan@abc.co',
      preferredName: 'Brent',
    },
    id: 246,
    publisherSelectedEmployees: [
      {
        label: 'Sandra Gilbert',
        subTitle: 'sandra.gilbert@abc.co',
        profilePhoto: null,
        id: 16260,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Seth Reese',
        subTitle: 'seth.reese@abc.co',
        profilePhoto: null,
        id: 16315,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Elizabeth Sutton',
        subTitle: 'elizabeth.sutton@abc.co',
        profilePhoto: null,
        id: 16145,
      },
    ],
  },
  {
    employee: {
      id: 16047,
      companyId: 3,
      displayName: 'Scott Brown',
      designation: 'Chief Technology Officer',
      ownerType: null,
      employeeFunction: null,
      email: 'scott.brown@abc.co',
      personalEmail: 'scott.brown@abc.co',
      workEmail: 'scott.brown@abc.co',
      preferredName: 'Scott',
    },
    id: 247,
    publisherSelectedEmployees: [
      {
        label: 'Leslie Bell',
        subTitle: 'leslie.bell@abc.co',
        profilePhoto: null,
        id: 16324,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Patrick Rivera',
        subTitle: 'patrick.rivera@abc.co',
        profilePhoto: null,
        id: 16162,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'James Hernandez',
        subTitle: 'james.hernandez@abc.co',
        profilePhoto: null,
        id: 16122,
      },
    ],
  },
  {
    employee: {
      id: 16048,
      companyId: 1,
      displayName: 'Nicholas Mcbride',
      designation: 'Clinical embryologist',
      ownerType: null,
      employeeFunction: null,
      email: 'nicholas.mcbride@abc.co',
      personalEmail: 'nicholas.mcbride@abc.co',
      workEmail: 'nicholas.mcbride@abc.co',
      preferredName: 'Nicholas',
    },
    id: 248,
    publisherSelectedEmployees: [
      {
        label: 'Katie Anderson',
        subTitle: 'katie.anderson@abc.co',
        profilePhoto: null,
        id: 16068,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Roy Torres',
        subTitle: 'roy.torres@abc.co',
        profilePhoto: null,
        id: 16104,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Monica Logan',
        subTitle: 'monica.logan@abc.co',
        profilePhoto: null,
        id: 16056,
      },
    ],
  },
  {
    employee: {
      id: 16049,
      companyId: 2,
      displayName: 'Connor West',
      designation: 'Pharmacist, hospital',
      ownerType: null,
      employeeFunction: null,
      email: 'connor.west@abc.co',
      personalEmail: 'connor.west@abc.co',
      workEmail: 'connor.west@abc.co',
      preferredName: 'Connor',
    },
    id: 249,
    publisherSelectedEmployees: [
      {
        label: 'Maria Jones',
        subTitle: 'maria.jones@abc.co',
        profilePhoto: null,
        id: 16334,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Ms. Rebecca Rodriguez',
        subTitle: 'ms..rebecca.rodriguez@abc.co',
        profilePhoto: null,
        id: 16270,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Robert Potter',
        subTitle: 'robert.potter@abc.co',
        profilePhoto: null,
        id: 16108,
      },
    ],
  },
  {
    employee: {
      id: 16050,
      companyId: 3,
      displayName: 'Joel Baxter',
      designation: 'Call centre manager',
      ownerType: null,
      employeeFunction: null,
      email: 'joel.baxter@abc.co',
      personalEmail: 'joel.baxter@abc.co',
      workEmail: 'joel.baxter@abc.co',
      preferredName: 'Joel',
    },
    id: 250,
    publisherSelectedEmployees: [
      {
        label: 'Susan Rivas',
        subTitle: 'susan.rivas@abc.co',
        profilePhoto: null,
        id: 16246,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jesse Mckay',
        subTitle: 'jesse.mckay@abc.co',
        profilePhoto: null,
        id: 16028,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Lance Simmons',
        subTitle: 'lance.simmons@abc.co',
        profilePhoto: null,
        id: 16385,
      },
    ],
  },
  {
    employee: {
      id: 16051,
      companyId: 1,
      displayName: 'Scott Pierce',
      designation: 'Arts administrator',
      ownerType: null,
      employeeFunction: null,
      email: 'scott.pierce@abc.co',
      personalEmail: 'scott.pierce@abc.co',
      workEmail: 'scott.pierce@abc.co',
      preferredName: 'Scott',
    },
    id: 251,
    publisherSelectedEmployees: [
      {
        label: 'Seth Reese',
        subTitle: 'seth.reese@abc.co',
        profilePhoto: null,
        id: 16315,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Cody Cox',
        subTitle: 'cody.cox@abc.co',
        profilePhoto: null,
        id: 16200,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Mrs. Diane Reyes',
        subTitle: 'mrs..diane.reyes@abc.co',
        profilePhoto: null,
        id: 16350,
      },
    ],
  },
  {
    employee: {
      id: 16052,
      companyId: 2,
      displayName: 'Kimberly Smith',
      designation: 'Chief Financial Officer',
      ownerType: null,
      employeeFunction: null,
      email: 'kimberly.smith@abc.co',
      personalEmail: 'kimberly.smith@abc.co',
      workEmail: 'kimberly.smith@abc.co',
      preferredName: 'Kimberly',
    },
    id: 252,
    publisherSelectedEmployees: [
      {
        label: 'Tammy Young',
        subTitle: 'tammy.young@abc.co',
        profilePhoto: null,
        id: 16084,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mrs. Catherine Taylor',
        subTitle: 'mrs..catherine.taylor@abc.co',
        profilePhoto: null,
        id: 16375,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Adam Mitchell',
        subTitle: 'adam.mitchell@abc.co',
        profilePhoto: null,
        id: 16170,
      },
    ],
  },
  {
    employee: {
      id: 16053,
      companyId: 3,
      displayName: 'Sarah Martin',
      designation: 'Radiographer, diagnostic',
      ownerType: null,
      employeeFunction: null,
      email: 'sarah.martin@abc.co',
      personalEmail: 'sarah.martin@abc.co',
      workEmail: 'sarah.martin@abc.co',
      preferredName: 'Sarah',
    },
    id: 253,
    publisherSelectedEmployees: [
      {
        label: 'Mason Johnson',
        subTitle: 'mason.johnson@abc.co',
        profilePhoto: null,
        id: 16276,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sabrina Briggs',
        subTitle: 'sabrina.briggs@abc.co',
        profilePhoto: null,
        id: 16318,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Brent Rodgers',
        subTitle: 'brent.rodgers@abc.co',
        profilePhoto: null,
        id: 16286,
      },
    ],
  },
  {
    employee: {
      id: 16054,
      companyId: 1,
      displayName: 'Dr. Steven Martin',
      designation: 'Accountant, chartered',
      ownerType: null,
      employeeFunction: null,
      email: 'dr..steven.martin@abc.co',
      personalEmail: 'dr..steven.martin@abc.co',
      workEmail: 'dr..steven.martin@abc.co',
      preferredName: 'Dr.',
    },
    id: 254,
    publisherSelectedEmployees: [
      {
        label: 'Brittney Campbell',
        subTitle: 'brittney.campbell@abc.co',
        profilePhoto: null,
        id: 16073,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Rita Keith',
        subTitle: 'rita.keith@abc.co',
        profilePhoto: null,
        id: 16085,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sarah Martin',
        subTitle: 'sarah.martin@abc.co',
        profilePhoto: null,
        id: 16053,
      },
    ],
  },
  {
    employee: {
      id: 16055,
      companyId: 2,
      displayName: 'Mrs. Rachel Gibson',
      designation: 'Pharmacologist',
      ownerType: null,
      employeeFunction: null,
      email: 'mrs..rachel.gibson@abc.co',
      personalEmail: 'mrs..rachel.gibson@abc.co',
      workEmail: 'mrs..rachel.gibson@abc.co',
      preferredName: 'Mrs.',
    },
    id: 255,
    publisherSelectedEmployees: [
      {
        label: 'Stephanie Gilbert',
        subTitle: 'stephanie.gilbert@abc.co',
        profilePhoto: null,
        id: 16103,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sherry Decker',
        subTitle: 'sherry.decker@abc.co',
        profilePhoto: null,
        id: 16033,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Mrs. Catherine Taylor',
        subTitle: 'mrs..catherine.taylor@abc.co',
        profilePhoto: null,
        id: 16375,
      },
    ],
  },
  {
    employee: {
      id: 16056,
      companyId: 3,
      displayName: 'Monica Logan',
      designation: 'Radiographer, therapeutic',
      ownerType: null,
      employeeFunction: null,
      email: 'monica.logan@abc.co',
      personalEmail: 'monica.logan@abc.co',
      workEmail: 'monica.logan@abc.co',
      preferredName: 'Monica',
    },
    id: 256,
    publisherSelectedEmployees: [
      {
        label: 'Cheryl Ortega',
        subTitle: 'cheryl.ortega@abc.co',
        profilePhoto: null,
        id: 16102,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Corey Murphy',
        subTitle: 'corey.murphy@abc.co',
        profilePhoto: null,
        id: 16091,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Mary Martinez',
        subTitle: 'mary.martinez@abc.co',
        profilePhoto: null,
        id: 16100,
      },
    ],
  },
  {
    employee: {
      id: 16057,
      companyId: 1,
      displayName: 'Edward Novak',
      designation: 'TEFL teacher',
      ownerType: null,
      employeeFunction: null,
      email: 'edward.novak@abc.co',
      personalEmail: 'edward.novak@abc.co',
      workEmail: 'edward.novak@abc.co',
      preferredName: 'Edward',
    },
    id: 257,
    publisherSelectedEmployees: [
      {
        label: 'Bobby Franklin',
        subTitle: 'bobby.franklin@abc.co',
        profilePhoto: null,
        id: 16278,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Miss Patricia Gibson',
        subTitle: 'miss.patricia.gibson@abc.co',
        profilePhoto: null,
        id: 16110,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Travis Horton',
        subTitle: 'travis.horton@abc.co',
        profilePhoto: null,
        id: 16258,
      },
    ],
  },
  {
    employee: {
      id: 16058,
      companyId: 2,
      displayName: 'Amy Edwards',
      designation: 'Arts administrator',
      ownerType: null,
      employeeFunction: null,
      email: 'amy.edwards@abc.co',
      personalEmail: 'amy.edwards@abc.co',
      workEmail: 'amy.edwards@abc.co',
      preferredName: 'Amy',
    },
    id: 258,
    publisherSelectedEmployees: [
      {
        label: 'Christina Walters',
        subTitle: 'christina.walters@abc.co',
        profilePhoto: null,
        id: 16074,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Allen Rogers',
        subTitle: 'allen.rogers@abc.co',
        profilePhoto: null,
        id: 16129,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sophia Moore',
        subTitle: 'sophia.moore@abc.co',
        profilePhoto: null,
        id: 16300,
      },
    ],
  },
  {
    employee: {
      id: 16059,
      companyId: 3,
      displayName: 'Kathryn Farrell',
      designation: 'Designer, industrial/product',
      ownerType: null,
      employeeFunction: null,
      email: 'kathryn.farrell@abc.co',
      personalEmail: 'kathryn.farrell@abc.co',
      workEmail: 'kathryn.farrell@abc.co',
      preferredName: 'Kathryn',
    },
    id: 259,
    publisherSelectedEmployees: [
      {
        label: 'Stephanie Hughes',
        subTitle: 'stephanie.hughes@abc.co',
        profilePhoto: null,
        id: 16381,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Ashley Gordon',
        subTitle: 'ashley.gordon@abc.co',
        profilePhoto: null,
        id: 16274,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kathleen Aguilar',
        subTitle: 'kathleen.aguilar@abc.co',
        profilePhoto: null,
        id: 16230,
      },
    ],
  },
  {
    employee: {
      id: 16060,
      companyId: 1,
      displayName: 'Jordan York',
      designation: 'Broadcast presenter',
      ownerType: null,
      employeeFunction: null,
      email: 'jordan.york@abc.co',
      personalEmail: 'jordan.york@abc.co',
      workEmail: 'jordan.york@abc.co',
      preferredName: 'Jordan',
    },
    id: 260,
    publisherSelectedEmployees: [
      {
        label: 'Nathan Freeman',
        subTitle: 'nathan.freeman@abc.co',
        profilePhoto: null,
        id: 16158,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Lisa Byrd',
        subTitle: 'lisa.byrd@abc.co',
        profilePhoto: null,
        id: 16241,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jill Miller',
        subTitle: 'jill.miller@abc.co',
        profilePhoto: null,
        id: 16398,
      },
    ],
  },
  {
    employee: {
      id: 16061,
      companyId: 2,
      displayName: 'Megan Young',
      designation: 'Communications engineer',
      ownerType: null,
      employeeFunction: null,
      email: 'megan.young@abc.co',
      personalEmail: 'megan.young@abc.co',
      workEmail: 'megan.young@abc.co',
      preferredName: 'Megan',
    },
    id: 261,
    publisherSelectedEmployees: [
      {
        label: 'Alicia Gilmore',
        subTitle: 'alicia.gilmore@abc.co',
        profilePhoto: null,
        id: 16125,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Julie Johnson',
        subTitle: 'julie.johnson@abc.co',
        profilePhoto: null,
        id: 16181,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Robert Savage',
        subTitle: 'robert.savage@abc.co',
        profilePhoto: null,
        id: 16090,
      },
    ],
  },
  {
    employee: {
      id: 16062,
      companyId: 3,
      displayName: 'Laura Riley',
      designation: 'Archaeologist',
      ownerType: null,
      employeeFunction: null,
      email: 'laura.riley@abc.co',
      personalEmail: 'laura.riley@abc.co',
      workEmail: 'laura.riley@abc.co',
      preferredName: 'Laura',
    },
    id: 262,
    publisherSelectedEmployees: [
      {
        label: 'Bob Pitts',
        subTitle: 'bob.pitts@abc.co',
        profilePhoto: null,
        id: 16229,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brian Barton',
        subTitle: 'brian.barton@abc.co',
        profilePhoto: null,
        id: 16198,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Ashley Singleton',
        subTitle: 'ashley.singleton@abc.co',
        profilePhoto: null,
        id: 16353,
      },
    ],
  },
  {
    employee: {
      id: 16063,
      companyId: 1,
      displayName: 'Jennifer Silva',
      designation: 'Scientist, research (medical)',
      ownerType: null,
      employeeFunction: null,
      email: 'jennifer.silva@abc.co',
      personalEmail: 'jennifer.silva@abc.co',
      workEmail: 'jennifer.silva@abc.co',
      preferredName: 'Jennifer',
    },
    id: 263,
    publisherSelectedEmployees: [
      {
        label: 'Michele Gibson',
        subTitle: 'michele.gibson@abc.co',
        profilePhoto: null,
        id: 16182,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Megan Young',
        subTitle: 'megan.young@abc.co',
        profilePhoto: null,
        id: 16061,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Julie Johnson',
        subTitle: 'julie.johnson@abc.co',
        profilePhoto: null,
        id: 16181,
      },
    ],
  },
  {
    employee: {
      id: 16064,
      companyId: 2,
      displayName: 'Dean Santiago',
      designation: 'Interior and spatial designer',
      ownerType: null,
      employeeFunction: null,
      email: 'dean.santiago@abc.co',
      personalEmail: 'dean.santiago@abc.co',
      workEmail: 'dean.santiago@abc.co',
      preferredName: 'Dean',
    },
    id: 264,
    publisherSelectedEmployees: [
      {
        label: 'Miss Patricia Gibson',
        subTitle: 'miss.patricia.gibson@abc.co',
        profilePhoto: null,
        id: 16110,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Russell Porter',
        subTitle: 'russell.porter@abc.co',
        profilePhoto: null,
        id: 16365,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Carlos Walls',
        subTitle: 'carlos.walls@abc.co',
        profilePhoto: null,
        id: 16044,
      },
    ],
  },
  {
    employee: {
      id: 16065,
      companyId: 3,
      displayName: 'James Powers',
      designation: 'Hydrologist',
      ownerType: null,
      employeeFunction: null,
      email: 'james.powers@abc.co',
      personalEmail: 'james.powers@abc.co',
      workEmail: 'james.powers@abc.co',
      preferredName: 'James',
    },
    id: 265,
    publisherSelectedEmployees: [
      {
        label: 'Jeffrey Potts',
        subTitle: 'jeffrey.potts@abc.co',
        profilePhoto: null,
        id: 16355,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mr. Andrew Foster',
        subTitle: 'mr..andrew.foster@abc.co',
        profilePhoto: null,
        id: 16304,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Donna Wilson',
        subTitle: 'donna.wilson@abc.co',
        profilePhoto: null,
        id: 16306,
      },
    ],
  },
  {
    employee: {
      id: 16066,
      companyId: 1,
      displayName: 'Timothy Walls',
      designation: 'Acupuncturist',
      ownerType: null,
      employeeFunction: null,
      email: 'timothy.walls@abc.co',
      personalEmail: 'timothy.walls@abc.co',
      workEmail: 'timothy.walls@abc.co',
      preferredName: 'Timothy',
    },
    id: 266,
    publisherSelectedEmployees: [
      {
        label: 'Bradley Smith',
        subTitle: 'bradley.smith@abc.co',
        profilePhoto: null,
        id: 16135,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Erik Scott',
        subTitle: 'erik.scott@abc.co',
        profilePhoto: null,
        id: 16284,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kathryn Rosario',
        subTitle: 'kathryn.rosario@abc.co',
        profilePhoto: null,
        id: 16329,
      },
    ],
  },
  {
    employee: {
      id: 16067,
      companyId: 2,
      displayName: 'Zachary Ferrell',
      designation: 'Buyer, retail',
      ownerType: null,
      employeeFunction: null,
      email: 'zachary.ferrell@abc.co',
      personalEmail: 'zachary.ferrell@abc.co',
      workEmail: 'zachary.ferrell@abc.co',
      preferredName: 'Zachary',
    },
    id: 267,
    publisherSelectedEmployees: [
      {
        label: 'Jonathan Wilkerson',
        subTitle: 'jonathan.wilkerson@abc.co',
        profilePhoto: null,
        id: 16019,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christopher Gonzalez',
        subTitle: 'christopher.gonzalez@abc.co',
        profilePhoto: null,
        id: 16351,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Rita Keith',
        subTitle: 'rita.keith@abc.co',
        profilePhoto: null,
        id: 16085,
      },
    ],
  },
  {
    employee: {
      id: 16068,
      companyId: 3,
      displayName: 'Katie Anderson',
      designation: 'Magazine journalist',
      ownerType: null,
      employeeFunction: null,
      email: 'katie.anderson@abc.co',
      personalEmail: 'katie.anderson@abc.co',
      workEmail: 'katie.anderson@abc.co',
      preferredName: 'Katie',
    },
    id: 268,
    publisherSelectedEmployees: [
      {
        label: 'Casey James',
        subTitle: 'casey.james@abc.co',
        profilePhoto: null,
        id: 16307,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mrs. Rachel Gibson',
        subTitle: 'mrs..rachel.gibson@abc.co',
        profilePhoto: null,
        id: 16055,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jennifer Brown',
        subTitle: 'jennifer.brown@abc.co',
        profilePhoto: null,
        id: 16024,
      },
    ],
  },
  {
    employee: {
      id: 16069,
      companyId: 1,
      displayName: 'Sherry Wood',
      designation: 'Designer, industrial/product',
      ownerType: null,
      employeeFunction: null,
      email: 'sherry.wood@abc.co',
      personalEmail: 'sherry.wood@abc.co',
      workEmail: 'sherry.wood@abc.co',
      preferredName: 'Sherry',
    },
    id: 269,
    publisherSelectedEmployees: [
      {
        label: 'Ariana Jennings',
        subTitle: 'ariana.jennings@abc.co',
        profilePhoto: null,
        id: 16262,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Barry Ramos',
        subTitle: 'barry.ramos@abc.co',
        profilePhoto: null,
        id: 16323,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Cindy Hayes',
        subTitle: 'cindy.hayes@abc.co',
        profilePhoto: null,
        id: 16282,
      },
    ],
  },
  {
    employee: {
      id: 16070,
      companyId: 2,
      displayName: 'Joshua Turner',
      designation: 'Seismic interpreter',
      ownerType: null,
      employeeFunction: null,
      email: 'joshua.turner@abc.co',
      personalEmail: 'joshua.turner@abc.co',
      workEmail: 'joshua.turner@abc.co',
      preferredName: 'Joshua',
    },
    id: 270,
    publisherSelectedEmployees: [
      {
        label: 'Dwayne Gilmore',
        subTitle: 'dwayne.gilmore@abc.co',
        profilePhoto: null,
        id: 16202,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sarah Rivera',
        subTitle: 'sarah.rivera@abc.co',
        profilePhoto: null,
        id: 16093,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Susan Wilson',
        subTitle: 'susan.wilson@abc.co',
        profilePhoto: null,
        id: 16395,
      },
    ],
  },
  {
    employee: {
      id: 16071,
      companyId: 3,
      displayName: 'Robert Evans',
      designation: 'Civil Service administrator',
      ownerType: null,
      employeeFunction: null,
      email: 'robert.evans@abc.co',
      personalEmail: 'robert.evans@abc.co',
      workEmail: 'robert.evans@abc.co',
      preferredName: 'Robert',
    },
    id: 271,
    publisherSelectedEmployees: [
      {
        label: 'Jeffrey Potts',
        subTitle: 'jeffrey.potts@abc.co',
        profilePhoto: null,
        id: 16355,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Raymond Shelton',
        subTitle: 'raymond.shelton@abc.co',
        profilePhoto: null,
        id: 16333,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Ariana Jennings',
        subTitle: 'ariana.jennings@abc.co',
        profilePhoto: null,
        id: 16262,
      },
    ],
  },
  {
    employee: {
      id: 16072,
      companyId: 1,
      displayName: 'Brandy Wilson',
      designation: 'Clinical biochemist',
      ownerType: null,
      employeeFunction: null,
      email: 'brandy.wilson@abc.co',
      personalEmail: 'brandy.wilson@abc.co',
      workEmail: 'brandy.wilson@abc.co',
      preferredName: 'Brandy',
    },
    id: 272,
    publisherSelectedEmployees: [
      {
        label: 'Jessica Fox',
        subTitle: 'jessica.fox@abc.co',
        profilePhoto: null,
        id: 16219,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Willie Durham',
        subTitle: 'willie.durham@abc.co',
        profilePhoto: null,
        id: 16205,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Janice Carpenter',
        subTitle: 'janice.carpenter@abc.co',
        profilePhoto: null,
        id: 16327,
      },
    ],
  },
  {
    employee: {
      id: 16073,
      companyId: 2,
      displayName: 'Brittney Campbell',
      designation: 'Engineer, materials',
      ownerType: null,
      employeeFunction: null,
      email: 'brittney.campbell@abc.co',
      personalEmail: 'brittney.campbell@abc.co',
      workEmail: 'brittney.campbell@abc.co',
      preferredName: 'Brittney',
    },
    id: 273,
    publisherSelectedEmployees: [
      {
        label: 'Emily Smith',
        subTitle: 'emily.smith@abc.co',
        profilePhoto: null,
        id: 16204,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mrs. Rachel Gibson',
        subTitle: 'mrs..rachel.gibson@abc.co',
        profilePhoto: null,
        id: 16055,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Mary Thompson',
        subTitle: 'mary.thompson@abc.co',
        profilePhoto: null,
        id: 16320,
      },
    ],
  },
  {
    employee: {
      id: 16074,
      companyId: 3,
      displayName: 'Christina Walters',
      designation: 'Geneticist, molecular',
      ownerType: null,
      employeeFunction: null,
      email: 'christina.walters@abc.co',
      personalEmail: 'christina.walters@abc.co',
      workEmail: 'christina.walters@abc.co',
      preferredName: 'Christina',
    },
    id: 274,
    publisherSelectedEmployees: [
      {
        label: 'Andrew Ferrell',
        subTitle: 'andrew.ferrell@abc.co',
        profilePhoto: null,
        id: 16256,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Amanda Jones',
        subTitle: 'amanda.jones@abc.co',
        profilePhoto: null,
        id: 16224,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Diane Beck',
        subTitle: 'diane.beck@abc.co',
        profilePhoto: null,
        id: 16107,
      },
    ],
  },
  {
    employee: {
      id: 16075,
      companyId: 1,
      displayName: 'Danielle Odonnell',
      designation: 'Arts development officer',
      ownerType: null,
      employeeFunction: null,
      email: 'danielle.odonnell@abc.co',
      personalEmail: 'danielle.odonnell@abc.co',
      workEmail: 'danielle.odonnell@abc.co',
      preferredName: 'Danielle',
    },
    id: 275,
    publisherSelectedEmployees: [
      {
        label: 'Courtney Rodriguez',
        subTitle: 'courtney.rodriguez@abc.co',
        profilePhoto: null,
        id: 16291,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christina Cruz',
        subTitle: 'christina.cruz@abc.co',
        profilePhoto: null,
        id: 16235,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Christopher Gonzalez',
        subTitle: 'christopher.gonzalez@abc.co',
        profilePhoto: null,
        id: 16351,
      },
    ],
  },
  {
    employee: {
      id: 16076,
      companyId: 2,
      displayName: 'Jeff Hill',
      designation: 'Accountant, chartered certified',
      ownerType: null,
      employeeFunction: null,
      email: 'jeff.hill@abc.co',
      personalEmail: 'jeff.hill@abc.co',
      workEmail: 'jeff.hill@abc.co',
      preferredName: 'Jeff',
    },
    id: 276,
    publisherSelectedEmployees: [
      {
        label: 'Justin Lowery',
        subTitle: 'justin.lowery@abc.co',
        profilePhoto: null,
        id: 16114,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mrs. Catherine Taylor',
        subTitle: 'mrs..catherine.taylor@abc.co',
        profilePhoto: null,
        id: 16375,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Elizabeth Sutton',
        subTitle: 'elizabeth.sutton@abc.co',
        profilePhoto: null,
        id: 16145,
      },
    ],
  },
  {
    employee: {
      id: 16077,
      companyId: 3,
      displayName: 'Carlos Whitney',
      designation: 'Designer, television/film set',
      ownerType: null,
      employeeFunction: null,
      email: 'carlos.whitney@abc.co',
      personalEmail: 'carlos.whitney@abc.co',
      workEmail: 'carlos.whitney@abc.co',
      preferredName: 'Carlos',
    },
    id: 277,
    publisherSelectedEmployees: [
      {
        label: 'Casey James',
        subTitle: 'casey.james@abc.co',
        profilePhoto: null,
        id: 16307,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Aaron Barber',
        subTitle: 'aaron.barber@abc.co',
        profilePhoto: null,
        id: 16211,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sergio Murphy',
        subTitle: 'sergio.murphy@abc.co',
        profilePhoto: null,
        id: 16268,
      },
    ],
  },
  {
    employee: {
      id: 16078,
      companyId: 1,
      displayName: 'Kristen Patterson',
      designation: 'Acupuncturist',
      ownerType: null,
      employeeFunction: null,
      email: 'kristen.patterson@abc.co',
      personalEmail: 'kristen.patterson@abc.co',
      workEmail: 'kristen.patterson@abc.co',
      preferredName: 'Kristen',
    },
    id: 278,
    publisherSelectedEmployees: [
      {
        label: 'Ian Cooper',
        subTitle: 'ian.cooper@abc.co',
        profilePhoto: null,
        id: 16007,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Chad Jones',
        subTitle: 'chad.jones@abc.co',
        profilePhoto: null,
        id: 16397,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kathryn Rosario',
        subTitle: 'kathryn.rosario@abc.co',
        profilePhoto: null,
        id: 16329,
      },
    ],
  },
  {
    employee: {
      id: 16079,
      companyId: 2,
      displayName: 'Tony Vazquez',
      designation: 'Database administrator',
      ownerType: null,
      employeeFunction: null,
      email: 'tony.vazquez@abc.co',
      personalEmail: 'tony.vazquez@abc.co',
      workEmail: 'tony.vazquez@abc.co',
      preferredName: 'Tony',
    },
    id: 279,
    publisherSelectedEmployees: [
      {
        label: 'Jason Bauer',
        subTitle: 'jason.bauer@abc.co',
        profilePhoto: null,
        id: 16364,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Susan Rivas',
        subTitle: 'susan.rivas@abc.co',
        profilePhoto: null,
        id: 16246,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kathleen Aguilar',
        subTitle: 'kathleen.aguilar@abc.co',
        profilePhoto: null,
        id: 16230,
      },
    ],
  },
  {
    employee: {
      id: 16080,
      companyId: 3,
      displayName: 'Sandra Aguilar',
      designation: 'Data scientist',
      ownerType: null,
      employeeFunction: null,
      email: 'sandra.aguilar@abc.co',
      personalEmail: 'sandra.aguilar@abc.co',
      workEmail: 'sandra.aguilar@abc.co',
      preferredName: 'Sandra',
    },
    id: 280,
    publisherSelectedEmployees: [
      {
        label: 'David Ramirez',
        subTitle: 'david.ramirez@abc.co',
        profilePhoto: null,
        id: 16156,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Stephanie Freeman',
        subTitle: 'stephanie.freeman@abc.co',
        profilePhoto: null,
        id: 16128,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Gary Santiago',
        subTitle: 'gary.santiago@abc.co',
        profilePhoto: null,
        id: 16195,
      },
    ],
  },
  {
    employee: {
      id: 16081,
      companyId: 1,
      displayName: 'Andrew Diaz',
      designation: 'Archaeologist',
      ownerType: null,
      employeeFunction: null,
      email: 'andrew.diaz@abc.co',
      personalEmail: 'andrew.diaz@abc.co',
      workEmail: 'andrew.diaz@abc.co',
      preferredName: 'Andrew',
    },
    id: 281,
    publisherSelectedEmployees: [
      {
        label: 'Erica Miller',
        subTitle: 'erica.miller@abc.co',
        profilePhoto: null,
        id: 16384,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Tiffany Watson',
        subTitle: 'tiffany.watson@abc.co',
        profilePhoto: null,
        id: 16392,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Erik Scott',
        subTitle: 'erik.scott@abc.co',
        profilePhoto: null,
        id: 16284,
      },
    ],
  },
  {
    employee: {
      id: 16082,
      companyId: 2,
      displayName: 'Christine Wright',
      designation: 'Civil engineer, contracting',
      ownerType: null,
      employeeFunction: null,
      email: 'christine.wright@abc.co',
      personalEmail: 'christine.wright@abc.co',
      workEmail: 'christine.wright@abc.co',
      preferredName: 'Christine',
    },
    id: 282,
    publisherSelectedEmployees: [
      {
        label: 'Andrea Martin',
        subTitle: 'andrea.martin@abc.co',
        profilePhoto: null,
        id: 16185,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Robert Potter',
        subTitle: 'robert.potter@abc.co',
        profilePhoto: null,
        id: 16108,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Edward Novak',
        subTitle: 'edward.novak@abc.co',
        profilePhoto: null,
        id: 16057,
      },
    ],
  },
  {
    employee: {
      id: 16083,
      companyId: 3,
      displayName: 'Justin Baxter',
      designation: 'Web designer',
      ownerType: null,
      employeeFunction: null,
      email: 'justin.baxter@abc.co',
      personalEmail: 'justin.baxter@abc.co',
      workEmail: 'justin.baxter@abc.co',
      preferredName: 'Justin',
    },
    id: 283,
    publisherSelectedEmployees: [
      {
        label: 'Zachary Ferrell',
        subTitle: 'zachary.ferrell@abc.co',
        profilePhoto: null,
        id: 16067,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sandra Drake',
        subTitle: 'sandra.drake@abc.co',
        profilePhoto: null,
        id: 16308,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kathryn Rosario',
        subTitle: 'kathryn.rosario@abc.co',
        profilePhoto: null,
        id: 16329,
      },
    ],
  },
  {
    employee: {
      id: 16084,
      companyId: 1,
      displayName: 'Tammy Young',
      designation: 'Designer, textile',
      ownerType: null,
      employeeFunction: null,
      email: 'tammy.young@abc.co',
      personalEmail: 'tammy.young@abc.co',
      workEmail: 'tammy.young@abc.co',
      preferredName: 'Tammy',
    },
    id: 284,
    publisherSelectedEmployees: [
      {
        label: 'Patrick Rivera',
        subTitle: 'patrick.rivera@abc.co',
        profilePhoto: null,
        id: 16162,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Crystal Robinson',
        subTitle: 'crystal.robinson@abc.co',
        profilePhoto: null,
        id: 16041,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sabrina Briggs',
        subTitle: 'sabrina.briggs@abc.co',
        profilePhoto: null,
        id: 16318,
      },
    ],
  },
  {
    employee: {
      id: 16085,
      companyId: 2,
      displayName: 'Rita Keith',
      designation: 'Agricultural consultant',
      ownerType: null,
      employeeFunction: null,
      email: 'rita.keith@abc.co',
      personalEmail: 'rita.keith@abc.co',
      workEmail: 'rita.keith@abc.co',
      preferredName: 'Rita',
    },
    id: 285,
    publisherSelectedEmployees: [
      {
        label: 'Zachary Taylor',
        subTitle: 'zachary.taylor@abc.co',
        profilePhoto: null,
        id: 16022,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Tiffany Barnes',
        subTitle: 'tiffany.barnes@abc.co',
        profilePhoto: null,
        id: 16127,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Travis Horton',
        subTitle: 'travis.horton@abc.co',
        profilePhoto: null,
        id: 16258,
      },
    ],
  },
  {
    employee: {
      id: 16086,
      companyId: 3,
      displayName: 'Tim Patton',
      designation: 'Paramedic',
      ownerType: null,
      employeeFunction: null,
      email: 'tim.patton@abc.co',
      personalEmail: 'tim.patton@abc.co',
      workEmail: 'tim.patton@abc.co',
      preferredName: 'Tim',
    },
    id: 286,
    publisherSelectedEmployees: [
      {
        label: 'Mrs. Catherine Taylor',
        subTitle: 'mrs..catherine.taylor@abc.co',
        profilePhoto: null,
        id: 16375,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'William Lynch',
        subTitle: 'william.lynch@abc.co',
        profilePhoto: null,
        id: 16203,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Michael Miller',
        subTitle: 'michael.miller@abc.co',
        profilePhoto: null,
        id: 16338,
      },
    ],
  },
  {
    employee: {
      id: 16087,
      companyId: 1,
      displayName: 'Sharon Cochran',
      designation: 'Geologist, engineering',
      ownerType: null,
      employeeFunction: null,
      email: 'sharon.cochran@abc.co',
      personalEmail: 'sharon.cochran@abc.co',
      workEmail: 'sharon.cochran@abc.co',
      preferredName: 'Sharon',
    },
    id: 287,
    publisherSelectedEmployees: [
      {
        label: 'Dana Kennedy',
        subTitle: 'dana.kennedy@abc.co',
        profilePhoto: null,
        id: 16045,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christina Cruz',
        subTitle: 'christina.cruz@abc.co',
        profilePhoto: null,
        id: 16235,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Anthony Howard',
        subTitle: 'anthony.howard@abc.co',
        profilePhoto: null,
        id: 16227,
      },
    ],
  },
  {
    employee: {
      id: 16088,
      companyId: 2,
      displayName: 'Michael Reyes',
      designation: 'Arboriculturist',
      ownerType: null,
      employeeFunction: null,
      email: 'michael.reyes@abc.co',
      personalEmail: 'michael.reyes@abc.co',
      workEmail: 'michael.reyes@abc.co',
      preferredName: 'Michael',
    },
    id: 288,
    publisherSelectedEmployees: [
      {
        label: 'Vanessa Cardenas',
        subTitle: 'vanessa.cardenas@abc.co',
        profilePhoto: null,
        id: 16293,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Pamela Thompson',
        subTitle: 'pamela.thompson@abc.co',
        profilePhoto: null,
        id: 16192,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Annette Miles',
        subTitle: 'annette.miles@abc.co',
        profilePhoto: null,
        id: 16281,
      },
    ],
  },
  {
    employee: {
      id: 16089,
      companyId: 3,
      displayName: 'Courtney Velasquez',
      designation: 'Psychiatrist',
      ownerType: null,
      employeeFunction: null,
      email: 'courtney.velasquez@abc.co',
      personalEmail: 'courtney.velasquez@abc.co',
      workEmail: 'courtney.velasquez@abc.co',
      preferredName: 'Courtney',
    },
    id: 289,
    publisherSelectedEmployees: [
      {
        label: 'Mark Cox',
        subTitle: 'mark.cox@abc.co',
        profilePhoto: null,
        id: 16388,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Maria Moore',
        subTitle: 'maria.moore@abc.co',
        profilePhoto: null,
        id: 16206,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Mr. Andrew Foster',
        subTitle: 'mr..andrew.foster@abc.co',
        profilePhoto: null,
        id: 16304,
      },
    ],
  },
  {
    employee: {
      id: 16090,
      companyId: 1,
      displayName: 'Robert Savage',
      designation: 'Environmental health practitioner',
      ownerType: null,
      employeeFunction: null,
      email: 'robert.savage@abc.co',
      personalEmail: 'robert.savage@abc.co',
      workEmail: 'robert.savage@abc.co',
      preferredName: 'Robert',
    },
    id: 290,
    publisherSelectedEmployees: [
      {
        label: 'Lisa Byrd',
        subTitle: 'lisa.byrd@abc.co',
        profilePhoto: null,
        id: 16241,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Parker Hill',
        subTitle: 'parker.hill@abc.co',
        profilePhoto: null,
        id: 16165,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jerry Ramirez',
        subTitle: 'jerry.ramirez@abc.co',
        profilePhoto: null,
        id: 16004,
      },
    ],
  },
  {
    employee: {
      id: 16091,
      companyId: 2,
      displayName: 'Corey Murphy',
      designation: 'Building control surveyor',
      ownerType: null,
      employeeFunction: null,
      email: 'corey.murphy@abc.co',
      personalEmail: 'corey.murphy@abc.co',
      workEmail: 'corey.murphy@abc.co',
      preferredName: 'Corey',
    },
    id: 291,
    publisherSelectedEmployees: [
      {
        label: 'Phillip Andrews',
        subTitle: 'phillip.andrews@abc.co',
        profilePhoto: null,
        id: 16292,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jordan York',
        subTitle: 'jordan.york@abc.co',
        profilePhoto: null,
        id: 16060,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Elizabeth Sutton',
        subTitle: 'elizabeth.sutton@abc.co',
        profilePhoto: null,
        id: 16145,
      },
    ],
  },
  {
    employee: {
      id: 16092,
      companyId: 3,
      displayName: 'Diana May',
      designation: 'Office manager',
      ownerType: null,
      employeeFunction: null,
      email: 'diana.may@abc.co',
      personalEmail: 'diana.may@abc.co',
      workEmail: 'diana.may@abc.co',
      preferredName: 'Diana',
    },
    id: 292,
    publisherSelectedEmployees: [
      {
        label: 'Nichole Alvarez',
        subTitle: 'nichole.alvarez@abc.co',
        profilePhoto: null,
        id: 16273,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jamie Kerr',
        subTitle: 'jamie.kerr@abc.co',
        profilePhoto: null,
        id: 16176,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jeff Hill',
        subTitle: 'jeff.hill@abc.co',
        profilePhoto: null,
        id: 16076,
      },
    ],
  },
  {
    employee: {
      id: 16093,
      companyId: 1,
      displayName: 'Sarah Rivera',
      designation: 'Air broker',
      ownerType: null,
      employeeFunction: null,
      email: 'sarah.rivera@abc.co',
      personalEmail: 'sarah.rivera@abc.co',
      workEmail: 'sarah.rivera@abc.co',
      preferredName: 'Sarah',
    },
    id: 293,
    publisherSelectedEmployees: [
      {
        label: 'Laurie Hoffman',
        subTitle: 'laurie.hoffman@abc.co',
        profilePhoto: null,
        id: 16287,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Thomas Bradley',
        subTitle: 'thomas.bradley@abc.co',
        profilePhoto: null,
        id: 16018,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Bobby Franklin',
        subTitle: 'bobby.franklin@abc.co',
        profilePhoto: null,
        id: 16278,
      },
    ],
  },
  {
    employee: {
      id: 16094,
      companyId: 2,
      displayName: 'Wesley White',
      designation: 'Geochemist',
      ownerType: null,
      employeeFunction: null,
      email: 'wesley.white@abc.co',
      personalEmail: 'wesley.white@abc.co',
      workEmail: 'wesley.white@abc.co',
      preferredName: 'Wesley',
    },
    id: 294,
    publisherSelectedEmployees: [
      {
        label: 'Seth Reese',
        subTitle: 'seth.reese@abc.co',
        profilePhoto: null,
        id: 16315,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Cindy Carr',
        subTitle: 'cindy.carr@abc.co',
        profilePhoto: null,
        id: 16396,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Melissa Martinez',
        subTitle: 'melissa.martinez@abc.co',
        profilePhoto: null,
        id: 16169,
      },
    ],
  },
  {
    employee: {
      id: 16095,
      companyId: 3,
      displayName: 'Kyle Reed',
      designation: 'Interior and spatial designer',
      ownerType: null,
      employeeFunction: null,
      email: 'kyle.reed@abc.co',
      personalEmail: 'kyle.reed@abc.co',
      workEmail: 'kyle.reed@abc.co',
      preferredName: 'Kyle',
    },
    id: 295,
    publisherSelectedEmployees: [
      {
        label: 'Sean Wyatt',
        subTitle: 'sean.wyatt@abc.co',
        profilePhoto: null,
        id: 16326,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'David Bradley',
        subTitle: 'david.bradley@abc.co',
        profilePhoto: null,
        id: 16034,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kyle Phillips',
        subTitle: 'kyle.phillips@abc.co',
        profilePhoto: null,
        id: 16280,
      },
    ],
  },
  {
    employee: {
      id: 16096,
      companyId: 1,
      displayName: 'William Wilson',
      designation: 'Technical author',
      ownerType: null,
      employeeFunction: null,
      email: 'william.wilson@abc.co',
      personalEmail: 'william.wilson@abc.co',
      workEmail: 'william.wilson@abc.co',
      preferredName: 'William',
    },
    id: 296,
    publisherSelectedEmployees: [
      {
        label: 'Gary Santiago',
        subTitle: 'gary.santiago@abc.co',
        profilePhoto: null,
        id: 16195,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mrs. Catherine Taylor',
        subTitle: 'mrs..catherine.taylor@abc.co',
        profilePhoto: null,
        id: 16375,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kaitlyn Harvey',
        subTitle: 'kaitlyn.harvey@abc.co',
        profilePhoto: null,
        id: 16253,
      },
    ],
  },
  {
    employee: {
      id: 16097,
      companyId: 2,
      displayName: 'Andrew Graham',
      designation: 'Scientist, product/process development',
      ownerType: null,
      employeeFunction: null,
      email: 'andrew.graham@abc.co',
      personalEmail: 'andrew.graham@abc.co',
      workEmail: 'andrew.graham@abc.co',
      preferredName: 'Andrew',
    },
    id: 297,
    publisherSelectedEmployees: [
      {
        label: 'Sydney White',
        subTitle: 'sydney.white@abc.co',
        profilePhoto: null,
        id: 16193,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Casey James',
        subTitle: 'casey.james@abc.co',
        profilePhoto: null,
        id: 16307,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 16001,
      },
    ],
  },
  {
    employee: {
      id: 16098,
      companyId: 3,
      displayName: 'Kimberly Ball',
      designation: 'Engineer, chemical',
      ownerType: null,
      employeeFunction: null,
      email: 'kimberly.ball@abc.co',
      personalEmail: 'kimberly.ball@abc.co',
      workEmail: 'kimberly.ball@abc.co',
      preferredName: 'Kimberly',
    },
    id: 298,
    publisherSelectedEmployees: [
      {
        label: 'Jesse Flowers',
        subTitle: 'jesse.flowers@abc.co',
        profilePhoto: null,
        id: 16012,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'James Powers',
        subTitle: 'james.powers@abc.co',
        profilePhoto: null,
        id: 16065,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Aaron Bell',
        subTitle: 'aaron.bell@abc.co',
        profilePhoto: null,
        id: 16126,
      },
    ],
  },
  {
    employee: {
      id: 16099,
      companyId: 1,
      displayName: 'Benjamin Beck',
      designation: 'Lawyer',
      ownerType: null,
      employeeFunction: null,
      email: 'benjamin.beck@abc.co',
      personalEmail: 'benjamin.beck@abc.co',
      workEmail: 'benjamin.beck@abc.co',
      preferredName: 'Benjamin',
    },
    id: 299,
    publisherSelectedEmployees: [
      {
        label: 'Cody Williams',
        subTitle: 'cody.williams@abc.co',
        profilePhoto: null,
        id: 16171,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Erik Scott',
        subTitle: 'erik.scott@abc.co',
        profilePhoto: null,
        id: 16284,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jill Miller',
        subTitle: 'jill.miller@abc.co',
        profilePhoto: null,
        id: 16398,
      },
    ],
  },
  {
    employee: {
      id: 16100,
      companyId: 2,
      displayName: 'Mary Martinez',
      designation: 'Hydrologist',
      ownerType: null,
      employeeFunction: null,
      email: 'mary.martinez@abc.co',
      personalEmail: 'mary.martinez@abc.co',
      workEmail: 'mary.martinez@abc.co',
      preferredName: 'Mary',
    },
    id: 300,
    publisherSelectedEmployees: [
      {
        label: 'Kathryn Rosario',
        subTitle: 'kathryn.rosario@abc.co',
        profilePhoto: null,
        id: 16329,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jill Miller',
        subTitle: 'jill.miller@abc.co',
        profilePhoto: null,
        id: 16398,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Patrick Moore',
        subTitle: 'patrick.moore@abc.co',
        profilePhoto: null,
        id: 16259,
      },
    ],
  },
  {
    employee: {
      id: 16101,
      companyId: 3,
      displayName: 'Mary Nguyen',
      designation: 'Hotel manager',
      ownerType: null,
      employeeFunction: null,
      email: 'mary.nguyen@abc.co',
      personalEmail: 'mary.nguyen@abc.co',
      workEmail: 'mary.nguyen@abc.co',
      preferredName: 'Mary',
    },
    id: 301,
    publisherSelectedEmployees: [
      {
        label: 'Joseph Knight',
        subTitle: 'joseph.knight@abc.co',
        profilePhoto: null,
        id: 16228,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Angela Wright',
        subTitle: 'angela.wright@abc.co',
        profilePhoto: null,
        id: 16174,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'David Walsh',
        subTitle: 'david.walsh@abc.co',
        profilePhoto: null,
        id: 16119,
      },
    ],
  },
  {
    employee: {
      id: 16102,
      companyId: 1,
      displayName: 'Cheryl Ortega',
      designation: 'Museum education officer',
      ownerType: null,
      employeeFunction: null,
      email: 'cheryl.ortega@abc.co',
      personalEmail: 'cheryl.ortega@abc.co',
      workEmail: 'cheryl.ortega@abc.co',
      preferredName: 'Cheryl',
    },
    id: 302,
    publisherSelectedEmployees: [
      {
        label: 'Jessica Fox',
        subTitle: 'jessica.fox@abc.co',
        profilePhoto: null,
        id: 16219,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Patrick Tapia',
        subTitle: 'patrick.tapia@abc.co',
        profilePhoto: null,
        id: 16164,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Eugene Higgins',
        subTitle: 'eugene.higgins@abc.co',
        profilePhoto: null,
        id: 16223,
      },
    ],
  },
  {
    employee: {
      id: 16103,
      companyId: 2,
      displayName: 'Stephanie Gilbert',
      designation: 'Illustrator',
      ownerType: null,
      employeeFunction: null,
      email: 'stephanie.gilbert@abc.co',
      personalEmail: 'stephanie.gilbert@abc.co',
      workEmail: 'stephanie.gilbert@abc.co',
      preferredName: 'Stephanie',
    },
    id: 303,
    publisherSelectedEmployees: [
      {
        label: 'Miss Patricia Gibson',
        subTitle: 'miss.patricia.gibson@abc.co',
        profilePhoto: null,
        id: 16110,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kyle Reed',
        subTitle: 'kyle.reed@abc.co',
        profilePhoto: null,
        id: 16095,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Courtney Rodriguez',
        subTitle: 'courtney.rodriguez@abc.co',
        profilePhoto: null,
        id: 16291,
      },
    ],
  },
  {
    employee: {
      id: 16104,
      companyId: 3,
      displayName: 'Roy Torres',
      designation: 'Engineer, materials',
      ownerType: null,
      employeeFunction: null,
      email: 'roy.torres@abc.co',
      personalEmail: 'roy.torres@abc.co',
      workEmail: 'roy.torres@abc.co',
      preferredName: 'Roy',
    },
    id: 304,
    publisherSelectedEmployees: [
      {
        label: 'Tony Vazquez',
        subTitle: 'tony.vazquez@abc.co',
        profilePhoto: null,
        id: 16079,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mr. Jeremiah Reeves',
        subTitle: 'mr..jeremiah.reeves@abc.co',
        profilePhoto: null,
        id: 16120,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Seth Reese',
        subTitle: 'seth.reese@abc.co',
        profilePhoto: null,
        id: 16315,
      },
    ],
  },
  {
    employee: {
      id: 16105,
      companyId: 1,
      displayName: 'Kevin Pena',
      designation: 'Psychologist, occupational',
      ownerType: null,
      employeeFunction: null,
      email: 'kevin.pena@abc.co',
      personalEmail: 'kevin.pena@abc.co',
      workEmail: 'kevin.pena@abc.co',
      preferredName: 'Kevin',
    },
    id: 305,
    publisherSelectedEmployees: [
      {
        label: 'Jonathan Young',
        subTitle: 'jonathan.young@abc.co',
        profilePhoto: null,
        id: 16357,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jennifer Brown',
        subTitle: 'jennifer.brown@abc.co',
        profilePhoto: null,
        id: 16024,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Carolyn Daniel',
        subTitle: 'carolyn.daniel@abc.co',
        profilePhoto: null,
        id: 16014,
      },
    ],
  },
  {
    employee: {
      id: 16106,
      companyId: 2,
      displayName: 'Michael Dixon',
      designation: 'Doctor, general practice',
      ownerType: null,
      employeeFunction: null,
      email: 'michael.dixon@abc.co',
      personalEmail: 'michael.dixon@abc.co',
      workEmail: 'michael.dixon@abc.co',
      preferredName: 'Michael',
    },
    id: 306,
    publisherSelectedEmployees: [
      {
        label: 'Samantha Bentley',
        subTitle: 'samantha.bentley@abc.co',
        profilePhoto: null,
        id: 16252,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jeff Hill',
        subTitle: 'jeff.hill@abc.co',
        profilePhoto: null,
        id: 16076,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Phillip Andrews',
        subTitle: 'phillip.andrews@abc.co',
        profilePhoto: null,
        id: 16292,
      },
    ],
  },
  {
    employee: {
      id: 16107,
      companyId: 3,
      displayName: 'Diane Beck',
      designation: 'Water quality scientist',
      ownerType: null,
      employeeFunction: null,
      email: 'diane.beck@abc.co',
      personalEmail: 'diane.beck@abc.co',
      workEmail: 'diane.beck@abc.co',
      preferredName: 'Diane',
    },
    id: 307,
    publisherSelectedEmployees: [
      {
        label: 'Donna Wilson',
        subTitle: 'donna.wilson@abc.co',
        profilePhoto: null,
        id: 16306,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'John Jones',
        subTitle: 'john.jones@abc.co',
        profilePhoto: null,
        id: 16035,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Andrew Berg',
        subTitle: 'andrew.berg@abc.co',
        profilePhoto: null,
        id: 16386,
      },
    ],
  },
  {
    employee: {
      id: 16108,
      companyId: 1,
      displayName: 'Robert Potter',
      designation: 'Insurance claims handler',
      ownerType: null,
      employeeFunction: null,
      email: 'robert.potter@abc.co',
      personalEmail: 'robert.potter@abc.co',
      workEmail: 'robert.potter@abc.co',
      preferredName: 'Robert',
    },
    id: 308,
    publisherSelectedEmployees: [
      {
        label: 'Michael Snyder',
        subTitle: 'michael.snyder@abc.co',
        profilePhoto: null,
        id: 16111,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christopher Gonzalez',
        subTitle: 'christopher.gonzalez@abc.co',
        profilePhoto: null,
        id: 16351,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kyle Reed',
        subTitle: 'kyle.reed@abc.co',
        profilePhoto: null,
        id: 16095,
      },
    ],
  },
  {
    employee: {
      id: 16109,
      companyId: 2,
      displayName: 'Curtis Johnson',
      designation: 'Financial risk analyst',
      ownerType: null,
      employeeFunction: null,
      email: 'curtis.johnson@abc.co',
      personalEmail: 'curtis.johnson@abc.co',
      workEmail: 'curtis.johnson@abc.co',
      preferredName: 'Curtis',
    },
    id: 309,
    publisherSelectedEmployees: [
      {
        label: 'Maria Moore',
        subTitle: 'maria.moore@abc.co',
        profilePhoto: null,
        id: 16206,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michael Brooks',
        subTitle: 'michael.brooks@abc.co',
        profilePhoto: null,
        id: 16039,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Ms. Rebecca Rodriguez',
        subTitle: 'ms..rebecca.rodriguez@abc.co',
        profilePhoto: null,
        id: 16270,
      },
    ],
  },
  {
    employee: {
      id: 16110,
      companyId: 3,
      displayName: 'Miss Patricia Gibson',
      designation: 'Teaching laboratory technician',
      ownerType: null,
      employeeFunction: null,
      email: 'miss.patricia.gibson@abc.co',
      personalEmail: 'miss.patricia.gibson@abc.co',
      workEmail: 'miss.patricia.gibson@abc.co',
      preferredName: 'Miss',
    },
    id: 310,
    publisherSelectedEmployees: [
      {
        label: 'Sean Osborne',
        subTitle: 'sean.osborne@abc.co',
        profilePhoto: null,
        id: 16238,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Justin Lowery',
        subTitle: 'justin.lowery@abc.co',
        profilePhoto: null,
        id: 16114,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Brian Barton',
        subTitle: 'brian.barton@abc.co',
        profilePhoto: null,
        id: 16198,
      },
    ],
  },
  {
    employee: {
      id: 16111,
      companyId: 1,
      displayName: 'Michael Snyder',
      designation: 'Financial planner',
      ownerType: null,
      employeeFunction: null,
      email: 'michael.snyder@abc.co',
      personalEmail: 'michael.snyder@abc.co',
      workEmail: 'michael.snyder@abc.co',
      preferredName: 'Michael',
    },
    id: 311,
    publisherSelectedEmployees: [
      {
        label: 'Allison Hill',
        subTitle: 'allison.hill@abc.co',
        profilePhoto: null,
        id: 16000,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Frederick Solis',
        subTitle: 'frederick.solis@abc.co',
        profilePhoto: null,
        id: 16312,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Morgan Munoz',
        subTitle: 'morgan.munoz@abc.co',
        profilePhoto: null,
        id: 16189,
      },
    ],
  },
  {
    employee: {
      id: 16112,
      companyId: 2,
      displayName: 'Michael Stafford',
      designation: 'Clinical biochemist',
      ownerType: null,
      employeeFunction: null,
      email: 'michael.stafford@abc.co',
      personalEmail: 'michael.stafford@abc.co',
      workEmail: 'michael.stafford@abc.co',
      preferredName: 'Michael',
    },
    id: 312,
    publisherSelectedEmployees: [
      {
        label: 'Mary Martinez',
        subTitle: 'mary.martinez@abc.co',
        profilePhoto: null,
        id: 16100,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michele Gibson',
        subTitle: 'michele.gibson@abc.co',
        profilePhoto: null,
        id: 16182,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Mrs. Rachel Gibson',
        subTitle: 'mrs..rachel.gibson@abc.co',
        profilePhoto: null,
        id: 16055,
      },
    ],
  },
  {
    employee: {
      id: 16113,
      companyId: 3,
      displayName: 'Colleen Brock',
      designation: 'Scientist, marine',
      ownerType: null,
      employeeFunction: null,
      email: 'colleen.brock@abc.co',
      personalEmail: 'colleen.brock@abc.co',
      workEmail: 'colleen.brock@abc.co',
      preferredName: 'Colleen',
    },
    id: 313,
    publisherSelectedEmployees: [
      {
        label: 'Brad Ramos',
        subTitle: 'brad.ramos@abc.co',
        profilePhoto: null,
        id: 16301,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Pamela Thompson',
        subTitle: 'pamela.thompson@abc.co',
        profilePhoto: null,
        id: 16192,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jeremy Reed',
        subTitle: 'jeremy.reed@abc.co',
        profilePhoto: null,
        id: 16233,
      },
    ],
  },
  {
    employee: {
      id: 16114,
      companyId: 1,
      displayName: 'Justin Lowery',
      designation: 'Community development worker',
      ownerType: null,
      employeeFunction: null,
      email: 'justin.lowery@abc.co',
      personalEmail: 'justin.lowery@abc.co',
      workEmail: 'justin.lowery@abc.co',
      preferredName: 'Justin',
    },
    id: 314,
    publisherSelectedEmployees: [
      {
        label: 'Scott Pierce',
        subTitle: 'scott.pierce@abc.co',
        profilePhoto: null,
        id: 16051,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Olivia Harris',
        subTitle: 'olivia.harris@abc.co',
        profilePhoto: null,
        id: 16201,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Christopher Williams',
        subTitle: 'christopher.williams@abc.co',
        profilePhoto: null,
        id: 16272,
      },
    ],
  },
  {
    employee: {
      id: 16115,
      companyId: 2,
      displayName: 'Robert Contreras',
      designation: 'Surveyor, land/geomatics',
      ownerType: null,
      employeeFunction: null,
      email: 'robert.contreras@abc.co',
      personalEmail: 'robert.contreras@abc.co',
      workEmail: 'robert.contreras@abc.co',
      preferredName: 'Robert',
    },
    id: 315,
    publisherSelectedEmployees: [
      {
        label: 'Raymond Shelton',
        subTitle: 'raymond.shelton@abc.co',
        profilePhoto: null,
        id: 16333,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sharon Cochran',
        subTitle: 'sharon.cochran@abc.co',
        profilePhoto: null,
        id: 16087,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 16001,
      },
    ],
  },
  {
    employee: {
      id: 16116,
      companyId: 3,
      displayName: 'Tiffany Vance',
      designation: 'Video editor',
      ownerType: null,
      employeeFunction: null,
      email: 'tiffany.vance@abc.co',
      personalEmail: 'tiffany.vance@abc.co',
      workEmail: 'tiffany.vance@abc.co',
      preferredName: 'Tiffany',
    },
    id: 316,
    publisherSelectedEmployees: [
      {
        label: 'Monica Herrera',
        subTitle: 'monica.herrera@abc.co',
        profilePhoto: null,
        id: 16008,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'David Bradley',
        subTitle: 'david.bradley@abc.co',
        profilePhoto: null,
        id: 16034,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Austin Vasquez',
        subTitle: 'austin.vasquez@abc.co',
        profilePhoto: null,
        id: 16172,
      },
    ],
  },
  {
    employee: {
      id: 16117,
      companyId: 1,
      displayName: 'Stephanie Simmons',
      designation: 'Sports therapist',
      ownerType: null,
      employeeFunction: null,
      email: 'stephanie.simmons@abc.co',
      personalEmail: 'stephanie.simmons@abc.co',
      workEmail: 'stephanie.simmons@abc.co',
      preferredName: 'Stephanie',
    },
    id: 317,
    publisherSelectedEmployees: [
      {
        label: 'Desiree Smith',
        subTitle: 'desiree.smith@abc.co',
        profilePhoto: null,
        id: 16157,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sydney White',
        subTitle: 'sydney.white@abc.co',
        profilePhoto: null,
        id: 16193,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Lance Simmons',
        subTitle: 'lance.simmons@abc.co',
        profilePhoto: null,
        id: 16385,
      },
    ],
  },
  {
    employee: {
      id: 16118,
      companyId: 2,
      displayName: 'Christopher Hensley',
      designation: 'Production assistant, television',
      ownerType: null,
      employeeFunction: null,
      email: 'christopher.hensley@abc.co',
      personalEmail: 'christopher.hensley@abc.co',
      workEmail: 'christopher.hensley@abc.co',
      preferredName: 'Christopher',
    },
    id: 318,
    publisherSelectedEmployees: [
      {
        label: 'Cindy Hayes',
        subTitle: 'cindy.hayes@abc.co',
        profilePhoto: null,
        id: 16282,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michael Roberts',
        subTitle: 'michael.roberts@abc.co',
        profilePhoto: null,
        id: 16196,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Travis Johnson',
        subTitle: 'travis.johnson@abc.co',
        profilePhoto: null,
        id: 16391,
      },
    ],
  },
  {
    employee: {
      id: 16119,
      companyId: 3,
      displayName: 'David Walsh',
      designation: 'Scientist, research (life sciences)',
      ownerType: null,
      employeeFunction: null,
      email: 'david.walsh@abc.co',
      personalEmail: 'david.walsh@abc.co',
      workEmail: 'david.walsh@abc.co',
      preferredName: 'David',
    },
    id: 319,
    publisherSelectedEmployees: [
      {
        label: 'Brittney Campbell',
        subTitle: 'brittney.campbell@abc.co',
        profilePhoto: null,
        id: 16073,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Samuel White',
        subTitle: 'samuel.white@abc.co',
        profilePhoto: null,
        id: 16155,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Megan Young',
        subTitle: 'megan.young@abc.co',
        profilePhoto: null,
        id: 16061,
      },
    ],
  },
  {
    employee: {
      id: 16120,
      companyId: 1,
      displayName: 'Mr. Jeremiah Reeves',
      designation: 'Farm manager',
      ownerType: null,
      employeeFunction: null,
      email: 'mr..jeremiah.reeves@abc.co',
      personalEmail: 'mr..jeremiah.reeves@abc.co',
      workEmail: 'mr..jeremiah.reeves@abc.co',
      preferredName: 'Mr.',
    },
    id: 320,
    publisherSelectedEmployees: [
      {
        label: 'Ashley Gordon',
        subTitle: 'ashley.gordon@abc.co',
        profilePhoto: null,
        id: 16274,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Gavin Zhang',
        subTitle: 'gavin.zhang@abc.co',
        profilePhoto: null,
        id: 16266,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Stephanie Freeman',
        subTitle: 'stephanie.freeman@abc.co',
        profilePhoto: null,
        id: 16128,
      },
    ],
  },
  {
    employee: {
      id: 16121,
      companyId: 2,
      displayName: 'Francisco Fernandez',
      designation: 'Corporate investment banker',
      ownerType: null,
      employeeFunction: null,
      email: 'francisco.fernandez@abc.co',
      personalEmail: 'francisco.fernandez@abc.co',
      workEmail: 'francisco.fernandez@abc.co',
      preferredName: 'Francisco',
    },
    id: 321,
    publisherSelectedEmployees: [
      {
        label: 'Susan Smith',
        subTitle: 'susan.smith@abc.co',
        profilePhoto: null,
        id: 16361,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Diana May',
        subTitle: 'diana.may@abc.co',
        profilePhoto: null,
        id: 16092,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Mrs. Catherine Taylor',
        subTitle: 'mrs..catherine.taylor@abc.co',
        profilePhoto: null,
        id: 16375,
      },
    ],
  },
  {
    employee: {
      id: 16122,
      companyId: 3,
      displayName: 'James Hernandez',
      designation: 'Engineer, site',
      ownerType: null,
      employeeFunction: null,
      email: 'james.hernandez@abc.co',
      personalEmail: 'james.hernandez@abc.co',
      workEmail: 'james.hernandez@abc.co',
      preferredName: 'James',
    },
    id: 322,
    publisherSelectedEmployees: [
      {
        label: 'Carolyn Daniel',
        subTitle: 'carolyn.daniel@abc.co',
        profilePhoto: null,
        id: 16014,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Hunter Kramer',
        subTitle: 'hunter.kramer@abc.co',
        profilePhoto: null,
        id: 16271,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Shannon Johnston',
        subTitle: 'shannon.johnston@abc.co',
        profilePhoto: null,
        id: 16310,
      },
    ],
  },
  {
    employee: {
      id: 16123,
      companyId: 1,
      displayName: 'Jason Daniels',
      designation: 'Pathologist',
      ownerType: null,
      employeeFunction: null,
      email: 'jason.daniels@abc.co',
      personalEmail: 'jason.daniels@abc.co',
      workEmail: 'jason.daniels@abc.co',
      preferredName: 'Jason',
    },
    id: 323,
    publisherSelectedEmployees: [
      {
        label: 'Julie King',
        subTitle: 'julie.king@abc.co',
        profilePhoto: null,
        id: 16025,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michael Berger',
        subTitle: 'michael.berger@abc.co',
        profilePhoto: null,
        id: 16226,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Connor West',
        subTitle: 'connor.west@abc.co',
        profilePhoto: null,
        id: 16049,
      },
    ],
  },
  {
    employee: {
      id: 16124,
      companyId: 2,
      displayName: 'Ross Price',
      designation: 'Television/film/video producer',
      ownerType: null,
      employeeFunction: null,
      email: 'ross.price@abc.co',
      personalEmail: 'ross.price@abc.co',
      workEmail: 'ross.price@abc.co',
      preferredName: 'Ross',
    },
    id: 324,
    publisherSelectedEmployees: [
      {
        label: 'Edward Fuller',
        subTitle: 'edward.fuller@abc.co',
        profilePhoto: null,
        id: 16009,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Ms. Rebecca Rodriguez',
        subTitle: 'ms..rebecca.rodriguez@abc.co',
        profilePhoto: null,
        id: 16270,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kimberly Acosta',
        subTitle: 'kimberly.acosta@abc.co',
        profilePhoto: null,
        id: 16362,
      },
    ],
  },
  {
    employee: {
      id: 16125,
      companyId: 3,
      displayName: 'Alicia Gilmore',
      designation: 'Teaching laboratory technician',
      ownerType: null,
      employeeFunction: null,
      email: 'alicia.gilmore@abc.co',
      personalEmail: 'alicia.gilmore@abc.co',
      workEmail: 'alicia.gilmore@abc.co',
      preferredName: 'Alicia',
    },
    id: 325,
    publisherSelectedEmployees: [
      {
        label: 'Vanessa Cardenas',
        subTitle: 'vanessa.cardenas@abc.co',
        profilePhoto: null,
        id: 16293,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christina Cruz',
        subTitle: 'christina.cruz@abc.co',
        profilePhoto: null,
        id: 16235,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Casey James',
        subTitle: 'casey.james@abc.co',
        profilePhoto: null,
        id: 16307,
      },
    ],
  },
  {
    employee: {
      id: 16126,
      companyId: 1,
      displayName: 'Aaron Bell',
      designation: 'Newspaper journalist',
      ownerType: null,
      employeeFunction: null,
      email: 'aaron.bell@abc.co',
      personalEmail: 'aaron.bell@abc.co',
      workEmail: 'aaron.bell@abc.co',
      preferredName: 'Aaron',
    },
    id: 326,
    publisherSelectedEmployees: [
      {
        label: 'Kylie Williams',
        subTitle: 'kylie.williams@abc.co',
        profilePhoto: null,
        id: 16146,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michael Dixon',
        subTitle: 'michael.dixon@abc.co',
        profilePhoto: null,
        id: 16106,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Chad Jones',
        subTitle: 'chad.jones@abc.co',
        profilePhoto: null,
        id: 16397,
      },
    ],
  },
  {
    employee: {
      id: 16127,
      companyId: 2,
      displayName: 'Tiffany Barnes',
      designation: 'Sports coach',
      ownerType: null,
      employeeFunction: null,
      email: 'tiffany.barnes@abc.co',
      personalEmail: 'tiffany.barnes@abc.co',
      workEmail: 'tiffany.barnes@abc.co',
      preferredName: 'Tiffany',
    },
    id: 327,
    publisherSelectedEmployees: [
      {
        label: 'Sabrina Briggs',
        subTitle: 'sabrina.briggs@abc.co',
        profilePhoto: null,
        id: 16318,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mr. Donald Fischer',
        subTitle: 'mr..donald.fischer@abc.co',
        profilePhoto: null,
        id: 16302,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'David Sheppard',
        subTitle: 'david.sheppard@abc.co',
        profilePhoto: null,
        id: 16348,
      },
    ],
  },
  {
    employee: {
      id: 16128,
      companyId: 3,
      displayName: 'Stephanie Freeman',
      designation: 'Government social research officer',
      ownerType: null,
      employeeFunction: null,
      email: 'stephanie.freeman@abc.co',
      personalEmail: 'stephanie.freeman@abc.co',
      workEmail: 'stephanie.freeman@abc.co',
      preferredName: 'Stephanie',
    },
    id: 328,
    publisherSelectedEmployees: [
      {
        label: 'Angela Morrison',
        subTitle: 'angela.morrison@abc.co',
        profilePhoto: null,
        id: 16383,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Stacey Arias',
        subTitle: 'stacey.arias@abc.co',
        profilePhoto: null,
        id: 16356,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Benjamin Smith',
        subTitle: 'benjamin.smith@abc.co',
        profilePhoto: null,
        id: 16180,
      },
    ],
  },
  {
    employee: {
      id: 16129,
      companyId: 1,
      displayName: 'Allen Rogers',
      designation: 'Ophthalmologist',
      ownerType: null,
      employeeFunction: null,
      email: 'allen.rogers@abc.co',
      personalEmail: 'allen.rogers@abc.co',
      workEmail: 'allen.rogers@abc.co',
      preferredName: 'Allen',
    },
    id: 329,
    publisherSelectedEmployees: [
      {
        label: 'Ashley Singleton',
        subTitle: 'ashley.singleton@abc.co',
        profilePhoto: null,
        id: 16353,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Pamela Thompson',
        subTitle: 'pamela.thompson@abc.co',
        profilePhoto: null,
        id: 16192,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Shawn Ramirez',
        subTitle: 'shawn.ramirez@abc.co',
        profilePhoto: null,
        id: 16134,
      },
    ],
  },
  {
    employee: {
      id: 16130,
      companyId: 2,
      displayName: 'Sara Calhoun',
      designation: 'Writer',
      ownerType: null,
      employeeFunction: null,
      email: 'sara.calhoun@abc.co',
      personalEmail: 'sara.calhoun@abc.co',
      workEmail: 'sara.calhoun@abc.co',
      preferredName: 'Sara',
    },
    id: 330,
    publisherSelectedEmployees: [
      {
        label: 'Bobby Franklin',
        subTitle: 'bobby.franklin@abc.co',
        profilePhoto: null,
        id: 16278,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Joseph Obrien',
        subTitle: 'joseph.obrien@abc.co',
        profilePhoto: null,
        id: 16037,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kara Davis',
        subTitle: 'kara.davis@abc.co',
        profilePhoto: null,
        id: 16285,
      },
    ],
  },
  {
    employee: {
      id: 16131,
      companyId: 3,
      displayName: 'Susan Vargas',
      designation: 'Aid worker',
      ownerType: null,
      employeeFunction: null,
      email: 'susan.vargas@abc.co',
      personalEmail: 'susan.vargas@abc.co',
      workEmail: 'susan.vargas@abc.co',
      preferredName: 'Susan',
    },
    id: 331,
    publisherSelectedEmployees: [
      {
        label: 'Ms. Rebecca Rodriguez',
        subTitle: 'ms..rebecca.rodriguez@abc.co',
        profilePhoto: null,
        id: 16270,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kyle Phillips',
        subTitle: 'kyle.phillips@abc.co',
        profilePhoto: null,
        id: 16280,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Bob Pitts',
        subTitle: 'bob.pitts@abc.co',
        profilePhoto: null,
        id: 16229,
      },
    ],
  },
  {
    employee: {
      id: 16132,
      companyId: 1,
      displayName: 'Jeffrey Camacho',
      designation: 'Education officer, environmental',
      ownerType: null,
      employeeFunction: null,
      email: 'jeffrey.camacho@abc.co',
      personalEmail: 'jeffrey.camacho@abc.co',
      workEmail: 'jeffrey.camacho@abc.co',
      preferredName: 'Jeffrey',
    },
    id: 332,
    publisherSelectedEmployees: [
      {
        label: 'Ashley Johnson',
        subTitle: 'ashley.johnson@abc.co',
        profilePhoto: null,
        id: 16142,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mrs. Catherine Taylor',
        subTitle: 'mrs..catherine.taylor@abc.co',
        profilePhoto: null,
        id: 16375,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Samantha Bentley',
        subTitle: 'samantha.bentley@abc.co',
        profilePhoto: null,
        id: 16252,
      },
    ],
  },
  {
    employee: {
      id: 16133,
      companyId: 2,
      displayName: 'James Lewis',
      designation: 'Journalist, newspaper',
      ownerType: null,
      employeeFunction: null,
      email: 'james.lewis@abc.co',
      personalEmail: 'james.lewis@abc.co',
      workEmail: 'james.lewis@abc.co',
      preferredName: 'James',
    },
    id: 333,
    publisherSelectedEmployees: [
      {
        label: 'Patrick Tapia',
        subTitle: 'patrick.tapia@abc.co',
        profilePhoto: null,
        id: 16164,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Tiffany Watson',
        subTitle: 'tiffany.watson@abc.co',
        profilePhoto: null,
        id: 16392,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'James Powers',
        subTitle: 'james.powers@abc.co',
        profilePhoto: null,
        id: 16065,
      },
    ],
  },
  {
    employee: {
      id: 16134,
      companyId: 3,
      displayName: 'Shawn Ramirez',
      designation: 'Pharmacist, community',
      ownerType: null,
      employeeFunction: null,
      email: 'shawn.ramirez@abc.co',
      personalEmail: 'shawn.ramirez@abc.co',
      workEmail: 'shawn.ramirez@abc.co',
      preferredName: 'Shawn',
    },
    id: 334,
    publisherSelectedEmployees: [
      {
        label: 'Michael Miller',
        subTitle: 'michael.miller@abc.co',
        profilePhoto: null,
        id: 16338,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Richard Camacho',
        subTitle: 'richard.camacho@abc.co',
        profilePhoto: null,
        id: 16275,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Dr. Steven Martin',
        subTitle: 'dr..steven.martin@abc.co',
        profilePhoto: null,
        id: 16054,
      },
    ],
  },
  {
    employee: {
      id: 16135,
      companyId: 1,
      displayName: 'Bradley Smith',
      designation: 'Solicitor, Scotland',
      ownerType: null,
      employeeFunction: null,
      email: 'bradley.smith@abc.co',
      personalEmail: 'bradley.smith@abc.co',
      workEmail: 'bradley.smith@abc.co',
      preferredName: 'Bradley',
    },
    id: 335,
    publisherSelectedEmployees: [
      {
        label: 'Christopher Thomas',
        subTitle: 'christopher.thomas@abc.co',
        profilePhoto: null,
        id: 16296,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Desiree Smith',
        subTitle: 'desiree.smith@abc.co',
        profilePhoto: null,
        id: 16157,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 16001,
      },
    ],
  },
  {
    employee: {
      id: 16136,
      companyId: 2,
      displayName: 'Trevor Walker',
      designation: 'Broadcast presenter',
      ownerType: null,
      employeeFunction: null,
      email: 'trevor.walker@abc.co',
      personalEmail: 'trevor.walker@abc.co',
      workEmail: 'trevor.walker@abc.co',
      preferredName: 'Trevor',
    },
    id: 336,
    publisherSelectedEmployees: [
      {
        label: 'Phillip Nelson',
        subTitle: 'phillip.nelson@abc.co',
        profilePhoto: null,
        id: 16354,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sandra Gilbert',
        subTitle: 'sandra.gilbert@abc.co',
        profilePhoto: null,
        id: 16260,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'James Howard',
        subTitle: 'james.howard@abc.co',
        profilePhoto: null,
        id: 16236,
      },
    ],
  },
  {
    employee: {
      id: 16137,
      companyId: 3,
      displayName: 'Marissa Webster',
      designation: 'Firefighter',
      ownerType: null,
      employeeFunction: null,
      email: 'marissa.webster@abc.co',
      personalEmail: 'marissa.webster@abc.co',
      workEmail: 'marissa.webster@abc.co',
      preferredName: 'Marissa',
    },
    id: 337,
    publisherSelectedEmployees: [
      {
        label: 'Maria Jones',
        subTitle: 'maria.jones@abc.co',
        profilePhoto: null,
        id: 16334,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'David Scott',
        subTitle: 'david.scott@abc.co',
        profilePhoto: null,
        id: 16231,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Samantha Bentley',
        subTitle: 'samantha.bentley@abc.co',
        profilePhoto: null,
        id: 16252,
      },
    ],
  },
  {
    employee: {
      id: 16138,
      companyId: 1,
      displayName: 'Alex Hernandez',
      designation: 'Computer games developer',
      ownerType: null,
      employeeFunction: null,
      email: 'alex.hernandez@abc.co',
      personalEmail: 'alex.hernandez@abc.co',
      workEmail: 'alex.hernandez@abc.co',
      preferredName: 'Alex',
    },
    id: 338,
    publisherSelectedEmployees: [
      {
        label: 'Eric Nguyen',
        subTitle: 'eric.nguyen@abc.co',
        profilePhoto: null,
        id: 16299,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Matthew Hoover',
        subTitle: 'matthew.hoover@abc.co',
        profilePhoto: null,
        id: 16217,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Stephanie Hughes',
        subTitle: 'stephanie.hughes@abc.co',
        profilePhoto: null,
        id: 16381,
      },
    ],
  },
  {
    employee: {
      id: 16139,
      companyId: 2,
      displayName: 'Brian Gould',
      designation: 'Psychologist, occupational',
      ownerType: null,
      employeeFunction: null,
      email: 'brian.gould@abc.co',
      personalEmail: 'brian.gould@abc.co',
      workEmail: 'brian.gould@abc.co',
      preferredName: 'Brian',
    },
    id: 339,
    publisherSelectedEmployees: [
      {
        label: 'Ross Price',
        subTitle: 'ross.price@abc.co',
        profilePhoto: null,
        id: 16124,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sandra Aguilar',
        subTitle: 'sandra.aguilar@abc.co',
        profilePhoto: null,
        id: 16080,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kathleen Aguilar',
        subTitle: 'kathleen.aguilar@abc.co',
        profilePhoto: null,
        id: 16230,
      },
    ],
  },
  {
    employee: {
      id: 16140,
      companyId: 3,
      displayName: 'Pamela Jackson',
      designation: 'Training and development officer',
      ownerType: null,
      employeeFunction: null,
      email: 'pamela.jackson@abc.co',
      personalEmail: 'pamela.jackson@abc.co',
      workEmail: 'pamela.jackson@abc.co',
      preferredName: 'Pamela',
    },
    id: 340,
    publisherSelectedEmployees: [
      {
        label: 'David Thompson',
        subTitle: 'david.thompson@abc.co',
        profilePhoto: null,
        id: 16319,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sandra Drake',
        subTitle: 'sandra.drake@abc.co',
        profilePhoto: null,
        id: 16308,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jeremy Reed',
        subTitle: 'jeremy.reed@abc.co',
        profilePhoto: null,
        id: 16233,
      },
    ],
  },
  {
    employee: {
      id: 16141,
      companyId: 1,
      displayName: 'Michelle Strickland',
      designation: 'Development worker, community',
      ownerType: null,
      employeeFunction: null,
      email: 'michelle.strickland@abc.co',
      personalEmail: 'michelle.strickland@abc.co',
      workEmail: 'michelle.strickland@abc.co',
      preferredName: 'Michelle',
    },
    id: 341,
    publisherSelectedEmployees: [
      {
        label: 'Justin Riley',
        subTitle: 'justin.riley@abc.co',
        profilePhoto: null,
        id: 16321,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brittney Campbell',
        subTitle: 'brittney.campbell@abc.co',
        profilePhoto: null,
        id: 16073,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Cynthia Rowe',
        subTitle: 'cynthia.rowe@abc.co',
        profilePhoto: null,
        id: 16215,
      },
    ],
  },
  {
    employee: {
      id: 16142,
      companyId: 2,
      displayName: 'Ashley Johnson',
      designation: 'Insurance underwriter',
      ownerType: null,
      employeeFunction: null,
      email: 'ashley.johnson@abc.co',
      personalEmail: 'ashley.johnson@abc.co',
      workEmail: 'ashley.johnson@abc.co',
      preferredName: 'Ashley',
    },
    id: 342,
    publisherSelectedEmployees: [
      {
        label: 'Elizabeth Ward',
        subTitle: 'elizabeth.ward@abc.co',
        profilePhoto: null,
        id: 16167,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christopher Thomas',
        subTitle: 'christopher.thomas@abc.co',
        profilePhoto: null,
        id: 16296,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Justin Baxter',
        subTitle: 'justin.baxter@abc.co',
        profilePhoto: null,
        id: 16083,
      },
    ],
  },
  {
    employee: {
      id: 16143,
      companyId: 3,
      displayName: 'Susan Brooks',
      designation: 'Engineer, civil (contracting)',
      ownerType: null,
      employeeFunction: null,
      email: 'susan.brooks@abc.co',
      personalEmail: 'susan.brooks@abc.co',
      workEmail: 'susan.brooks@abc.co',
      preferredName: 'Susan',
    },
    id: 343,
    publisherSelectedEmployees: [
      {
        label: 'James Lewis',
        subTitle: 'james.lewis@abc.co',
        profilePhoto: null,
        id: 16133,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Zachary Moore',
        subTitle: 'zachary.moore@abc.co',
        profilePhoto: null,
        id: 16342,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Matthew Miller',
        subTitle: 'matthew.miller@abc.co',
        profilePhoto: null,
        id: 16368,
      },
    ],
  },
  {
    employee: {
      id: 16144,
      companyId: 1,
      displayName: 'Michael Burton',
      designation: 'Civil engineer, consulting',
      ownerType: null,
      employeeFunction: null,
      email: 'michael.burton@abc.co',
      personalEmail: 'michael.burton@abc.co',
      workEmail: 'michael.burton@abc.co',
      preferredName: 'Michael',
    },
    id: 344,
    publisherSelectedEmployees: [
      {
        label: 'Terry Coffey',
        subTitle: 'terry.coffey@abc.co',
        profilePhoto: null,
        id: 16247,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jonathan Young',
        subTitle: 'jonathan.young@abc.co',
        profilePhoto: null,
        id: 16357,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Ashley Wise',
        subTitle: 'ashley.wise@abc.co',
        profilePhoto: null,
        id: 16343,
      },
    ],
  },
  {
    employee: {
      id: 16145,
      companyId: 2,
      displayName: 'Elizabeth Sutton',
      designation: 'Community arts worker',
      ownerType: null,
      employeeFunction: null,
      email: 'elizabeth.sutton@abc.co',
      personalEmail: 'elizabeth.sutton@abc.co',
      workEmail: 'elizabeth.sutton@abc.co',
      preferredName: 'Elizabeth',
    },
    id: 345,
    publisherSelectedEmployees: [
      {
        label: 'Zachary Taylor',
        subTitle: 'zachary.taylor@abc.co',
        profilePhoto: null,
        id: 16022,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Lisa Gibbs',
        subTitle: 'lisa.gibbs@abc.co',
        profilePhoto: null,
        id: 16175,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Charles Pitts',
        subTitle: 'charles.pitts@abc.co',
        profilePhoto: null,
        id: 16220,
      },
    ],
  },
  {
    employee: {
      id: 16146,
      companyId: 3,
      displayName: 'Kylie Williams',
      designation: 'Site engineer',
      ownerType: null,
      employeeFunction: null,
      email: 'kylie.williams@abc.co',
      personalEmail: 'kylie.williams@abc.co',
      workEmail: 'kylie.williams@abc.co',
      preferredName: 'Kylie',
    },
    id: 346,
    publisherSelectedEmployees: [
      {
        label: 'Richard Camacho',
        subTitle: 'richard.camacho@abc.co',
        profilePhoto: null,
        id: 16275,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Betty Alvarez',
        subTitle: 'betty.alvarez@abc.co',
        profilePhoto: null,
        id: 16036,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Scott Pierce',
        subTitle: 'scott.pierce@abc.co',
        profilePhoto: null,
        id: 16051,
      },
    ],
  },
  {
    employee: {
      id: 16147,
      companyId: 1,
      displayName: 'Jacob Hunter',
      designation: 'Licensed conveyancer',
      ownerType: null,
      employeeFunction: null,
      email: 'jacob.hunter@abc.co',
      personalEmail: 'jacob.hunter@abc.co',
      workEmail: 'jacob.hunter@abc.co',
      preferredName: 'Jacob',
    },
    id: 347,
    publisherSelectedEmployees: [
      {
        label: 'Edward Burgess',
        subTitle: 'edward.burgess@abc.co',
        profilePhoto: null,
        id: 16244,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Frederick Tate',
        subTitle: 'frederick.tate@abc.co',
        profilePhoto: null,
        id: 16016,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Ms. Rebecca Rodriguez',
        subTitle: 'ms..rebecca.rodriguez@abc.co',
        profilePhoto: null,
        id: 16270,
      },
    ],
  },
  {
    employee: {
      id: 16148,
      companyId: 2,
      displayName: 'Jason Henry',
      designation: 'Police officer',
      ownerType: null,
      employeeFunction: null,
      email: 'jason.henry@abc.co',
      personalEmail: 'jason.henry@abc.co',
      workEmail: 'jason.henry@abc.co',
      preferredName: 'Jason',
    },
    id: 348,
    publisherSelectedEmployees: [
      {
        label: 'Stacey Arias',
        subTitle: 'stacey.arias@abc.co',
        profilePhoto: null,
        id: 16356,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Marie Christian',
        subTitle: 'marie.christian@abc.co',
        profilePhoto: null,
        id: 16222,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Patricia Peterson',
        subTitle: 'patricia.peterson@abc.co',
        profilePhoto: null,
        id: 16027,
      },
    ],
  },
  {
    employee: {
      id: 16149,
      companyId: 3,
      displayName: 'Madison Poole',
      designation: 'Designer, ceramics/pottery',
      ownerType: null,
      employeeFunction: null,
      email: 'madison.poole@abc.co',
      personalEmail: 'madison.poole@abc.co',
      workEmail: 'madison.poole@abc.co',
      preferredName: 'Madison',
    },
    id: 349,
    publisherSelectedEmployees: [
      {
        label: 'Andrea Martin',
        subTitle: 'andrea.martin@abc.co',
        profilePhoto: null,
        id: 16185,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brittney Campbell',
        subTitle: 'brittney.campbell@abc.co',
        profilePhoto: null,
        id: 16073,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Samuel White',
        subTitle: 'samuel.white@abc.co',
        profilePhoto: null,
        id: 16155,
      },
    ],
  },
  {
    employee: {
      id: 16150,
      companyId: 1,
      displayName: 'Nicholas Sheppard',
      designation: 'Geophysicist/field seismologist',
      ownerType: null,
      employeeFunction: null,
      email: 'nicholas.sheppard@abc.co',
      personalEmail: 'nicholas.sheppard@abc.co',
      workEmail: 'nicholas.sheppard@abc.co',
      preferredName: 'Nicholas',
    },
    id: 350,
    publisherSelectedEmployees: [
      {
        label: 'Katherine Miller',
        subTitle: 'katherine.miller@abc.co',
        profilePhoto: null,
        id: 16188,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brandy Wilson',
        subTitle: 'brandy.wilson@abc.co',
        profilePhoto: null,
        id: 16072,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Mark Cox',
        subTitle: 'mark.cox@abc.co',
        profilePhoto: null,
        id: 16388,
      },
    ],
  },
  {
    employee: {
      id: 16151,
      companyId: 2,
      displayName: 'Tamara Hampton',
      designation: 'Psychologist, occupational',
      ownerType: null,
      employeeFunction: null,
      email: 'tamara.hampton@abc.co',
      personalEmail: 'tamara.hampton@abc.co',
      workEmail: 'tamara.hampton@abc.co',
      preferredName: 'Tamara',
    },
    id: 351,
    publisherSelectedEmployees: [
      {
        label: 'Charles Pitts',
        subTitle: 'charles.pitts@abc.co',
        profilePhoto: null,
        id: 16220,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Carlos Whitney',
        subTitle: 'carlos.whitney@abc.co',
        profilePhoto: null,
        id: 16077,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Phillip Nelson',
        subTitle: 'phillip.nelson@abc.co',
        profilePhoto: null,
        id: 16354,
      },
    ],
  },
  {
    employee: {
      id: 16152,
      companyId: 3,
      displayName: 'Nicholas Adams',
      designation: 'Financial trader',
      ownerType: null,
      employeeFunction: null,
      email: 'nicholas.adams@abc.co',
      personalEmail: 'nicholas.adams@abc.co',
      workEmail: 'nicholas.adams@abc.co',
      preferredName: 'Nicholas',
    },
    id: 352,
    publisherSelectedEmployees: [
      {
        label: 'Brenda Lawson',
        subTitle: 'brenda.lawson@abc.co',
        profilePhoto: null,
        id: 16389,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'James Howard',
        subTitle: 'james.howard@abc.co',
        profilePhoto: null,
        id: 16236,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jennifer Brown',
        subTitle: 'jennifer.brown@abc.co',
        profilePhoto: null,
        id: 16024,
      },
    ],
  },
  {
    employee: {
      id: 16153,
      companyId: 1,
      displayName: 'Angelica Keith',
      designation: 'Financial planner',
      ownerType: null,
      employeeFunction: null,
      email: 'angelica.keith@abc.co',
      personalEmail: 'angelica.keith@abc.co',
      workEmail: 'angelica.keith@abc.co',
      preferredName: 'Angelica',
    },
    id: 353,
    publisherSelectedEmployees: [
      {
        label: 'Sherry Shields',
        subTitle: 'sherry.shields@abc.co',
        profilePhoto: null,
        id: 16209,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Aaron Barber',
        subTitle: 'aaron.barber@abc.co',
        profilePhoto: null,
        id: 16211,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Anthony Howard',
        subTitle: 'anthony.howard@abc.co',
        profilePhoto: null,
        id: 16227,
      },
    ],
  },
  {
    employee: {
      id: 16154,
      companyId: 2,
      displayName: 'Laura Barnett',
      designation: 'Legal secretary',
      ownerType: null,
      employeeFunction: null,
      email: 'laura.barnett@abc.co',
      personalEmail: 'laura.barnett@abc.co',
      workEmail: 'laura.barnett@abc.co',
      preferredName: 'Laura',
    },
    id: 354,
    publisherSelectedEmployees: [
      {
        label: 'Carlos Whitney',
        subTitle: 'carlos.whitney@abc.co',
        profilePhoto: null,
        id: 16077,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christina Walters',
        subTitle: 'christina.walters@abc.co',
        profilePhoto: null,
        id: 16074,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Ronald Ross',
        subTitle: 'ronald.ross@abc.co',
        profilePhoto: null,
        id: 16283,
      },
    ],
  },
  {
    employee: {
      id: 16155,
      companyId: 3,
      displayName: 'Samuel White',
      designation: 'Engineer, petroleum',
      ownerType: null,
      employeeFunction: null,
      email: 'samuel.white@abc.co',
      personalEmail: 'samuel.white@abc.co',
      workEmail: 'samuel.white@abc.co',
      preferredName: 'Samuel',
    },
    id: 355,
    publisherSelectedEmployees: [
      {
        label: 'David Martinez',
        subTitle: 'david.martinez@abc.co',
        profilePhoto: null,
        id: 16163,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kristin Lynch',
        subTitle: 'kristin.lynch@abc.co',
        profilePhoto: null,
        id: 16294,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Mr. Donald Fischer',
        subTitle: 'mr..donald.fischer@abc.co',
        profilePhoto: null,
        id: 16302,
      },
    ],
  },
  {
    employee: {
      id: 16156,
      companyId: 1,
      displayName: 'David Ramirez',
      designation: 'Therapist, occupational',
      ownerType: null,
      employeeFunction: null,
      email: 'david.ramirez@abc.co',
      personalEmail: 'david.ramirez@abc.co',
      workEmail: 'david.ramirez@abc.co',
      preferredName: 'David',
    },
    id: 356,
    publisherSelectedEmployees: [
      {
        label: 'Brittney Campbell',
        subTitle: 'brittney.campbell@abc.co',
        profilePhoto: null,
        id: 16073,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Aaron Bell',
        subTitle: 'aaron.bell@abc.co',
        profilePhoto: null,
        id: 16126,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Melissa Martinez',
        subTitle: 'melissa.martinez@abc.co',
        profilePhoto: null,
        id: 16169,
      },
    ],
  },
  {
    employee: {
      id: 16157,
      companyId: 2,
      displayName: 'Desiree Smith',
      designation: 'Engineer, aeronautical',
      ownerType: null,
      employeeFunction: null,
      email: 'desiree.smith@abc.co',
      personalEmail: 'desiree.smith@abc.co',
      workEmail: 'desiree.smith@abc.co',
      preferredName: 'Desiree',
    },
    id: 357,
    publisherSelectedEmployees: [
      {
        label: 'Samantha Bentley',
        subTitle: 'samantha.bentley@abc.co',
        profilePhoto: null,
        id: 16252,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kara Davis',
        subTitle: 'kara.davis@abc.co',
        profilePhoto: null,
        id: 16285,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Ariana Jennings',
        subTitle: 'ariana.jennings@abc.co',
        profilePhoto: null,
        id: 16262,
      },
    ],
  },
  {
    employee: {
      id: 16158,
      companyId: 3,
      displayName: 'Nathan Freeman',
      designation: 'Financial adviser',
      ownerType: null,
      employeeFunction: null,
      email: 'nathan.freeman@abc.co',
      personalEmail: 'nathan.freeman@abc.co',
      workEmail: 'nathan.freeman@abc.co',
      preferredName: 'Nathan',
    },
    id: 358,
    publisherSelectedEmployees: [
      {
        label: 'Sandra Drake',
        subTitle: 'sandra.drake@abc.co',
        profilePhoto: null,
        id: 16308,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brittney Campbell',
        subTitle: 'brittney.campbell@abc.co',
        profilePhoto: null,
        id: 16073,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Mary Martinez',
        subTitle: 'mary.martinez@abc.co',
        profilePhoto: null,
        id: 16100,
      },
    ],
  },
  {
    employee: {
      id: 16159,
      companyId: 1,
      displayName: 'Maria Henry',
      designation: 'Adult guidance worker',
      ownerType: null,
      employeeFunction: null,
      email: 'maria.henry@abc.co',
      personalEmail: 'maria.henry@abc.co',
      workEmail: 'maria.henry@abc.co',
      preferredName: 'Maria',
    },
    id: 359,
    publisherSelectedEmployees: [
      {
        label: 'Joel Baxter',
        subTitle: 'joel.baxter@abc.co',
        profilePhoto: null,
        id: 16050,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Patrick Tapia',
        subTitle: 'patrick.tapia@abc.co',
        profilePhoto: null,
        id: 16164,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Natasha Wall',
        subTitle: 'natasha.wall@abc.co',
        profilePhoto: null,
        id: 16239,
      },
    ],
  },
  {
    employee: {
      id: 16160,
      companyId: 2,
      displayName: 'Daniel Holt',
      designation: 'Information officer',
      ownerType: null,
      employeeFunction: null,
      email: 'daniel.holt@abc.co',
      personalEmail: 'daniel.holt@abc.co',
      workEmail: 'daniel.holt@abc.co',
      preferredName: 'Daniel',
    },
    id: 360,
    publisherSelectedEmployees: [
      {
        label: 'Jacob Ramos',
        subTitle: 'jacob.ramos@abc.co',
        profilePhoto: null,
        id: 16261,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Joseph Knight',
        subTitle: 'joseph.knight@abc.co',
        profilePhoto: null,
        id: 16228,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Joel Baxter',
        subTitle: 'joel.baxter@abc.co',
        profilePhoto: null,
        id: 16050,
      },
    ],
  },
  {
    employee: {
      id: 16161,
      companyId: 3,
      displayName: 'Jackie Tran',
      designation: 'Local government officer',
      ownerType: null,
      employeeFunction: null,
      email: 'jackie.tran@abc.co',
      personalEmail: 'jackie.tran@abc.co',
      workEmail: 'jackie.tran@abc.co',
      preferredName: 'Jackie',
    },
    id: 361,
    publisherSelectedEmployees: [
      {
        label: 'Richard Baker',
        subTitle: 'richard.baker@abc.co',
        profilePhoto: null,
        id: 16221,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Daniel Adams',
        subTitle: 'daniel.adams@abc.co',
        profilePhoto: null,
        id: 16013,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Krista Gibson',
        subTitle: 'krista.gibson@abc.co',
        profilePhoto: null,
        id: 16197,
      },
    ],
  },
  {
    employee: {
      id: 16162,
      companyId: 1,
      displayName: 'Patrick Rivera',
      designation: 'Professor Emeritus',
      ownerType: null,
      employeeFunction: null,
      email: 'patrick.rivera@abc.co',
      personalEmail: 'patrick.rivera@abc.co',
      workEmail: 'patrick.rivera@abc.co',
      preferredName: 'Patrick',
    },
    id: 362,
    publisherSelectedEmployees: [
      {
        label: 'Mark Cox',
        subTitle: 'mark.cox@abc.co',
        profilePhoto: null,
        id: 16388,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Daniel Fowler',
        subTitle: 'daniel.fowler@abc.co',
        profilePhoto: null,
        id: 16265,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jessica Fox',
        subTitle: 'jessica.fox@abc.co',
        profilePhoto: null,
        id: 16219,
      },
    ],
  },
  {
    employee: {
      id: 16163,
      companyId: 2,
      displayName: 'David Martinez',
      designation: 'Engineer, automotive',
      ownerType: null,
      employeeFunction: null,
      email: 'david.martinez@abc.co',
      personalEmail: 'david.martinez@abc.co',
      workEmail: 'david.martinez@abc.co',
      preferredName: 'David',
    },
    id: 363,
    publisherSelectedEmployees: [
      {
        label: 'Mr. Jeremiah Reeves',
        subTitle: 'mr..jeremiah.reeves@abc.co',
        profilePhoto: null,
        id: 16120,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jerry Ramirez',
        subTitle: 'jerry.ramirez@abc.co',
        profilePhoto: null,
        id: 16004,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Cody Williams',
        subTitle: 'cody.williams@abc.co',
        profilePhoto: null,
        id: 16171,
      },
    ],
  },
  {
    employee: {
      id: 16164,
      companyId: 3,
      displayName: 'Patrick Tapia',
      designation: 'Electrical engineer',
      ownerType: null,
      employeeFunction: null,
      email: 'patrick.tapia@abc.co',
      personalEmail: 'patrick.tapia@abc.co',
      workEmail: 'patrick.tapia@abc.co',
      preferredName: 'Patrick',
    },
    id: 364,
    publisherSelectedEmployees: [
      {
        label: 'Sherry Shields',
        subTitle: 'sherry.shields@abc.co',
        profilePhoto: null,
        id: 16209,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Stephanie Gilbert',
        subTitle: 'stephanie.gilbert@abc.co',
        profilePhoto: null,
        id: 16103,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Marcus Richards',
        subTitle: 'marcus.richards@abc.co',
        profilePhoto: null,
        id: 16279,
      },
    ],
  },
  {
    employee: {
      id: 16165,
      companyId: 1,
      displayName: 'Parker Hill',
      designation: 'Theme park manager',
      ownerType: null,
      employeeFunction: null,
      email: 'parker.hill@abc.co',
      personalEmail: 'parker.hill@abc.co',
      workEmail: 'parker.hill@abc.co',
      preferredName: 'Parker',
    },
    id: 365,
    publisherSelectedEmployees: [
      {
        label: 'Tamara Hampton',
        subTitle: 'tamara.hampton@abc.co',
        profilePhoto: null,
        id: 16151,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kylie Williams',
        subTitle: 'kylie.williams@abc.co',
        profilePhoto: null,
        id: 16146,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Michael Brooks',
        subTitle: 'michael.brooks@abc.co',
        profilePhoto: null,
        id: 16039,
      },
    ],
  },
  {
    employee: {
      id: 16166,
      companyId: 2,
      displayName: 'Kelly Campbell',
      designation: 'Chiropodist',
      ownerType: null,
      employeeFunction: null,
      email: 'kelly.campbell@abc.co',
      personalEmail: 'kelly.campbell@abc.co',
      workEmail: 'kelly.campbell@abc.co',
      preferredName: 'Kelly',
    },
    id: 366,
    publisherSelectedEmployees: [
      {
        label: 'Christopher Dixon',
        subTitle: 'christopher.dixon@abc.co',
        profilePhoto: null,
        id: 16316,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Terry Coffey',
        subTitle: 'terry.coffey@abc.co',
        profilePhoto: null,
        id: 16247,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Nathan Freeman',
        subTitle: 'nathan.freeman@abc.co',
        profilePhoto: null,
        id: 16158,
      },
    ],
  },
  {
    employee: {
      id: 16167,
      companyId: 3,
      displayName: 'Elizabeth Ward',
      designation: 'Immigration officer',
      ownerType: null,
      employeeFunction: null,
      email: 'elizabeth.ward@abc.co',
      personalEmail: 'elizabeth.ward@abc.co',
      workEmail: 'elizabeth.ward@abc.co',
      preferredName: 'Elizabeth',
    },
    id: 367,
    publisherSelectedEmployees: [
      {
        label: 'Justin Riley',
        subTitle: 'justin.riley@abc.co',
        profilePhoto: null,
        id: 16321,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christina Walters',
        subTitle: 'christina.walters@abc.co',
        profilePhoto: null,
        id: 16074,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Shawn Ramirez',
        subTitle: 'shawn.ramirez@abc.co',
        profilePhoto: null,
        id: 16134,
      },
    ],
  },
  {
    employee: {
      id: 16168,
      companyId: 1,
      displayName: 'Joseph Hill',
      designation: 'Audiological scientist',
      ownerType: null,
      employeeFunction: null,
      email: 'joseph.hill@abc.co',
      personalEmail: 'joseph.hill@abc.co',
      workEmail: 'joseph.hill@abc.co',
      preferredName: 'Joseph',
    },
    id: 368,
    publisherSelectedEmployees: [
      {
        label: 'Lisa Byrd',
        subTitle: 'lisa.byrd@abc.co',
        profilePhoto: null,
        id: 16241,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Tiffany Barnes',
        subTitle: 'tiffany.barnes@abc.co',
        profilePhoto: null,
        id: 16127,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Wesley White',
        subTitle: 'wesley.white@abc.co',
        profilePhoto: null,
        id: 16094,
      },
    ],
  },
  {
    employee: {
      id: 16169,
      companyId: 2,
      displayName: 'Melissa Martinez',
      designation: 'Recycling officer',
      ownerType: null,
      employeeFunction: null,
      email: 'melissa.martinez@abc.co',
      personalEmail: 'melissa.martinez@abc.co',
      workEmail: 'melissa.martinez@abc.co',
      preferredName: 'Melissa',
    },
    id: 369,
    publisherSelectedEmployees: [
      {
        label: 'Emily Douglas',
        subTitle: 'emily.douglas@abc.co',
        profilePhoto: null,
        id: 16337,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michael Brooks',
        subTitle: 'michael.brooks@abc.co',
        profilePhoto: null,
        id: 16039,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Daniel Holt',
        subTitle: 'daniel.holt@abc.co',
        profilePhoto: null,
        id: 16160,
      },
    ],
  },
  {
    employee: {
      id: 16170,
      companyId: 3,
      displayName: 'Adam Mitchell',
      designation: 'Quality manager',
      ownerType: null,
      employeeFunction: null,
      email: 'adam.mitchell@abc.co',
      personalEmail: 'adam.mitchell@abc.co',
      workEmail: 'adam.mitchell@abc.co',
      preferredName: 'Adam',
    },
    id: 370,
    publisherSelectedEmployees: [
      {
        label: 'Devin Schaefer',
        subTitle: 'devin.schaefer@abc.co',
        profilePhoto: null,
        id: 16015,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christopher Hensley',
        subTitle: 'christopher.hensley@abc.co',
        profilePhoto: null,
        id: 16118,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'David Bradley',
        subTitle: 'david.bradley@abc.co',
        profilePhoto: null,
        id: 16034,
      },
    ],
  },
  {
    employee: {
      id: 16171,
      companyId: 1,
      displayName: 'Cody Williams',
      designation: 'Purchasing manager',
      ownerType: null,
      employeeFunction: null,
      email: 'cody.williams@abc.co',
      personalEmail: 'cody.williams@abc.co',
      workEmail: 'cody.williams@abc.co',
      preferredName: 'Cody',
    },
    id: 371,
    publisherSelectedEmployees: [
      {
        label: 'Angelica Keith',
        subTitle: 'angelica.keith@abc.co',
        profilePhoto: null,
        id: 16153,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Richard Glenn',
        subTitle: 'richard.glenn@abc.co',
        profilePhoto: null,
        id: 16379,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Patrick Rivera',
        subTitle: 'patrick.rivera@abc.co',
        profilePhoto: null,
        id: 16162,
      },
    ],
  },
  {
    employee: {
      id: 16172,
      companyId: 2,
      displayName: 'Austin Vasquez',
      designation: 'Technical author',
      ownerType: null,
      employeeFunction: null,
      email: 'austin.vasquez@abc.co',
      personalEmail: 'austin.vasquez@abc.co',
      workEmail: 'austin.vasquez@abc.co',
      preferredName: 'Austin',
    },
    id: 372,
    publisherSelectedEmployees: [
      {
        label: 'David Walsh',
        subTitle: 'david.walsh@abc.co',
        profilePhoto: null,
        id: 16119,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Ronald Ross',
        subTitle: 'ronald.ross@abc.co',
        profilePhoto: null,
        id: 16283,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Michael Berger',
        subTitle: 'michael.berger@abc.co',
        profilePhoto: null,
        id: 16226,
      },
    ],
  },
  {
    employee: {
      id: 16173,
      companyId: 3,
      displayName: 'Amy Hernandez',
      designation: 'Surveyor, quantity',
      ownerType: null,
      employeeFunction: null,
      email: 'amy.hernandez@abc.co',
      personalEmail: 'amy.hernandez@abc.co',
      workEmail: 'amy.hernandez@abc.co',
      preferredName: 'Amy',
    },
    id: 373,
    publisherSelectedEmployees: [
      {
        label: 'Alfred Galvan',
        subTitle: 'alfred.galvan@abc.co',
        profilePhoto: null,
        id: 16358,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Alex Hernandez',
        subTitle: 'alex.hernandez@abc.co',
        profilePhoto: null,
        id: 16138,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Michael Brooks',
        subTitle: 'michael.brooks@abc.co',
        profilePhoto: null,
        id: 16039,
      },
    ],
  },
  {
    employee: {
      id: 16174,
      companyId: 1,
      displayName: 'Angela Wright',
      designation: 'Surveyor, insurance',
      ownerType: null,
      employeeFunction: null,
      email: 'angela.wright@abc.co',
      personalEmail: 'angela.wright@abc.co',
      workEmail: 'angela.wright@abc.co',
      preferredName: 'Angela',
    },
    id: 374,
    publisherSelectedEmployees: [
      {
        label: 'Allen Rogers',
        subTitle: 'allen.rogers@abc.co',
        profilePhoto: null,
        id: 16129,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Scott Pierce',
        subTitle: 'scott.pierce@abc.co',
        profilePhoto: null,
        id: 16051,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jessica Fowler',
        subTitle: 'jessica.fowler@abc.co',
        profilePhoto: null,
        id: 16387,
      },
    ],
  },
  {
    employee: {
      id: 16175,
      companyId: 2,
      displayName: 'Lisa Gibbs',
      designation: 'Equities trader',
      ownerType: null,
      employeeFunction: null,
      email: 'lisa.gibbs@abc.co',
      personalEmail: 'lisa.gibbs@abc.co',
      workEmail: 'lisa.gibbs@abc.co',
      preferredName: 'Lisa',
    },
    id: 375,
    publisherSelectedEmployees: [
      {
        label: 'Daniel Adams',
        subTitle: 'daniel.adams@abc.co',
        profilePhoto: null,
        id: 16013,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brian Gould',
        subTitle: 'brian.gould@abc.co',
        profilePhoto: null,
        id: 16139,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Cynthia Rowe',
        subTitle: 'cynthia.rowe@abc.co',
        profilePhoto: null,
        id: 16215,
      },
    ],
  },
  {
    employee: {
      id: 16176,
      companyId: 3,
      displayName: 'Jamie Kerr',
      designation: 'Human resources officer',
      ownerType: null,
      employeeFunction: null,
      email: 'jamie.kerr@abc.co',
      personalEmail: 'jamie.kerr@abc.co',
      workEmail: 'jamie.kerr@abc.co',
      preferredName: 'Jamie',
    },
    id: 376,
    publisherSelectedEmployees: [
      {
        label: 'George Miranda',
        subTitle: 'george.miranda@abc.co',
        profilePhoto: null,
        id: 16344,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Justin Lowery',
        subTitle: 'justin.lowery@abc.co',
        profilePhoto: null,
        id: 16114,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Christine Wright',
        subTitle: 'christine.wright@abc.co',
        profilePhoto: null,
        id: 16082,
      },
    ],
  },
  {
    employee: {
      id: 16177,
      companyId: 1,
      displayName: 'Wanda Torres',
      designation: 'Web designer',
      ownerType: null,
      employeeFunction: null,
      email: 'wanda.torres@abc.co',
      personalEmail: 'wanda.torres@abc.co',
      workEmail: 'wanda.torres@abc.co',
      preferredName: 'Wanda',
    },
    id: 377,
    publisherSelectedEmployees: [
      {
        label: 'Dwayne Gilmore',
        subTitle: 'dwayne.gilmore@abc.co',
        profilePhoto: null,
        id: 16202,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Bradley Smith',
        subTitle: 'bradley.smith@abc.co',
        profilePhoto: null,
        id: 16135,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Julie Roberts',
        subTitle: 'julie.roberts@abc.co',
        profilePhoto: null,
        id: 16232,
      },
    ],
  },
  {
    employee: {
      id: 16178,
      companyId: 2,
      displayName: 'Tyler Garcia',
      designation: 'Engineer, maintenance (IT)',
      ownerType: null,
      employeeFunction: null,
      email: 'tyler.garcia@abc.co',
      personalEmail: 'tyler.garcia@abc.co',
      workEmail: 'tyler.garcia@abc.co',
      preferredName: 'Tyler',
    },
    id: 378,
    publisherSelectedEmployees: [
      {
        label: 'Lisa Gibbs',
        subTitle: 'lisa.gibbs@abc.co',
        profilePhoto: null,
        id: 16175,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Shannon Johnston',
        subTitle: 'shannon.johnston@abc.co',
        profilePhoto: null,
        id: 16310,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Joshua Turner',
        subTitle: 'joshua.turner@abc.co',
        profilePhoto: null,
        id: 16070,
      },
    ],
  },
  {
    employee: {
      id: 16179,
      companyId: 3,
      displayName: 'Deborah Miller',
      designation: 'Film/video editor',
      ownerType: null,
      employeeFunction: null,
      email: 'deborah.miller@abc.co',
      personalEmail: 'deborah.miller@abc.co',
      workEmail: 'deborah.miller@abc.co',
      preferredName: 'Deborah',
    },
    id: 379,
    publisherSelectedEmployees: [
      {
        label: 'Olivia Harris',
        subTitle: 'olivia.harris@abc.co',
        profilePhoto: null,
        id: 16201,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Caitlin Henderson',
        subTitle: 'caitlin.henderson@abc.co',
        profilePhoto: null,
        id: 16005,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'David Sheppard',
        subTitle: 'david.sheppard@abc.co',
        profilePhoto: null,
        id: 16348,
      },
    ],
  },
  {
    employee: {
      id: 16180,
      companyId: 1,
      displayName: 'Benjamin Smith',
      designation: 'Production designer, theatre/television/film',
      ownerType: null,
      employeeFunction: null,
      email: 'benjamin.smith@abc.co',
      personalEmail: 'benjamin.smith@abc.co',
      workEmail: 'benjamin.smith@abc.co',
      preferredName: 'Benjamin',
    },
    id: 380,
    publisherSelectedEmployees: [
      {
        label: 'Christopher Williams',
        subTitle: 'christopher.williams@abc.co',
        profilePhoto: null,
        id: 16272,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jeffrey Potts',
        subTitle: 'jeffrey.potts@abc.co',
        profilePhoto: null,
        id: 16355,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Vanessa Cardenas',
        subTitle: 'vanessa.cardenas@abc.co',
        profilePhoto: null,
        id: 16293,
      },
    ],
  },
  {
    employee: {
      id: 16181,
      companyId: 2,
      displayName: 'Julie Johnson',
      designation: 'Homeopath',
      ownerType: null,
      employeeFunction: null,
      email: 'julie.johnson@abc.co',
      personalEmail: 'julie.johnson@abc.co',
      workEmail: 'julie.johnson@abc.co',
      preferredName: 'Julie',
    },
    id: 381,
    publisherSelectedEmployees: [
      {
        label: 'Angela Wright',
        subTitle: 'angela.wright@abc.co',
        profilePhoto: null,
        id: 16174,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Austin Vasquez',
        subTitle: 'austin.vasquez@abc.co',
        profilePhoto: null,
        id: 16172,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Gary Santiago',
        subTitle: 'gary.santiago@abc.co',
        profilePhoto: null,
        id: 16195,
      },
    ],
  },
  {
    employee: {
      id: 16182,
      companyId: 3,
      displayName: 'Michele Gibson',
      designation: 'Facilities manager',
      ownerType: null,
      employeeFunction: null,
      email: 'michele.gibson@abc.co',
      personalEmail: 'michele.gibson@abc.co',
      workEmail: 'michele.gibson@abc.co',
      preferredName: 'Michele',
    },
    id: 382,
    publisherSelectedEmployees: [
      {
        label: 'Devin Schaefer',
        subTitle: 'devin.schaefer@abc.co',
        profilePhoto: null,
        id: 16015,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Victor Vaughn',
        subTitle: 'victor.vaughn@abc.co',
        profilePhoto: null,
        id: 16234,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Emily Douglas',
        subTitle: 'emily.douglas@abc.co',
        profilePhoto: null,
        id: 16337,
      },
    ],
  },
  {
    employee: {
      id: 16183,
      companyId: 1,
      displayName: 'Rachel Weber',
      designation: 'Engineer, civil (consulting)',
      ownerType: null,
      employeeFunction: null,
      email: 'rachel.weber@abc.co',
      personalEmail: 'rachel.weber@abc.co',
      workEmail: 'rachel.weber@abc.co',
      preferredName: 'Rachel',
    },
    id: 383,
    publisherSelectedEmployees: [
      {
        label: 'Kaitlyn Harvey',
        subTitle: 'kaitlyn.harvey@abc.co',
        profilePhoto: null,
        id: 16253,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michael Lyons',
        subTitle: 'michael.lyons@abc.co',
        profilePhoto: null,
        id: 16187,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Donna Wilson',
        subTitle: 'donna.wilson@abc.co',
        profilePhoto: null,
        id: 16306,
      },
    ],
  },
  {
    employee: {
      id: 16184,
      companyId: 2,
      displayName: 'Joshua Holland',
      designation: 'Geographical information systems officer',
      ownerType: null,
      employeeFunction: null,
      email: 'joshua.holland@abc.co',
      personalEmail: 'joshua.holland@abc.co',
      workEmail: 'joshua.holland@abc.co',
      preferredName: 'Joshua',
    },
    id: 384,
    publisherSelectedEmployees: [
      {
        label: 'Cindy Hayes',
        subTitle: 'cindy.hayes@abc.co',
        profilePhoto: null,
        id: 16282,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Elizabeth Ortiz',
        subTitle: 'elizabeth.ortiz@abc.co',
        profilePhoto: null,
        id: 16255,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Susan Brooks',
        subTitle: 'susan.brooks@abc.co',
        profilePhoto: null,
        id: 16143,
      },
    ],
  },
  {
    employee: {
      id: 16185,
      companyId: 3,
      displayName: 'Andrea Martin',
      designation: 'Information systems manager',
      ownerType: null,
      employeeFunction: null,
      email: 'andrea.martin@abc.co',
      personalEmail: 'andrea.martin@abc.co',
      workEmail: 'andrea.martin@abc.co',
      preferredName: 'Andrea',
    },
    id: 385,
    publisherSelectedEmployees: [
      {
        label: 'Mr. Jeremiah Reeves',
        subTitle: 'mr..jeremiah.reeves@abc.co',
        profilePhoto: null,
        id: 16120,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kathryn Rosario',
        subTitle: 'kathryn.rosario@abc.co',
        profilePhoto: null,
        id: 16329,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Robert Pearson',
        subTitle: 'robert.pearson@abc.co',
        profilePhoto: null,
        id: 16328,
      },
    ],
  },
  {
    employee: {
      id: 16186,
      companyId: 1,
      displayName: 'Samantha Morse',
      designation: 'Print production planner',
      ownerType: null,
      employeeFunction: null,
      email: 'samantha.morse@abc.co',
      personalEmail: 'samantha.morse@abc.co',
      workEmail: 'samantha.morse@abc.co',
      preferredName: 'Samantha',
    },
    id: 386,
    publisherSelectedEmployees: [
      {
        label: 'Patrick Graham',
        subTitle: 'patrick.graham@abc.co',
        profilePhoto: null,
        id: 16309,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Miss Patricia Gibson',
        subTitle: 'miss.patricia.gibson@abc.co',
        profilePhoto: null,
        id: 16110,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Zachary Taylor',
        subTitle: 'zachary.taylor@abc.co',
        profilePhoto: null,
        id: 16022,
      },
    ],
  },
  {
    employee: {
      id: 16187,
      companyId: 2,
      displayName: 'Michael Lyons',
      designation: 'Glass blower/designer',
      ownerType: null,
      employeeFunction: null,
      email: 'michael.lyons@abc.co',
      personalEmail: 'michael.lyons@abc.co',
      workEmail: 'michael.lyons@abc.co',
      preferredName: 'Michael',
    },
    id: 387,
    publisherSelectedEmployees: [
      {
        label: 'Nicole Vaughn',
        subTitle: 'nicole.vaughn@abc.co',
        profilePhoto: null,
        id: 16038,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Carlos Whitney',
        subTitle: 'carlos.whitney@abc.co',
        profilePhoto: null,
        id: 16077,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Tiffany Barnes',
        subTitle: 'tiffany.barnes@abc.co',
        profilePhoto: null,
        id: 16127,
      },
    ],
  },
  {
    employee: {
      id: 16188,
      companyId: 3,
      displayName: 'Katherine Miller',
      designation: 'Archaeologist',
      ownerType: null,
      employeeFunction: null,
      email: 'katherine.miller@abc.co',
      personalEmail: 'katherine.miller@abc.co',
      workEmail: 'katherine.miller@abc.co',
      preferredName: 'Katherine',
    },
    id: 388,
    publisherSelectedEmployees: [
      {
        label: 'Rachel Weber',
        subTitle: 'rachel.weber@abc.co',
        profilePhoto: null,
        id: 16183,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mrs. Diane Reyes',
        subTitle: 'mrs..diane.reyes@abc.co',
        profilePhoto: null,
        id: 16350,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Morgan Munoz',
        subTitle: 'morgan.munoz@abc.co',
        profilePhoto: null,
        id: 16189,
      },
    ],
  },
  {
    employee: {
      id: 16189,
      companyId: 1,
      displayName: 'Morgan Munoz',
      designation: 'Agricultural engineer',
      ownerType: null,
      employeeFunction: null,
      email: 'morgan.munoz@abc.co',
      personalEmail: 'morgan.munoz@abc.co',
      workEmail: 'morgan.munoz@abc.co',
      preferredName: 'Morgan',
    },
    id: 389,
    publisherSelectedEmployees: [
      {
        label: 'Megan Young',
        subTitle: 'megan.young@abc.co',
        profilePhoto: null,
        id: 16061,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Richard Camacho',
        subTitle: 'richard.camacho@abc.co',
        profilePhoto: null,
        id: 16275,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Stephanie Gilbert',
        subTitle: 'stephanie.gilbert@abc.co',
        profilePhoto: null,
        id: 16103,
      },
    ],
  },
  {
    employee: {
      id: 16190,
      companyId: 2,
      displayName: 'Vernon Huff',
      designation: 'Teaching laboratory technician',
      ownerType: null,
      employeeFunction: null,
      email: 'vernon.huff@abc.co',
      personalEmail: 'vernon.huff@abc.co',
      workEmail: 'vernon.huff@abc.co',
      preferredName: 'Vernon',
    },
    id: 390,
    publisherSelectedEmployees: [
      {
        label: 'William Wilson',
        subTitle: 'william.wilson@abc.co',
        profilePhoto: null,
        id: 16096,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Susan Wilson',
        subTitle: 'susan.wilson@abc.co',
        profilePhoto: null,
        id: 16395,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Michelle Pierce',
        subTitle: 'michelle.pierce@abc.co',
        profilePhoto: null,
        id: 16399,
      },
    ],
  },
  {
    employee: {
      id: 16191,
      companyId: 3,
      displayName: 'Alicia Hubbard',
      designation: 'Geophysical data processor',
      ownerType: null,
      employeeFunction: null,
      email: 'alicia.hubbard@abc.co',
      personalEmail: 'alicia.hubbard@abc.co',
      workEmail: 'alicia.hubbard@abc.co',
      preferredName: 'Alicia',
    },
    id: 391,
    publisherSelectedEmployees: [
      {
        label: 'Ashley Wise',
        subTitle: 'ashley.wise@abc.co',
        profilePhoto: null,
        id: 16343,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jasmine King',
        subTitle: 'jasmine.king@abc.co',
        profilePhoto: null,
        id: 16335,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Gary Santiago',
        subTitle: 'gary.santiago@abc.co',
        profilePhoto: null,
        id: 16195,
      },
    ],
  },
  {
    employee: {
      id: 16192,
      companyId: 1,
      displayName: 'Pamela Thompson',
      designation: 'Scientist, physiological',
      ownerType: null,
      employeeFunction: null,
      email: 'pamela.thompson@abc.co',
      personalEmail: 'pamela.thompson@abc.co',
      workEmail: 'pamela.thompson@abc.co',
      preferredName: 'Pamela',
    },
    id: 392,
    publisherSelectedEmployees: [
      {
        label: 'Jackie Tran',
        subTitle: 'jackie.tran@abc.co',
        profilePhoto: null,
        id: 16161,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Tammy Young',
        subTitle: 'tammy.young@abc.co',
        profilePhoto: null,
        id: 16084,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Robert Potter',
        subTitle: 'robert.potter@abc.co',
        profilePhoto: null,
        id: 16108,
      },
    ],
  },
  {
    employee: {
      id: 16193,
      companyId: 2,
      displayName: 'Sydney White',
      designation: 'Textile designer',
      ownerType: null,
      employeeFunction: null,
      email: 'sydney.white@abc.co',
      personalEmail: 'sydney.white@abc.co',
      workEmail: 'sydney.white@abc.co',
      preferredName: 'Sydney',
    },
    id: 393,
    publisherSelectedEmployees: [
      {
        label: 'Emily Douglas',
        subTitle: 'emily.douglas@abc.co',
        profilePhoto: null,
        id: 16337,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Shannon Johnston',
        subTitle: 'shannon.johnston@abc.co',
        profilePhoto: null,
        id: 16310,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Mary Nguyen',
        subTitle: 'mary.nguyen@abc.co',
        profilePhoto: null,
        id: 16101,
      },
    ],
  },
  {
    employee: {
      id: 16194,
      companyId: 3,
      displayName: 'Robert Costa',
      designation: 'Psychotherapist, dance movement',
      ownerType: null,
      employeeFunction: null,
      email: 'robert.costa@abc.co',
      personalEmail: 'robert.costa@abc.co',
      workEmail: 'robert.costa@abc.co',
      preferredName: 'Robert',
    },
    id: 394,
    publisherSelectedEmployees: [
      {
        label: 'Jonathan Wilkerson',
        subTitle: 'jonathan.wilkerson@abc.co',
        profilePhoto: null,
        id: 16019,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sandra Drake',
        subTitle: 'sandra.drake@abc.co',
        profilePhoto: null,
        id: 16308,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kelly Campbell',
        subTitle: 'kelly.campbell@abc.co',
        profilePhoto: null,
        id: 16166,
      },
    ],
  },
  {
    employee: {
      id: 16195,
      companyId: 1,
      displayName: 'Gary Santiago',
      designation: 'Designer, multimedia',
      ownerType: null,
      employeeFunction: null,
      email: 'gary.santiago@abc.co',
      personalEmail: 'gary.santiago@abc.co',
      workEmail: 'gary.santiago@abc.co',
      preferredName: 'Gary',
    },
    id: 395,
    publisherSelectedEmployees: [
      {
        label: 'Sean Wyatt',
        subTitle: 'sean.wyatt@abc.co',
        profilePhoto: null,
        id: 16326,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brittney Campbell',
        subTitle: 'brittney.campbell@abc.co',
        profilePhoto: null,
        id: 16073,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Samantha Morse',
        subTitle: 'samantha.morse@abc.co',
        profilePhoto: null,
        id: 16186,
      },
    ],
  },
  {
    employee: {
      id: 16196,
      companyId: 2,
      displayName: 'Michael Roberts',
      designation: 'Oncologist',
      ownerType: null,
      employeeFunction: null,
      email: 'michael.roberts@abc.co',
      personalEmail: 'michael.roberts@abc.co',
      workEmail: 'michael.roberts@abc.co',
      preferredName: 'Michael',
    },
    id: 396,
    publisherSelectedEmployees: [
      {
        label: 'Scott Brown',
        subTitle: 'scott.brown@abc.co',
        profilePhoto: null,
        id: 16047,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Stephanie Hughes',
        subTitle: 'stephanie.hughes@abc.co',
        profilePhoto: null,
        id: 16381,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Adam Mitchell',
        subTitle: 'adam.mitchell@abc.co',
        profilePhoto: null,
        id: 16170,
      },
    ],
  },
  {
    employee: {
      id: 16197,
      companyId: 3,
      displayName: 'Krista Gibson',
      designation: 'International aid/development worker',
      ownerType: null,
      employeeFunction: null,
      email: 'krista.gibson@abc.co',
      personalEmail: 'krista.gibson@abc.co',
      workEmail: 'krista.gibson@abc.co',
      preferredName: 'Krista',
    },
    id: 397,
    publisherSelectedEmployees: [
      {
        label: 'Cheryl Ortega',
        subTitle: 'cheryl.ortega@abc.co',
        profilePhoto: null,
        id: 16102,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Nicole Vaughn',
        subTitle: 'nicole.vaughn@abc.co',
        profilePhoto: null,
        id: 16038,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Brenda Mitchell',
        subTitle: 'brenda.mitchell@abc.co',
        profilePhoto: null,
        id: 16359,
      },
    ],
  },
  {
    employee: {
      id: 16198,
      companyId: 1,
      displayName: 'Brian Barton',
      designation: 'Scientist, audiological',
      ownerType: null,
      employeeFunction: null,
      email: 'brian.barton@abc.co',
      personalEmail: 'brian.barton@abc.co',
      workEmail: 'brian.barton@abc.co',
      preferredName: 'Brian',
    },
    id: 398,
    publisherSelectedEmployees: [
      {
        label: 'Jonathan Wilkerson',
        subTitle: 'jonathan.wilkerson@abc.co',
        profilePhoto: null,
        id: 16019,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Edward Fuller',
        subTitle: 'edward.fuller@abc.co',
        profilePhoto: null,
        id: 16009,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Deborah Miller',
        subTitle: 'deborah.miller@abc.co',
        profilePhoto: null,
        id: 16179,
      },
    ],
  },
  {
    employee: {
      id: 16199,
      companyId: 2,
      displayName: 'April Booth',
      designation: 'Psychologist, counselling',
      ownerType: null,
      employeeFunction: null,
      email: 'april.booth@abc.co',
      personalEmail: 'april.booth@abc.co',
      workEmail: 'april.booth@abc.co',
      preferredName: 'April',
    },
    id: 399,
    publisherSelectedEmployees: [
      {
        label: 'Elizabeth Sutton',
        subTitle: 'elizabeth.sutton@abc.co',
        profilePhoto: null,
        id: 16145,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Cheryl Ortega',
        subTitle: 'cheryl.ortega@abc.co',
        profilePhoto: null,
        id: 16102,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Andrea Martin',
        subTitle: 'andrea.martin@abc.co',
        profilePhoto: null,
        id: 16185,
      },
    ],
  },
  {
    employee: {
      id: 16200,
      companyId: 3,
      displayName: 'Cody Cox',
      designation: 'Research scientist (physical sciences)',
      ownerType: null,
      employeeFunction: null,
      email: 'cody.cox@abc.co',
      personalEmail: 'cody.cox@abc.co',
      workEmail: 'cody.cox@abc.co',
      preferredName: 'Cody',
    },
    id: 400,
    publisherSelectedEmployees: [
      {
        label: 'Janice Carpenter',
        subTitle: 'janice.carpenter@abc.co',
        profilePhoto: null,
        id: 16327,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michael Berger',
        subTitle: 'michael.berger@abc.co',
        profilePhoto: null,
        id: 16226,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Ms. Rebecca Rodriguez',
        subTitle: 'ms..rebecca.rodriguez@abc.co',
        profilePhoto: null,
        id: 16270,
      },
    ],
  },
  {
    employee: {
      id: 16201,
      companyId: 1,
      displayName: 'Olivia Harris',
      designation: 'Stage manager',
      ownerType: null,
      employeeFunction: null,
      email: 'olivia.harris@abc.co',
      personalEmail: 'olivia.harris@abc.co',
      workEmail: 'olivia.harris@abc.co',
      preferredName: 'Olivia',
    },
    id: 401,
    publisherSelectedEmployees: [
      {
        label: 'Erica Miller',
        subTitle: 'erica.miller@abc.co',
        profilePhoto: null,
        id: 16384,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mary Thompson',
        subTitle: 'mary.thompson@abc.co',
        profilePhoto: null,
        id: 16320,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Eric Sanders',
        subTitle: 'eric.sanders@abc.co',
        profilePhoto: null,
        id: 16377,
      },
    ],
  },
  {
    employee: {
      id: 16202,
      companyId: 2,
      displayName: 'Dwayne Gilmore',
      designation: 'Radio producer',
      ownerType: null,
      employeeFunction: null,
      email: 'dwayne.gilmore@abc.co',
      personalEmail: 'dwayne.gilmore@abc.co',
      workEmail: 'dwayne.gilmore@abc.co',
      preferredName: 'Dwayne',
    },
    id: 402,
    publisherSelectedEmployees: [
      {
        label: 'Robert Pearson',
        subTitle: 'robert.pearson@abc.co',
        profilePhoto: null,
        id: 16328,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Anthony Rodriguez',
        subTitle: 'anthony.rodriguez@abc.co',
        profilePhoto: null,
        id: 16023,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sarah Morgan',
        subTitle: 'sarah.morgan@abc.co',
        profilePhoto: null,
        id: 16210,
      },
    ],
  },
  {
    employee: {
      id: 16203,
      companyId: 3,
      displayName: 'William Lynch',
      designation: 'Film/video editor',
      ownerType: null,
      employeeFunction: null,
      email: 'william.lynch@abc.co',
      personalEmail: 'william.lynch@abc.co',
      workEmail: 'william.lynch@abc.co',
      preferredName: 'William',
    },
    id: 403,
    publisherSelectedEmployees: [
      {
        label: 'Adam Mitchell',
        subTitle: 'adam.mitchell@abc.co',
        profilePhoto: null,
        id: 16170,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mark Cox',
        subTitle: 'mark.cox@abc.co',
        profilePhoto: null,
        id: 16388,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Bobby Franklin',
        subTitle: 'bobby.franklin@abc.co',
        profilePhoto: null,
        id: 16278,
      },
    ],
  },
  {
    employee: {
      id: 16204,
      companyId: 1,
      displayName: 'Emily Smith',
      designation: 'Orthoptist',
      ownerType: null,
      employeeFunction: null,
      email: 'emily.smith@abc.co',
      personalEmail: 'emily.smith@abc.co',
      workEmail: 'emily.smith@abc.co',
      preferredName: 'Emily',
    },
    id: 404,
    publisherSelectedEmployees: [
      {
        label: 'Victoria Morris',
        subTitle: 'victoria.morris@abc.co',
        profilePhoto: null,
        id: 16322,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Rita Keith',
        subTitle: 'rita.keith@abc.co',
        profilePhoto: null,
        id: 16085,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Megan Young',
        subTitle: 'megan.young@abc.co',
        profilePhoto: null,
        id: 16061,
      },
    ],
  },
  {
    employee: {
      id: 16205,
      companyId: 2,
      displayName: 'Willie Durham',
      designation: 'Psychologist, clinical',
      ownerType: null,
      employeeFunction: null,
      email: 'willie.durham@abc.co',
      personalEmail: 'willie.durham@abc.co',
      workEmail: 'willie.durham@abc.co',
      preferredName: 'Willie',
    },
    id: 405,
    publisherSelectedEmployees: [
      {
        label: 'Ricardo Young',
        subTitle: 'ricardo.young@abc.co',
        profilePhoto: null,
        id: 16363,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Timothy Walls',
        subTitle: 'timothy.walls@abc.co',
        profilePhoto: null,
        id: 16066,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Joseph Knight',
        subTitle: 'joseph.knight@abc.co',
        profilePhoto: null,
        id: 16228,
      },
    ],
  },
  {
    employee: {
      id: 16206,
      companyId: 3,
      displayName: 'Maria Moore',
      designation: 'Horticulturist, amenity',
      ownerType: null,
      employeeFunction: null,
      email: 'maria.moore@abc.co',
      personalEmail: 'maria.moore@abc.co',
      workEmail: 'maria.moore@abc.co',
      preferredName: 'Maria',
    },
    id: 406,
    publisherSelectedEmployees: [
      {
        label: 'Caitlin Henderson',
        subTitle: 'caitlin.henderson@abc.co',
        profilePhoto: null,
        id: 16005,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Evelyn Williams',
        subTitle: 'evelyn.williams@abc.co',
        profilePhoto: null,
        id: 16373,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Aaron Gomez',
        subTitle: 'aaron.gomez@abc.co',
        profilePhoto: null,
        id: 16367,
      },
    ],
  },
  {
    employee: {
      id: 16207,
      companyId: 1,
      displayName: 'Denise Davenport',
      designation: 'Public house manager',
      ownerType: null,
      employeeFunction: null,
      email: 'denise.davenport@abc.co',
      personalEmail: 'denise.davenport@abc.co',
      workEmail: 'denise.davenport@abc.co',
      preferredName: 'Denise',
    },
    id: 407,
    publisherSelectedEmployees: [
      {
        label: 'Ian Cooper',
        subTitle: 'ian.cooper@abc.co',
        profilePhoto: null,
        id: 16007,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Bobby Franklin',
        subTitle: 'bobby.franklin@abc.co',
        profilePhoto: null,
        id: 16278,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Olivia Harris',
        subTitle: 'olivia.harris@abc.co',
        profilePhoto: null,
        id: 16201,
      },
    ],
  },
  {
    employee: {
      id: 16208,
      companyId: 2,
      displayName: 'Juan Reyes',
      designation: 'Tour manager',
      ownerType: null,
      employeeFunction: null,
      email: 'juan.reyes@abc.co',
      personalEmail: 'juan.reyes@abc.co',
      workEmail: 'juan.reyes@abc.co',
      preferredName: 'Juan',
    },
    id: 408,
    publisherSelectedEmployees: [
      {
        label: 'Brad Ramos',
        subTitle: 'brad.ramos@abc.co',
        profilePhoto: null,
        id: 16301,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Amy Hernandez',
        subTitle: 'amy.hernandez@abc.co',
        profilePhoto: null,
        id: 16173,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Stephanie Simmons',
        subTitle: 'stephanie.simmons@abc.co',
        profilePhoto: null,
        id: 16117,
      },
    ],
  },
  {
    employee: {
      id: 16209,
      companyId: 3,
      displayName: 'Sherry Shields',
      designation: 'Health and safety adviser',
      ownerType: null,
      employeeFunction: null,
      email: 'sherry.shields@abc.co',
      personalEmail: 'sherry.shields@abc.co',
      workEmail: 'sherry.shields@abc.co',
      preferredName: 'Sherry',
    },
    id: 409,
    publisherSelectedEmployees: [
      {
        label: 'Willie Durham',
        subTitle: 'willie.durham@abc.co',
        profilePhoto: null,
        id: 16205,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Andrew Lucas',
        subTitle: 'andrew.lucas@abc.co',
        profilePhoto: null,
        id: 16378,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Michael Roberts',
        subTitle: 'michael.roberts@abc.co',
        profilePhoto: null,
        id: 16196,
      },
    ],
  },
  {
    employee: {
      id: 16210,
      companyId: 1,
      displayName: 'Sarah Morgan',
      designation: 'Runner, broadcasting/film/video',
      ownerType: null,
      employeeFunction: null,
      email: 'sarah.morgan@abc.co',
      personalEmail: 'sarah.morgan@abc.co',
      workEmail: 'sarah.morgan@abc.co',
      preferredName: 'Sarah',
    },
    id: 410,
    publisherSelectedEmployees: [
      {
        label: 'Pamela Thompson',
        subTitle: 'pamela.thompson@abc.co',
        profilePhoto: null,
        id: 16192,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Leslie Bell',
        subTitle: 'leslie.bell@abc.co',
        profilePhoto: null,
        id: 16324,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kylie Williams',
        subTitle: 'kylie.williams@abc.co',
        profilePhoto: null,
        id: 16146,
      },
    ],
  },
  {
    employee: {
      id: 16211,
      companyId: 2,
      displayName: 'Aaron Barber',
      designation: 'Theatre manager',
      ownerType: null,
      employeeFunction: null,
      email: 'aaron.barber@abc.co',
      personalEmail: 'aaron.barber@abc.co',
      workEmail: 'aaron.barber@abc.co',
      preferredName: 'Aaron',
    },
    id: 411,
    publisherSelectedEmployees: [
      {
        label: 'Carlos Walls',
        subTitle: 'carlos.walls@abc.co',
        profilePhoto: null,
        id: 16044,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jackie Tran',
        subTitle: 'jackie.tran@abc.co',
        profilePhoto: null,
        id: 16161,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jessica Rodriguez',
        subTitle: 'jessica.rodriguez@abc.co',
        profilePhoto: null,
        id: 16277,
      },
    ],
  },
  {
    employee: {
      id: 16212,
      companyId: 3,
      displayName: 'Mary Grimes',
      designation: 'Product manager',
      ownerType: null,
      employeeFunction: null,
      email: 'mary.grimes@abc.co',
      personalEmail: 'mary.grimes@abc.co',
      workEmail: 'mary.grimes@abc.co',
      preferredName: 'Mary',
    },
    id: 412,
    publisherSelectedEmployees: [
      {
        label: 'Michael Cox',
        subTitle: 'michael.cox@abc.co',
        profilePhoto: null,
        id: 16313,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Tyler Garcia',
        subTitle: 'tyler.garcia@abc.co',
        profilePhoto: null,
        id: 16178,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Emily Douglas',
        subTitle: 'emily.douglas@abc.co',
        profilePhoto: null,
        id: 16337,
      },
    ],
  },
  {
    employee: {
      id: 16213,
      companyId: 1,
      displayName: 'Haley Arnold',
      designation: 'Speech and language therapist',
      ownerType: null,
      employeeFunction: null,
      email: 'haley.arnold@abc.co',
      personalEmail: 'haley.arnold@abc.co',
      workEmail: 'haley.arnold@abc.co',
      preferredName: 'Haley',
    },
    id: 413,
    publisherSelectedEmployees: [
      {
        label: 'Mrs. Catherine Taylor',
        subTitle: 'mrs..catherine.taylor@abc.co',
        profilePhoto: null,
        id: 16375,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Charles Mcgee',
        subTitle: 'charles.mcgee@abc.co',
        profilePhoto: null,
        id: 16020,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Janice Carpenter',
        subTitle: 'janice.carpenter@abc.co',
        profilePhoto: null,
        id: 16327,
      },
    ],
  },
  {
    employee: {
      id: 16214,
      companyId: 2,
      displayName: 'Timothy Kane',
      designation: 'Field trials officer',
      ownerType: null,
      employeeFunction: null,
      email: 'timothy.kane@abc.co',
      personalEmail: 'timothy.kane@abc.co',
      workEmail: 'timothy.kane@abc.co',
      preferredName: 'Timothy',
    },
    id: 414,
    publisherSelectedEmployees: [
      {
        label: 'Timothy Kane',
        subTitle: 'timothy.kane@abc.co',
        profilePhoto: null,
        id: 16214,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Carrie Wright',
        subTitle: 'carrie.wright@abc.co',
        profilePhoto: null,
        id: 16331,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Pamela Romero',
        subTitle: 'pamela.romero@abc.co',
        profilePhoto: null,
        id: 16029,
      },
    ],
  },
  {
    employee: {
      id: 16215,
      companyId: 3,
      displayName: 'Cynthia Rowe',
      designation: 'Armed forces logistics/support/administrative officer',
      ownerType: null,
      employeeFunction: null,
      email: 'cynthia.rowe@abc.co',
      personalEmail: 'cynthia.rowe@abc.co',
      workEmail: 'cynthia.rowe@abc.co',
      preferredName: 'Cynthia',
    },
    id: 415,
    publisherSelectedEmployees: [
      {
        label: 'James Powers',
        subTitle: 'james.powers@abc.co',
        profilePhoto: null,
        id: 16065,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Shannon Johnston',
        subTitle: 'shannon.johnston@abc.co',
        profilePhoto: null,
        id: 16310,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Ross Price',
        subTitle: 'ross.price@abc.co',
        profilePhoto: null,
        id: 16124,
      },
    ],
  },
  {
    employee: {
      id: 16216,
      companyId: 1,
      displayName: 'John Mcintyre',
      designation: 'Museum/gallery curator',
      ownerType: null,
      employeeFunction: null,
      email: 'john.mcintyre@abc.co',
      personalEmail: 'john.mcintyre@abc.co',
      workEmail: 'john.mcintyre@abc.co',
      preferredName: 'John',
    },
    id: 416,
    publisherSelectedEmployees: [
      {
        label: 'Mrs. Rachel Gibson',
        subTitle: 'mrs..rachel.gibson@abc.co',
        profilePhoto: null,
        id: 16055,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sandra Gilbert',
        subTitle: 'sandra.gilbert@abc.co',
        profilePhoto: null,
        id: 16260,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Janice Carpenter',
        subTitle: 'janice.carpenter@abc.co',
        profilePhoto: null,
        id: 16327,
      },
    ],
  },
  {
    employee: {
      id: 16217,
      companyId: 2,
      displayName: 'Matthew Hoover',
      designation: 'Designer, blown glass/stained glass',
      ownerType: null,
      employeeFunction: null,
      email: 'matthew.hoover@abc.co',
      personalEmail: 'matthew.hoover@abc.co',
      workEmail: 'matthew.hoover@abc.co',
      preferredName: 'Matthew',
    },
    id: 417,
    publisherSelectedEmployees: [
      {
        label: 'Matthew Miller',
        subTitle: 'matthew.miller@abc.co',
        profilePhoto: null,
        id: 16368,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Daniel Fowler',
        subTitle: 'daniel.fowler@abc.co',
        profilePhoto: null,
        id: 16265,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Frederick Solis',
        subTitle: 'frederick.solis@abc.co',
        profilePhoto: null,
        id: 16312,
      },
    ],
  },
  {
    employee: {
      id: 16218,
      companyId: 3,
      displayName: 'Andrew Shaw MD',
      designation: 'Chiropodist',
      ownerType: null,
      employeeFunction: null,
      email: 'andrew.shaw.md@abc.co',
      personalEmail: 'andrew.shaw.md@abc.co',
      workEmail: 'andrew.shaw.md@abc.co',
      preferredName: 'Andrew',
    },
    id: 418,
    publisherSelectedEmployees: [
      {
        label: 'Dana Kennedy',
        subTitle: 'dana.kennedy@abc.co',
        profilePhoto: null,
        id: 16045,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Alex Hernandez',
        subTitle: 'alex.hernandez@abc.co',
        profilePhoto: null,
        id: 16138,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Donna Wilson',
        subTitle: 'donna.wilson@abc.co',
        profilePhoto: null,
        id: 16306,
      },
    ],
  },
  {
    employee: {
      id: 16219,
      companyId: 1,
      displayName: 'Jessica Fox',
      designation: 'Programmer, multimedia',
      ownerType: null,
      employeeFunction: null,
      email: 'jessica.fox@abc.co',
      personalEmail: 'jessica.fox@abc.co',
      workEmail: 'jessica.fox@abc.co',
      preferredName: 'Jessica',
    },
    id: 419,
    publisherSelectedEmployees: [
      {
        label: 'Diane Beck',
        subTitle: 'diane.beck@abc.co',
        profilePhoto: null,
        id: 16107,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mrs. Catherine Taylor',
        subTitle: 'mrs..catherine.taylor@abc.co',
        profilePhoto: null,
        id: 16375,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Amy Edwards',
        subTitle: 'amy.edwards@abc.co',
        profilePhoto: null,
        id: 16058,
      },
    ],
  },
  {
    employee: {
      id: 16220,
      companyId: 2,
      displayName: 'Charles Pitts',
      designation: 'Designer, fashion/clothing',
      ownerType: null,
      employeeFunction: null,
      email: 'charles.pitts@abc.co',
      personalEmail: 'charles.pitts@abc.co',
      workEmail: 'charles.pitts@abc.co',
      preferredName: 'Charles',
    },
    id: 420,
    publisherSelectedEmployees: [
      {
        label: 'Jeremy Reed',
        subTitle: 'jeremy.reed@abc.co',
        profilePhoto: null,
        id: 16233,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sean Wyatt',
        subTitle: 'sean.wyatt@abc.co',
        profilePhoto: null,
        id: 16326,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Lisa Byrd',
        subTitle: 'lisa.byrd@abc.co',
        profilePhoto: null,
        id: 16241,
      },
    ],
  },
  {
    employee: {
      id: 16221,
      companyId: 3,
      displayName: 'Richard Baker',
      designation: 'Youth worker',
      ownerType: null,
      employeeFunction: null,
      email: 'richard.baker@abc.co',
      personalEmail: 'richard.baker@abc.co',
      workEmail: 'richard.baker@abc.co',
      preferredName: 'Richard',
    },
    id: 421,
    publisherSelectedEmployees: [
      {
        label: 'Morgan Munoz',
        subTitle: 'morgan.munoz@abc.co',
        profilePhoto: null,
        id: 16189,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Tammy Young',
        subTitle: 'tammy.young@abc.co',
        profilePhoto: null,
        id: 16084,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Devin Schaefer',
        subTitle: 'devin.schaefer@abc.co',
        profilePhoto: null,
        id: 16015,
      },
    ],
  },
  {
    employee: {
      id: 16222,
      companyId: 1,
      displayName: 'Marie Christian',
      designation: 'Social research officer, government',
      ownerType: null,
      employeeFunction: null,
      email: 'marie.christian@abc.co',
      personalEmail: 'marie.christian@abc.co',
      workEmail: 'marie.christian@abc.co',
      preferredName: 'Marie',
    },
    id: 422,
    publisherSelectedEmployees: [
      {
        label: 'Nicholas Mcbride',
        subTitle: 'nicholas.mcbride@abc.co',
        profilePhoto: null,
        id: 16048,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Devin Schaefer',
        subTitle: 'devin.schaefer@abc.co',
        profilePhoto: null,
        id: 16015,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Pamela Thompson',
        subTitle: 'pamela.thompson@abc.co',
        profilePhoto: null,
        id: 16192,
      },
    ],
  },
  {
    employee: {
      id: 16223,
      companyId: 2,
      displayName: 'Eugene Higgins',
      designation: 'Ranger/warden',
      ownerType: null,
      employeeFunction: null,
      email: 'eugene.higgins@abc.co',
      personalEmail: 'eugene.higgins@abc.co',
      workEmail: 'eugene.higgins@abc.co',
      preferredName: 'Eugene',
    },
    id: 423,
    publisherSelectedEmployees: [
      {
        label: 'Joshua Holland',
        subTitle: 'joshua.holland@abc.co',
        profilePhoto: null,
        id: 16184,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sherry Wood',
        subTitle: 'sherry.wood@abc.co',
        profilePhoto: null,
        id: 16069,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jessica Fox',
        subTitle: 'jessica.fox@abc.co',
        profilePhoto: null,
        id: 16219,
      },
    ],
  },
  {
    employee: {
      id: 16224,
      companyId: 3,
      displayName: 'Amanda Jones',
      designation: 'Holiday representative',
      ownerType: null,
      employeeFunction: null,
      email: 'amanda.jones@abc.co',
      personalEmail: 'amanda.jones@abc.co',
      workEmail: 'amanda.jones@abc.co',
      preferredName: 'Amanda',
    },
    id: 424,
    publisherSelectedEmployees: [
      {
        label: 'Madison Poole',
        subTitle: 'madison.poole@abc.co',
        profilePhoto: null,
        id: 16149,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jonathan Young',
        subTitle: 'jonathan.young@abc.co',
        profilePhoto: null,
        id: 16357,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Laura Barnett',
        subTitle: 'laura.barnett@abc.co',
        profilePhoto: null,
        id: 16154,
      },
    ],
  },
  {
    employee: {
      id: 16225,
      companyId: 1,
      displayName: 'Nicole Hamilton MD',
      designation: 'Chiropodist',
      ownerType: null,
      employeeFunction: null,
      email: 'nicole.hamilton.md@abc.co',
      personalEmail: 'nicole.hamilton.md@abc.co',
      workEmail: 'nicole.hamilton.md@abc.co',
      preferredName: 'Nicole',
    },
    id: 425,
    publisherSelectedEmployees: [
      {
        label: 'Michael Brooks',
        subTitle: 'michael.brooks@abc.co',
        profilePhoto: null,
        id: 16039,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'April Booth',
        subTitle: 'april.booth@abc.co',
        profilePhoto: null,
        id: 16199,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Dean Santiago',
        subTitle: 'dean.santiago@abc.co',
        profilePhoto: null,
        id: 16064,
      },
    ],
  },
  {
    employee: {
      id: 16226,
      companyId: 2,
      displayName: 'Michael Berger',
      designation: 'Armed forces training and education officer',
      ownerType: null,
      employeeFunction: null,
      email: 'michael.berger@abc.co',
      personalEmail: 'michael.berger@abc.co',
      workEmail: 'michael.berger@abc.co',
      preferredName: 'Michael',
    },
    id: 426,
    publisherSelectedEmployees: [
      {
        label: 'Michael Berger',
        subTitle: 'michael.berger@abc.co',
        profilePhoto: null,
        id: 16226,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Curtis Johnson',
        subTitle: 'curtis.johnson@abc.co',
        profilePhoto: null,
        id: 16109,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Corey Murphy',
        subTitle: 'corey.murphy@abc.co',
        profilePhoto: null,
        id: 16091,
      },
    ],
  },
  {
    employee: {
      id: 16227,
      companyId: 3,
      displayName: 'Anthony Howard',
      designation: 'Plant breeder/geneticist',
      ownerType: null,
      employeeFunction: null,
      email: 'anthony.howard@abc.co',
      personalEmail: 'anthony.howard@abc.co',
      workEmail: 'anthony.howard@abc.co',
      preferredName: 'Anthony',
    },
    id: 427,
    publisherSelectedEmployees: [
      {
        label: 'Carlos Walls',
        subTitle: 'carlos.walls@abc.co',
        profilePhoto: null,
        id: 16044,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Benjamin Smith',
        subTitle: 'benjamin.smith@abc.co',
        profilePhoto: null,
        id: 16180,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Tyler Rogers',
        subTitle: 'tyler.rogers@abc.co',
        profilePhoto: null,
        id: 16006,
      },
    ],
  },
  {
    employee: {
      id: 16228,
      companyId: 1,
      displayName: 'Joseph Knight',
      designation: 'Education administrator',
      ownerType: null,
      employeeFunction: null,
      email: 'joseph.knight@abc.co',
      personalEmail: 'joseph.knight@abc.co',
      workEmail: 'joseph.knight@abc.co',
      preferredName: 'Joseph',
    },
    id: 428,
    publisherSelectedEmployees: [
      {
        label: 'Morgan Munoz',
        subTitle: 'morgan.munoz@abc.co',
        profilePhoto: null,
        id: 16189,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kendra Sanders',
        subTitle: 'kendra.sanders@abc.co',
        profilePhoto: null,
        id: 16393,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Regina Diaz',
        subTitle: 'regina.diaz@abc.co',
        profilePhoto: null,
        id: 16250,
      },
    ],
  },
  {
    employee: {
      id: 16229,
      companyId: 2,
      displayName: 'Bob Pitts',
      designation: 'Water quality scientist',
      ownerType: null,
      employeeFunction: null,
      email: 'bob.pitts@abc.co',
      personalEmail: 'bob.pitts@abc.co',
      workEmail: 'bob.pitts@abc.co',
      preferredName: 'Bob',
    },
    id: 429,
    publisherSelectedEmployees: [
      {
        label: 'Elizabeth Sutton',
        subTitle: 'elizabeth.sutton@abc.co',
        profilePhoto: null,
        id: 16145,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Joshua Holland',
        subTitle: 'joshua.holland@abc.co',
        profilePhoto: null,
        id: 16184,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Susan Rivas',
        subTitle: 'susan.rivas@abc.co',
        profilePhoto: null,
        id: 16246,
      },
    ],
  },
  {
    employee: {
      id: 16230,
      companyId: 3,
      displayName: 'Kathleen Aguilar',
      designation: 'Exhibition designer',
      ownerType: null,
      employeeFunction: null,
      email: 'kathleen.aguilar@abc.co',
      personalEmail: 'kathleen.aguilar@abc.co',
      workEmail: 'kathleen.aguilar@abc.co',
      preferredName: 'Kathleen',
    },
    id: 430,
    publisherSelectedEmployees: [
      {
        label: 'Jeff Hill',
        subTitle: 'jeff.hill@abc.co',
        profilePhoto: null,
        id: 16076,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Angela Wright',
        subTitle: 'angela.wright@abc.co',
        profilePhoto: null,
        id: 16174,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Pamela Jackson',
        subTitle: 'pamela.jackson@abc.co',
        profilePhoto: null,
        id: 16140,
      },
    ],
  },
  {
    employee: {
      id: 16231,
      companyId: 1,
      displayName: 'David Scott',
      designation: 'Acupuncturist',
      ownerType: null,
      employeeFunction: null,
      email: 'david.scott@abc.co',
      personalEmail: 'david.scott@abc.co',
      workEmail: 'david.scott@abc.co',
      preferredName: 'David',
    },
    id: 431,
    publisherSelectedEmployees: [
      {
        label: 'Jose Allen',
        subTitle: 'jose.allen@abc.co',
        profilePhoto: null,
        id: 16366,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Andrew Diaz',
        subTitle: 'andrew.diaz@abc.co',
        profilePhoto: null,
        id: 16081,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Monica Logan',
        subTitle: 'monica.logan@abc.co',
        profilePhoto: null,
        id: 16056,
      },
    ],
  },
  {
    employee: {
      id: 16232,
      companyId: 2,
      displayName: 'Julie Roberts',
      designation: 'Sports coach',
      ownerType: null,
      employeeFunction: null,
      email: 'julie.roberts@abc.co',
      personalEmail: 'julie.roberts@abc.co',
      workEmail: 'julie.roberts@abc.co',
      preferredName: 'Julie',
    },
    id: 432,
    publisherSelectedEmployees: [
      {
        label: 'Susan Vargas',
        subTitle: 'susan.vargas@abc.co',
        profilePhoto: null,
        id: 16131,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Justin Baxter',
        subTitle: 'justin.baxter@abc.co',
        profilePhoto: null,
        id: 16083,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Brittney Campbell',
        subTitle: 'brittney.campbell@abc.co',
        profilePhoto: null,
        id: 16073,
      },
    ],
  },
  {
    employee: {
      id: 16233,
      companyId: 3,
      displayName: 'Jeremy Reed',
      designation: 'Theatre manager',
      ownerType: null,
      employeeFunction: null,
      email: 'jeremy.reed@abc.co',
      personalEmail: 'jeremy.reed@abc.co',
      workEmail: 'jeremy.reed@abc.co',
      preferredName: 'Jeremy',
    },
    id: 433,
    publisherSelectedEmployees: [
      {
        label: 'Hunter Kramer',
        subTitle: 'hunter.kramer@abc.co',
        profilePhoto: null,
        id: 16271,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Linda Burns',
        subTitle: 'linda.burns@abc.co',
        profilePhoto: null,
        id: 16032,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'David Davidson',
        subTitle: 'david.davidson@abc.co',
        profilePhoto: null,
        id: 16352,
      },
    ],
  },
  {
    employee: {
      id: 16234,
      companyId: 1,
      displayName: 'Victor Vaughn',
      designation: 'Programmer, multimedia',
      ownerType: null,
      employeeFunction: null,
      email: 'victor.vaughn@abc.co',
      personalEmail: 'victor.vaughn@abc.co',
      workEmail: 'victor.vaughn@abc.co',
      preferredName: 'Victor',
    },
    id: 434,
    publisherSelectedEmployees: [
      {
        label: 'Pamela Romero',
        subTitle: 'pamela.romero@abc.co',
        profilePhoto: null,
        id: 16029,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Justin Riley',
        subTitle: 'justin.riley@abc.co',
        profilePhoto: null,
        id: 16321,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Haley Arnold',
        subTitle: 'haley.arnold@abc.co',
        profilePhoto: null,
        id: 16213,
      },
    ],
  },
  {
    employee: {
      id: 16235,
      companyId: 2,
      displayName: 'Christina Cruz',
      designation: 'Radiation protection practitioner',
      ownerType: null,
      employeeFunction: null,
      email: 'christina.cruz@abc.co',
      personalEmail: 'christina.cruz@abc.co',
      workEmail: 'christina.cruz@abc.co',
      preferredName: 'Christina',
    },
    id: 435,
    publisherSelectedEmployees: [
      {
        label: 'Stacey Arias',
        subTitle: 'stacey.arias@abc.co',
        profilePhoto: null,
        id: 16356,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Victoria Wyatt',
        subTitle: 'victoria.wyatt@abc.co',
        profilePhoto: null,
        id: 16011,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Lance Simmons',
        subTitle: 'lance.simmons@abc.co',
        profilePhoto: null,
        id: 16385,
      },
    ],
  },
  {
    employee: {
      id: 16236,
      companyId: 3,
      displayName: 'James Howard',
      designation: 'Hotel manager',
      ownerType: null,
      employeeFunction: null,
      email: 'james.howard@abc.co',
      personalEmail: 'james.howard@abc.co',
      workEmail: 'james.howard@abc.co',
      preferredName: 'James',
    },
    id: 436,
    publisherSelectedEmployees: [
      {
        label: 'Christopher Lewis',
        subTitle: 'christopher.lewis@abc.co',
        profilePhoto: null,
        id: 16341,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Gary Santiago',
        subTitle: 'gary.santiago@abc.co',
        profilePhoto: null,
        id: 16195,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Joshua Gibson',
        subTitle: 'joshua.gibson@abc.co',
        profilePhoto: null,
        id: 16251,
      },
    ],
  },
  {
    employee: {
      id: 16237,
      companyId: 1,
      displayName: 'Elizabeth Spence DDS',
      designation: 'Haematologist',
      ownerType: null,
      employeeFunction: null,
      email: 'elizabeth.spence.dds@abc.co',
      personalEmail: 'elizabeth.spence.dds@abc.co',
      workEmail: 'elizabeth.spence.dds@abc.co',
      preferredName: 'Elizabeth',
    },
    id: 437,
    publisherSelectedEmployees: [
      {
        label: 'Joshua Turner',
        subTitle: 'joshua.turner@abc.co',
        profilePhoto: null,
        id: 16070,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Ricardo Young',
        subTitle: 'ricardo.young@abc.co',
        profilePhoto: null,
        id: 16363,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Nicholas Adams',
        subTitle: 'nicholas.adams@abc.co',
        profilePhoto: null,
        id: 16152,
      },
    ],
  },
  {
    employee: {
      id: 16238,
      companyId: 2,
      displayName: 'Sean Osborne',
      designation: 'Artist',
      ownerType: null,
      employeeFunction: null,
      email: 'sean.osborne@abc.co',
      personalEmail: 'sean.osborne@abc.co',
      workEmail: 'sean.osborne@abc.co',
      preferredName: 'Sean',
    },
    id: 438,
    publisherSelectedEmployees: [
      {
        label: 'Joseph Romero',
        subTitle: 'joseph.romero@abc.co',
        profilePhoto: null,
        id: 16369,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Rickey Li',
        subTitle: 'rickey.li@abc.co',
        profilePhoto: null,
        id: 16339,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Dana Chapman',
        subTitle: 'dana.chapman@abc.co',
        profilePhoto: null,
        id: 16314,
      },
    ],
  },
  {
    employee: {
      id: 16239,
      companyId: 3,
      displayName: 'Natasha Wall',
      designation: 'Historic buildings inspector/conservation officer',
      ownerType: null,
      employeeFunction: null,
      email: 'natasha.wall@abc.co',
      personalEmail: 'natasha.wall@abc.co',
      workEmail: 'natasha.wall@abc.co',
      preferredName: 'Natasha',
    },
    id: 439,
    publisherSelectedEmployees: [
      {
        label: 'Maria Moore',
        subTitle: 'maria.moore@abc.co',
        profilePhoto: null,
        id: 16206,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Devin Schaefer',
        subTitle: 'devin.schaefer@abc.co',
        profilePhoto: null,
        id: 16015,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Katie Anderson',
        subTitle: 'katie.anderson@abc.co',
        profilePhoto: null,
        id: 16068,
      },
    ],
  },
  {
    employee: {
      id: 16240,
      companyId: 1,
      displayName: 'Crystal Pham',
      designation: 'English as a foreign language teacher',
      ownerType: null,
      employeeFunction: null,
      email: 'crystal.pham@abc.co',
      personalEmail: 'crystal.pham@abc.co',
      workEmail: 'crystal.pham@abc.co',
      preferredName: 'Crystal',
    },
    id: 440,
    publisherSelectedEmployees: [
      {
        label: 'Richard Glenn',
        subTitle: 'richard.glenn@abc.co',
        profilePhoto: null,
        id: 16379,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sara Calhoun',
        subTitle: 'sara.calhoun@abc.co',
        profilePhoto: null,
        id: 16130,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Terry Coffey',
        subTitle: 'terry.coffey@abc.co',
        profilePhoto: null,
        id: 16247,
      },
    ],
  },
  {
    employee: {
      id: 16241,
      companyId: 2,
      displayName: 'Lisa Byrd',
      designation: 'Copywriter, advertising',
      ownerType: null,
      employeeFunction: null,
      email: 'lisa.byrd@abc.co',
      personalEmail: 'lisa.byrd@abc.co',
      workEmail: 'lisa.byrd@abc.co',
      preferredName: 'Lisa',
    },
    id: 441,
    publisherSelectedEmployees: [
      {
        label: 'Alexandra Le',
        subTitle: 'alexandra.le@abc.co',
        profilePhoto: null,
        id: 16026,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jacob Hunter',
        subTitle: 'jacob.hunter@abc.co',
        profilePhoto: null,
        id: 16147,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Elizabeth Fowler',
        subTitle: 'elizabeth.fowler@abc.co',
        profilePhoto: null,
        id: 16030,
      },
    ],
  },
  {
    employee: {
      id: 16242,
      companyId: 3,
      displayName: 'Stephanie Lucas',
      designation: 'Insurance broker',
      ownerType: null,
      employeeFunction: null,
      email: 'stephanie.lucas@abc.co',
      personalEmail: 'stephanie.lucas@abc.co',
      workEmail: 'stephanie.lucas@abc.co',
      preferredName: 'Stephanie',
    },
    id: 442,
    publisherSelectedEmployees: [
      {
        label: 'Melissa Martinez',
        subTitle: 'melissa.martinez@abc.co',
        profilePhoto: null,
        id: 16169,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mrs. Alexis Kramer',
        subTitle: 'mrs..alexis.kramer@abc.co',
        profilePhoto: null,
        id: 16371,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Devin Schaefer',
        subTitle: 'devin.schaefer@abc.co',
        profilePhoto: null,
        id: 16015,
      },
    ],
  },
  {
    employee: {
      id: 16243,
      companyId: 1,
      displayName: 'Amanda Diaz',
      designation: 'Conservator, museum/gallery',
      ownerType: null,
      employeeFunction: null,
      email: 'amanda.diaz@abc.co',
      personalEmail: 'amanda.diaz@abc.co',
      workEmail: 'amanda.diaz@abc.co',
      preferredName: 'Amanda',
    },
    id: 443,
    publisherSelectedEmployees: [
      {
        label: 'Corey Murphy',
        subTitle: 'corey.murphy@abc.co',
        profilePhoto: null,
        id: 16091,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Justin Lowery',
        subTitle: 'justin.lowery@abc.co',
        profilePhoto: null,
        id: 16114,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sean Wyatt',
        subTitle: 'sean.wyatt@abc.co',
        profilePhoto: null,
        id: 16326,
      },
    ],
  },
  {
    employee: {
      id: 16244,
      companyId: 2,
      displayName: 'Edward Burgess',
      designation: 'Economist',
      ownerType: null,
      employeeFunction: null,
      email: 'edward.burgess@abc.co',
      personalEmail: 'edward.burgess@abc.co',
      workEmail: 'edward.burgess@abc.co',
      preferredName: 'Edward',
    },
    id: 444,
    publisherSelectedEmployees: [
      {
        label: 'Brent Rodgers',
        subTitle: 'brent.rodgers@abc.co',
        profilePhoto: null,
        id: 16286,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Caitlin Henderson',
        subTitle: 'caitlin.henderson@abc.co',
        profilePhoto: null,
        id: 16005,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sherry Shields',
        subTitle: 'sherry.shields@abc.co',
        profilePhoto: null,
        id: 16209,
      },
    ],
  },
  {
    employee: {
      id: 16245,
      companyId: 3,
      displayName: 'Richard Walter',
      designation: 'Medical secretary',
      ownerType: null,
      employeeFunction: null,
      email: 'richard.walter@abc.co',
      personalEmail: 'richard.walter@abc.co',
      workEmail: 'richard.walter@abc.co',
      preferredName: 'Richard',
    },
    id: 445,
    publisherSelectedEmployees: [
      {
        label: 'Samantha Bentley',
        subTitle: 'samantha.bentley@abc.co',
        profilePhoto: null,
        id: 16252,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brandy Wilson',
        subTitle: 'brandy.wilson@abc.co',
        profilePhoto: null,
        id: 16072,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Deborah Miller',
        subTitle: 'deborah.miller@abc.co',
        profilePhoto: null,
        id: 16179,
      },
    ],
  },
  {
    employee: {
      id: 16246,
      companyId: 1,
      displayName: 'Susan Rivas',
      designation: 'Furniture designer',
      ownerType: null,
      employeeFunction: null,
      email: 'susan.rivas@abc.co',
      personalEmail: 'susan.rivas@abc.co',
      workEmail: 'susan.rivas@abc.co',
      preferredName: 'Susan',
    },
    id: 446,
    publisherSelectedEmployees: [
      {
        label: 'Patrick Moore',
        subTitle: 'patrick.moore@abc.co',
        profilePhoto: null,
        id: 16259,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Joshua Turner',
        subTitle: 'joshua.turner@abc.co',
        profilePhoto: null,
        id: 16070,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Eric Nguyen',
        subTitle: 'eric.nguyen@abc.co',
        profilePhoto: null,
        id: 16299,
      },
    ],
  },
  {
    employee: {
      id: 16247,
      companyId: 2,
      displayName: 'Terry Coffey',
      designation: 'Hotel manager',
      ownerType: null,
      employeeFunction: null,
      email: 'terry.coffey@abc.co',
      personalEmail: 'terry.coffey@abc.co',
      workEmail: 'terry.coffey@abc.co',
      preferredName: 'Terry',
    },
    id: 447,
    publisherSelectedEmployees: [
      {
        label: 'Ashley Singleton',
        subTitle: 'ashley.singleton@abc.co',
        profilePhoto: null,
        id: 16353,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Caitlin Henderson',
        subTitle: 'caitlin.henderson@abc.co',
        profilePhoto: null,
        id: 16005,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Megan Young',
        subTitle: 'megan.young@abc.co',
        profilePhoto: null,
        id: 16061,
      },
    ],
  },
  {
    employee: {
      id: 16248,
      companyId: 3,
      displayName: 'Gina Wilson',
      designation: 'Call centre manager',
      ownerType: null,
      employeeFunction: null,
      email: 'gina.wilson@abc.co',
      personalEmail: 'gina.wilson@abc.co',
      workEmail: 'gina.wilson@abc.co',
      preferredName: 'Gina',
    },
    id: 448,
    publisherSelectedEmployees: [
      {
        label: 'Victoria Morris',
        subTitle: 'victoria.morris@abc.co',
        profilePhoto: null,
        id: 16322,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Joseph Romero',
        subTitle: 'joseph.romero@abc.co',
        profilePhoto: null,
        id: 16369,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Caitlin Henderson',
        subTitle: 'caitlin.henderson@abc.co',
        profilePhoto: null,
        id: 16005,
      },
    ],
  },
  {
    employee: {
      id: 16249,
      companyId: 1,
      displayName: 'Vincent Dalton',
      designation: 'Occupational psychologist',
      ownerType: null,
      employeeFunction: null,
      email: 'vincent.dalton@abc.co',
      personalEmail: 'vincent.dalton@abc.co',
      workEmail: 'vincent.dalton@abc.co',
      preferredName: 'Vincent',
    },
    id: 449,
    publisherSelectedEmployees: [
      {
        label: 'Kara Davis',
        subTitle: 'kara.davis@abc.co',
        profilePhoto: null,
        id: 16285,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Adam Mitchell',
        subTitle: 'adam.mitchell@abc.co',
        profilePhoto: null,
        id: 16170,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kylie Williams',
        subTitle: 'kylie.williams@abc.co',
        profilePhoto: null,
        id: 16146,
      },
    ],
  },
  {
    employee: {
      id: 16250,
      companyId: 2,
      displayName: 'Regina Diaz',
      designation: 'Nutritional therapist',
      ownerType: null,
      employeeFunction: null,
      email: 'regina.diaz@abc.co',
      personalEmail: 'regina.diaz@abc.co',
      workEmail: 'regina.diaz@abc.co',
      preferredName: 'Regina',
    },
    id: 450,
    publisherSelectedEmployees: [
      {
        label: 'Ariana Jennings',
        subTitle: 'ariana.jennings@abc.co',
        profilePhoto: null,
        id: 16262,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mrs. Rachel Gibson',
        subTitle: 'mrs..rachel.gibson@abc.co',
        profilePhoto: null,
        id: 16055,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Samuel White',
        subTitle: 'samuel.white@abc.co',
        profilePhoto: null,
        id: 16155,
      },
    ],
  },
  {
    employee: {
      id: 16251,
      companyId: 3,
      displayName: 'Joshua Gibson',
      designation: 'Garment/textile technologist',
      ownerType: null,
      employeeFunction: null,
      email: 'joshua.gibson@abc.co',
      personalEmail: 'joshua.gibson@abc.co',
      workEmail: 'joshua.gibson@abc.co',
      preferredName: 'Joshua',
    },
    id: 451,
    publisherSelectedEmployees: [
      {
        label: 'Nicholas Sheppard',
        subTitle: 'nicholas.sheppard@abc.co',
        profilePhoto: null,
        id: 16150,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Travis Johnson',
        subTitle: 'travis.johnson@abc.co',
        profilePhoto: null,
        id: 16391,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Joseph Hill',
        subTitle: 'joseph.hill@abc.co',
        profilePhoto: null,
        id: 16168,
      },
    ],
  },
  {
    employee: {
      id: 16252,
      companyId: 1,
      displayName: 'Samantha Bentley',
      designation: 'Clinical cytogeneticist',
      ownerType: null,
      employeeFunction: null,
      email: 'samantha.bentley@abc.co',
      personalEmail: 'samantha.bentley@abc.co',
      workEmail: 'samantha.bentley@abc.co',
      preferredName: 'Samantha',
    },
    id: 452,
    publisherSelectedEmployees: [
      {
        label: 'Curtis Johnson',
        subTitle: 'curtis.johnson@abc.co',
        profilePhoto: null,
        id: 16109,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Joseph Knight',
        subTitle: 'joseph.knight@abc.co',
        profilePhoto: null,
        id: 16228,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Dr. Steven Martin',
        subTitle: 'dr..steven.martin@abc.co',
        profilePhoto: null,
        id: 16054,
      },
    ],
  },
  {
    employee: {
      id: 16253,
      companyId: 2,
      displayName: 'Kaitlyn Harvey',
      designation: 'Surveyor, mining',
      ownerType: null,
      employeeFunction: null,
      email: 'kaitlyn.harvey@abc.co',
      personalEmail: 'kaitlyn.harvey@abc.co',
      workEmail: 'kaitlyn.harvey@abc.co',
      preferredName: 'Kaitlyn',
    },
    id: 453,
    publisherSelectedEmployees: [
      {
        label: 'Jessica Fowler',
        subTitle: 'jessica.fowler@abc.co',
        profilePhoto: null,
        id: 16387,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christopher Williams',
        subTitle: 'christopher.williams@abc.co',
        profilePhoto: null,
        id: 16272,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Regina Diaz',
        subTitle: 'regina.diaz@abc.co',
        profilePhoto: null,
        id: 16250,
      },
    ],
  },
  {
    employee: {
      id: 16254,
      companyId: 3,
      displayName: 'Leonard Holland',
      designation: 'Psychologist, forensic',
      ownerType: null,
      employeeFunction: null,
      email: 'leonard.holland@abc.co',
      personalEmail: 'leonard.holland@abc.co',
      workEmail: 'leonard.holland@abc.co',
      preferredName: 'Leonard',
    },
    id: 454,
    publisherSelectedEmployees: [
      {
        label: 'Shannon Johnston',
        subTitle: 'shannon.johnston@abc.co',
        profilePhoto: null,
        id: 16310,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Monica Logan',
        subTitle: 'monica.logan@abc.co',
        profilePhoto: null,
        id: 16056,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Courtney Rodriguez',
        subTitle: 'courtney.rodriguez@abc.co',
        profilePhoto: null,
        id: 16291,
      },
    ],
  },
  {
    employee: {
      id: 16255,
      companyId: 1,
      displayName: 'Elizabeth Ortiz',
      designation: 'Counselling psychologist',
      ownerType: null,
      employeeFunction: null,
      email: 'elizabeth.ortiz@abc.co',
      personalEmail: 'elizabeth.ortiz@abc.co',
      workEmail: 'elizabeth.ortiz@abc.co',
      preferredName: 'Elizabeth',
    },
    id: 455,
    publisherSelectedEmployees: [
      {
        label: 'Julie Johnson',
        subTitle: 'julie.johnson@abc.co',
        profilePhoto: null,
        id: 16181,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jose Allen',
        subTitle: 'jose.allen@abc.co',
        profilePhoto: null,
        id: 16366,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sherry Shields',
        subTitle: 'sherry.shields@abc.co',
        profilePhoto: null,
        id: 16209,
      },
    ],
  },
  {
    employee: {
      id: 16256,
      companyId: 2,
      displayName: 'Andrew Ferrell',
      designation: 'Commercial art gallery manager',
      ownerType: null,
      employeeFunction: null,
      email: 'andrew.ferrell@abc.co',
      personalEmail: 'andrew.ferrell@abc.co',
      workEmail: 'andrew.ferrell@abc.co',
      preferredName: 'Andrew',
    },
    id: 456,
    publisherSelectedEmployees: [
      {
        label: 'Julie Roberts',
        subTitle: 'julie.roberts@abc.co',
        profilePhoto: null,
        id: 16232,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Gary Santiago',
        subTitle: 'gary.santiago@abc.co',
        profilePhoto: null,
        id: 16195,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'James Powers',
        subTitle: 'james.powers@abc.co',
        profilePhoto: null,
        id: 16065,
      },
    ],
  },
  {
    employee: {
      id: 16257,
      companyId: 3,
      displayName: 'Stephen Taylor',
      designation: 'Professor Emeritus',
      ownerType: null,
      employeeFunction: null,
      email: 'stephen.taylor@abc.co',
      personalEmail: 'stephen.taylor@abc.co',
      workEmail: 'stephen.taylor@abc.co',
      preferredName: 'Stephen',
    },
    id: 457,
    publisherSelectedEmployees: [
      {
        label: 'Patrick Bonilla',
        subTitle: 'patrick.bonilla@abc.co',
        profilePhoto: null,
        id: 16297,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mary Nguyen',
        subTitle: 'mary.nguyen@abc.co',
        profilePhoto: null,
        id: 16101,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kimberly Ball',
        subTitle: 'kimberly.ball@abc.co',
        profilePhoto: null,
        id: 16098,
      },
    ],
  },
  {
    employee: {
      id: 16258,
      companyId: 1,
      displayName: 'Travis Horton',
      designation: 'Sound technician, broadcasting/film/video',
      ownerType: null,
      employeeFunction: null,
      email: 'travis.horton@abc.co',
      personalEmail: 'travis.horton@abc.co',
      workEmail: 'travis.horton@abc.co',
      preferredName: 'Travis',
    },
    id: 458,
    publisherSelectedEmployees: [
      {
        label: 'Maria Brown',
        subTitle: 'maria.brown@abc.co',
        profilePhoto: null,
        id: 16263,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Matthew Miller',
        subTitle: 'matthew.miller@abc.co',
        profilePhoto: null,
        id: 16368,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Edward Burgess',
        subTitle: 'edward.burgess@abc.co',
        profilePhoto: null,
        id: 16244,
      },
    ],
  },
  {
    employee: {
      id: 16259,
      companyId: 2,
      displayName: 'Patrick Moore',
      designation: 'Patent examiner',
      ownerType: null,
      employeeFunction: null,
      email: 'patrick.moore@abc.co',
      personalEmail: 'patrick.moore@abc.co',
      workEmail: 'patrick.moore@abc.co',
      preferredName: 'Patrick',
    },
    id: 459,
    publisherSelectedEmployees: [
      {
        label: 'Alicia Hubbard',
        subTitle: 'alicia.hubbard@abc.co',
        profilePhoto: null,
        id: 16191,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michelle Schmitt',
        subTitle: 'michelle.schmitt@abc.co',
        profilePhoto: null,
        id: 16289,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Crystal Robinson',
        subTitle: 'crystal.robinson@abc.co',
        profilePhoto: null,
        id: 16041,
      },
    ],
  },
  {
    employee: {
      id: 16260,
      companyId: 3,
      displayName: 'Sandra Gilbert',
      designation: 'Health service manager',
      ownerType: null,
      employeeFunction: null,
      email: 'sandra.gilbert@abc.co',
      personalEmail: 'sandra.gilbert@abc.co',
      workEmail: 'sandra.gilbert@abc.co',
      preferredName: 'Sandra',
    },
    id: 460,
    publisherSelectedEmployees: [
      {
        label: 'Jamie Kerr',
        subTitle: 'jamie.kerr@abc.co',
        profilePhoto: null,
        id: 16176,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Cindy Barnes',
        subTitle: 'cindy.barnes@abc.co',
        profilePhoto: null,
        id: 16298,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Nicholas Adams',
        subTitle: 'nicholas.adams@abc.co',
        profilePhoto: null,
        id: 16152,
      },
    ],
  },
  {
    employee: {
      id: 16261,
      companyId: 1,
      displayName: 'Jacob Ramos',
      designation: 'Fashion designer',
      ownerType: null,
      employeeFunction: null,
      email: 'jacob.ramos@abc.co',
      personalEmail: 'jacob.ramos@abc.co',
      workEmail: 'jacob.ramos@abc.co',
      preferredName: 'Jacob',
    },
    id: 461,
    publisherSelectedEmployees: [
      {
        label: 'Allen Rogers',
        subTitle: 'allen.rogers@abc.co',
        profilePhoto: null,
        id: 16129,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Dakota Moody',
        subTitle: 'dakota.moody@abc.co',
        profilePhoto: null,
        id: 16376,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Courtney Velasquez',
        subTitle: 'courtney.velasquez@abc.co',
        profilePhoto: null,
        id: 16089,
      },
    ],
  },
  {
    employee: {
      id: 16262,
      companyId: 2,
      displayName: 'Ariana Jennings',
      designation: 'Sport and exercise psychologist',
      ownerType: null,
      employeeFunction: null,
      email: 'ariana.jennings@abc.co',
      personalEmail: 'ariana.jennings@abc.co',
      workEmail: 'ariana.jennings@abc.co',
      preferredName: 'Ariana',
    },
    id: 462,
    publisherSelectedEmployees: [
      {
        label: 'Jeremy Reed',
        subTitle: 'jeremy.reed@abc.co',
        profilePhoto: null,
        id: 16233,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sharon Cochran',
        subTitle: 'sharon.cochran@abc.co',
        profilePhoto: null,
        id: 16087,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Deborah Miller',
        subTitle: 'deborah.miller@abc.co',
        profilePhoto: null,
        id: 16179,
      },
    ],
  },
  {
    employee: {
      id: 16263,
      companyId: 3,
      displayName: 'Maria Brown',
      designation: 'Health and safety adviser',
      ownerType: null,
      employeeFunction: null,
      email: 'maria.brown@abc.co',
      personalEmail: 'maria.brown@abc.co',
      workEmail: 'maria.brown@abc.co',
      preferredName: 'Maria',
    },
    id: 463,
    publisherSelectedEmployees: [
      {
        label: 'Steven Cooper',
        subTitle: 'steven.cooper@abc.co',
        profilePhoto: null,
        id: 16330,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sean Wyatt',
        subTitle: 'sean.wyatt@abc.co',
        profilePhoto: null,
        id: 16326,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Lisa Gibbs',
        subTitle: 'lisa.gibbs@abc.co',
        profilePhoto: null,
        id: 16175,
      },
    ],
  },
  {
    employee: {
      id: 16264,
      companyId: 1,
      displayName: 'Bryan Charles',
      designation: 'Programme researcher, broadcasting/film/video',
      ownerType: null,
      employeeFunction: null,
      email: 'bryan.charles@abc.co',
      personalEmail: 'bryan.charles@abc.co',
      workEmail: 'bryan.charles@abc.co',
      preferredName: 'Bryan',
    },
    id: 464,
    publisherSelectedEmployees: [
      {
        label: 'Eugene Higgins',
        subTitle: 'eugene.higgins@abc.co',
        profilePhoto: null,
        id: 16223,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michael Snyder',
        subTitle: 'michael.snyder@abc.co',
        profilePhoto: null,
        id: 16111,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Dakota Moody',
        subTitle: 'dakota.moody@abc.co',
        profilePhoto: null,
        id: 16376,
      },
    ],
  },
  {
    employee: {
      id: 16265,
      companyId: 2,
      displayName: 'Daniel Fowler',
      designation: 'Advertising art director',
      ownerType: null,
      employeeFunction: null,
      email: 'daniel.fowler@abc.co',
      personalEmail: 'daniel.fowler@abc.co',
      workEmail: 'daniel.fowler@abc.co',
      preferredName: 'Daniel',
    },
    id: 465,
    publisherSelectedEmployees: [
      {
        label: 'Donald Farmer',
        subTitle: 'donald.farmer@abc.co',
        profilePhoto: null,
        id: 16295,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'David Thompson',
        subTitle: 'david.thompson@abc.co',
        profilePhoto: null,
        id: 16319,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Curtis Johnson',
        subTitle: 'curtis.johnson@abc.co',
        profilePhoto: null,
        id: 16109,
      },
    ],
  },
  {
    employee: {
      id: 16266,
      companyId: 3,
      displayName: 'Gavin Zhang',
      designation: 'Systems analyst',
      ownerType: null,
      employeeFunction: null,
      email: 'gavin.zhang@abc.co',
      personalEmail: 'gavin.zhang@abc.co',
      workEmail: 'gavin.zhang@abc.co',
      preferredName: 'Gavin',
    },
    id: 466,
    publisherSelectedEmployees: [
      {
        label: 'Robert Costa',
        subTitle: 'robert.costa@abc.co',
        profilePhoto: null,
        id: 16194,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Katherine Miller',
        subTitle: 'katherine.miller@abc.co',
        profilePhoto: null,
        id: 16188,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Charles Mcgee',
        subTitle: 'charles.mcgee@abc.co',
        profilePhoto: null,
        id: 16020,
      },
    ],
  },
  {
    employee: {
      id: 16267,
      companyId: 1,
      displayName: 'Ronald Spencer',
      designation: 'Theatre director',
      ownerType: null,
      employeeFunction: null,
      email: 'ronald.spencer@abc.co',
      personalEmail: 'ronald.spencer@abc.co',
      workEmail: 'ronald.spencer@abc.co',
      preferredName: 'Ronald',
    },
    id: 467,
    publisherSelectedEmployees: [
      {
        label: 'Angelica Keith',
        subTitle: 'angelica.keith@abc.co',
        profilePhoto: null,
        id: 16153,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Shannon Johnston',
        subTitle: 'shannon.johnston@abc.co',
        profilePhoto: null,
        id: 16310,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Chad Jones',
        subTitle: 'chad.jones@abc.co',
        profilePhoto: null,
        id: 16397,
      },
    ],
  },
  {
    employee: {
      id: 16268,
      companyId: 2,
      displayName: 'Sergio Murphy',
      designation: 'Data scientist',
      ownerType: null,
      employeeFunction: null,
      email: 'sergio.murphy@abc.co',
      personalEmail: 'sergio.murphy@abc.co',
      workEmail: 'sergio.murphy@abc.co',
      preferredName: 'Sergio',
    },
    id: 468,
    publisherSelectedEmployees: [
      {
        label: 'Edward Fuller',
        subTitle: 'edward.fuller@abc.co',
        profilePhoto: null,
        id: 16009,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christina Cruz',
        subTitle: 'christina.cruz@abc.co',
        profilePhoto: null,
        id: 16235,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Zachary Taylor',
        subTitle: 'zachary.taylor@abc.co',
        profilePhoto: null,
        id: 16022,
      },
    ],
  },
  {
    employee: {
      id: 16269,
      companyId: 3,
      displayName: 'Linda Ramirez',
      designation: 'Dance movement psychotherapist',
      ownerType: null,
      employeeFunction: null,
      email: 'linda.ramirez@abc.co',
      personalEmail: 'linda.ramirez@abc.co',
      workEmail: 'linda.ramirez@abc.co',
      preferredName: 'Linda',
    },
    id: 469,
    publisherSelectedEmployees: [
      {
        label: 'Samuel White',
        subTitle: 'samuel.white@abc.co',
        profilePhoto: null,
        id: 16155,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mrs. Diane Reyes',
        subTitle: 'mrs..diane.reyes@abc.co',
        profilePhoto: null,
        id: 16350,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Nicole Vaughn',
        subTitle: 'nicole.vaughn@abc.co',
        profilePhoto: null,
        id: 16038,
      },
    ],
  },
  {
    employee: {
      id: 16270,
      companyId: 1,
      displayName: 'Ms. Rebecca Rodriguez',
      designation: 'Agricultural engineer',
      ownerType: null,
      employeeFunction: null,
      email: 'ms..rebecca.rodriguez@abc.co',
      personalEmail: 'ms..rebecca.rodriguez@abc.co',
      workEmail: 'ms..rebecca.rodriguez@abc.co',
      preferredName: 'Ms.',
    },
    id: 470,
    publisherSelectedEmployees: [
      {
        label: 'Jessica Fox',
        subTitle: 'jessica.fox@abc.co',
        profilePhoto: null,
        id: 16219,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sherry Shields',
        subTitle: 'sherry.shields@abc.co',
        profilePhoto: null,
        id: 16209,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Susan Smith',
        subTitle: 'susan.smith@abc.co',
        profilePhoto: null,
        id: 16361,
      },
    ],
  },
  {
    employee: {
      id: 16271,
      companyId: 2,
      displayName: 'Hunter Kramer',
      designation: 'Theatre stage manager',
      ownerType: null,
      employeeFunction: null,
      email: 'hunter.kramer@abc.co',
      personalEmail: 'hunter.kramer@abc.co',
      workEmail: 'hunter.kramer@abc.co',
      preferredName: 'Hunter',
    },
    id: 471,
    publisherSelectedEmployees: [
      {
        label: 'Stephanie Freeman',
        subTitle: 'stephanie.freeman@abc.co',
        profilePhoto: null,
        id: 16128,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michael Lyons',
        subTitle: 'michael.lyons@abc.co',
        profilePhoto: null,
        id: 16187,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'David Bradley',
        subTitle: 'david.bradley@abc.co',
        profilePhoto: null,
        id: 16034,
      },
    ],
  },
  {
    employee: {
      id: 16272,
      companyId: 3,
      displayName: 'Christopher Williams',
      designation: 'Pharmacist, community',
      ownerType: null,
      employeeFunction: null,
      email: 'christopher.williams@abc.co',
      personalEmail: 'christopher.williams@abc.co',
      workEmail: 'christopher.williams@abc.co',
      preferredName: 'Christopher',
    },
    id: 472,
    publisherSelectedEmployees: [
      {
        label: 'Richard Camacho',
        subTitle: 'richard.camacho@abc.co',
        profilePhoto: null,
        id: 16275,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michele Gibson',
        subTitle: 'michele.gibson@abc.co',
        profilePhoto: null,
        id: 16182,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Michele Gibson',
        subTitle: 'michele.gibson@abc.co',
        profilePhoto: null,
        id: 16182,
      },
    ],
  },
  {
    employee: {
      id: 16273,
      companyId: 1,
      displayName: 'Nichole Alvarez',
      designation: 'Medical illustrator',
      ownerType: null,
      employeeFunction: null,
      email: 'nichole.alvarez@abc.co',
      personalEmail: 'nichole.alvarez@abc.co',
      workEmail: 'nichole.alvarez@abc.co',
      preferredName: 'Nichole',
    },
    id: 473,
    publisherSelectedEmployees: [
      {
        label: 'Sandra Gilbert',
        subTitle: 'sandra.gilbert@abc.co',
        profilePhoto: null,
        id: 16260,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Gavin Zhang',
        subTitle: 'gavin.zhang@abc.co',
        profilePhoto: null,
        id: 16266,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Desiree Smith',
        subTitle: 'desiree.smith@abc.co',
        profilePhoto: null,
        id: 16157,
      },
    ],
  },
  {
    employee: {
      id: 16274,
      companyId: 2,
      displayName: 'Ashley Gordon',
      designation: 'Volunteer coordinator',
      ownerType: null,
      employeeFunction: null,
      email: 'ashley.gordon@abc.co',
      personalEmail: 'ashley.gordon@abc.co',
      workEmail: 'ashley.gordon@abc.co',
      preferredName: 'Ashley',
    },
    id: 474,
    publisherSelectedEmployees: [
      {
        label: 'Mrs. Diane Reyes',
        subTitle: 'mrs..diane.reyes@abc.co',
        profilePhoto: null,
        id: 16350,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Olivia Harris',
        subTitle: 'olivia.harris@abc.co',
        profilePhoto: null,
        id: 16201,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Michelle Strickland',
        subTitle: 'michelle.strickland@abc.co',
        profilePhoto: null,
        id: 16141,
      },
    ],
  },
  {
    employee: {
      id: 16275,
      companyId: 3,
      displayName: 'Richard Camacho',
      designation: 'Scientist, research (life sciences)',
      ownerType: null,
      employeeFunction: null,
      email: 'richard.camacho@abc.co',
      personalEmail: 'richard.camacho@abc.co',
      workEmail: 'richard.camacho@abc.co',
      preferredName: 'Richard',
    },
    id: 475,
    publisherSelectedEmployees: [
      {
        label: 'Felicia Aguilar',
        subTitle: 'felicia.aguilar@abc.co',
        profilePhoto: null,
        id: 16336,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mr. Andrew Foster',
        subTitle: 'mr..andrew.foster@abc.co',
        profilePhoto: null,
        id: 16304,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sabrina Briggs',
        subTitle: 'sabrina.briggs@abc.co',
        profilePhoto: null,
        id: 16318,
      },
    ],
  },
  {
    employee: {
      id: 16276,
      companyId: 1,
      displayName: 'Mason Johnson',
      designation: 'Quality manager',
      ownerType: null,
      employeeFunction: null,
      email: 'mason.johnson@abc.co',
      personalEmail: 'mason.johnson@abc.co',
      workEmail: 'mason.johnson@abc.co',
      preferredName: 'Mason',
    },
    id: 476,
    publisherSelectedEmployees: [
      {
        label: 'Miss Patricia Gibson',
        subTitle: 'miss.patricia.gibson@abc.co',
        profilePhoto: null,
        id: 16110,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Emily Douglas',
        subTitle: 'emily.douglas@abc.co',
        profilePhoto: null,
        id: 16337,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Samantha Morse',
        subTitle: 'samantha.morse@abc.co',
        profilePhoto: null,
        id: 16186,
      },
    ],
  },
  {
    employee: {
      id: 16277,
      companyId: 2,
      displayName: 'Jessica Rodriguez',
      designation: 'Producer, radio',
      ownerType: null,
      employeeFunction: null,
      email: 'jessica.rodriguez@abc.co',
      personalEmail: 'jessica.rodriguez@abc.co',
      workEmail: 'jessica.rodriguez@abc.co',
      preferredName: 'Jessica',
    },
    id: 477,
    publisherSelectedEmployees: [
      {
        label: 'Kara Davis',
        subTitle: 'kara.davis@abc.co',
        profilePhoto: null,
        id: 16285,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Charles Mcgee',
        subTitle: 'charles.mcgee@abc.co',
        profilePhoto: null,
        id: 16020,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Joshua Holland',
        subTitle: 'joshua.holland@abc.co',
        profilePhoto: null,
        id: 16184,
      },
    ],
  },
  {
    employee: {
      id: 16278,
      companyId: 3,
      displayName: 'Bobby Franklin',
      designation: 'Brewing technologist',
      ownerType: null,
      employeeFunction: null,
      email: 'bobby.franklin@abc.co',
      personalEmail: 'bobby.franklin@abc.co',
      workEmail: 'bobby.franklin@abc.co',
      preferredName: 'Bobby',
    },
    id: 478,
    publisherSelectedEmployees: [
      {
        label: 'Linda Ramirez',
        subTitle: 'linda.ramirez@abc.co',
        profilePhoto: null,
        id: 16269,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brandy Wilson',
        subTitle: 'brandy.wilson@abc.co',
        profilePhoto: null,
        id: 16072,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jill Miller',
        subTitle: 'jill.miller@abc.co',
        profilePhoto: null,
        id: 16398,
      },
    ],
  },
  {
    employee: {
      id: 16279,
      companyId: 1,
      displayName: 'Marcus Richards',
      designation: 'Journalist, broadcasting',
      ownerType: null,
      employeeFunction: null,
      email: 'marcus.richards@abc.co',
      personalEmail: 'marcus.richards@abc.co',
      workEmail: 'marcus.richards@abc.co',
      preferredName: 'Marcus',
    },
    id: 479,
    publisherSelectedEmployees: [
      {
        label: 'Diana May',
        subTitle: 'diana.may@abc.co',
        profilePhoto: null,
        id: 16092,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Ian Cooper',
        subTitle: 'ian.cooper@abc.co',
        profilePhoto: null,
        id: 16007,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Erica Miller',
        subTitle: 'erica.miller@abc.co',
        profilePhoto: null,
        id: 16384,
      },
    ],
  },
  {
    employee: {
      id: 16280,
      companyId: 2,
      displayName: 'Kyle Phillips',
      designation: 'Risk analyst',
      ownerType: null,
      employeeFunction: null,
      email: 'kyle.phillips@abc.co',
      personalEmail: 'kyle.phillips@abc.co',
      workEmail: 'kyle.phillips@abc.co',
      preferredName: 'Kyle',
    },
    id: 480,
    publisherSelectedEmployees: [
      {
        label: 'Jonathan Wilkerson',
        subTitle: 'jonathan.wilkerson@abc.co',
        profilePhoto: null,
        id: 16019,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christopher Thomas',
        subTitle: 'christopher.thomas@abc.co',
        profilePhoto: null,
        id: 16296,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Edward Burgess',
        subTitle: 'edward.burgess@abc.co',
        profilePhoto: null,
        id: 16244,
      },
    ],
  },
  {
    employee: {
      id: 16281,
      companyId: 3,
      displayName: 'Annette Miles',
      designation: 'Structural engineer',
      ownerType: null,
      employeeFunction: null,
      email: 'annette.miles@abc.co',
      personalEmail: 'annette.miles@abc.co',
      workEmail: 'annette.miles@abc.co',
      preferredName: 'Annette',
    },
    id: 481,
    publisherSelectedEmployees: [
      {
        label: 'Vernon Huff',
        subTitle: 'vernon.huff@abc.co',
        profilePhoto: null,
        id: 16190,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Justin Riley',
        subTitle: 'justin.riley@abc.co',
        profilePhoto: null,
        id: 16321,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Lisa Goodwin',
        subTitle: 'lisa.goodwin@abc.co',
        profilePhoto: null,
        id: 16347,
      },
    ],
  },
  {
    employee: {
      id: 16282,
      companyId: 1,
      displayName: 'Cindy Hayes',
      designation: 'Estate agent',
      ownerType: null,
      employeeFunction: null,
      email: 'cindy.hayes@abc.co',
      personalEmail: 'cindy.hayes@abc.co',
      workEmail: 'cindy.hayes@abc.co',
      preferredName: 'Cindy',
    },
    id: 482,
    publisherSelectedEmployees: [
      {
        label: 'Gina Wilson',
        subTitle: 'gina.wilson@abc.co',
        profilePhoto: null,
        id: 16248,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Katie Anderson',
        subTitle: 'katie.anderson@abc.co',
        profilePhoto: null,
        id: 16068,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sergio Murphy',
        subTitle: 'sergio.murphy@abc.co',
        profilePhoto: null,
        id: 16268,
      },
    ],
  },
  {
    employee: {
      id: 16283,
      companyId: 2,
      displayName: 'Ronald Ross',
      designation: 'Chief of Staff',
      ownerType: null,
      employeeFunction: null,
      email: 'ronald.ross@abc.co',
      personalEmail: 'ronald.ross@abc.co',
      workEmail: 'ronald.ross@abc.co',
      preferredName: 'Ronald',
    },
    id: 483,
    publisherSelectedEmployees: [
      {
        label: 'Kyle Phillips',
        subTitle: 'kyle.phillips@abc.co',
        profilePhoto: null,
        id: 16280,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Nicholas Mcbride',
        subTitle: 'nicholas.mcbride@abc.co',
        profilePhoto: null,
        id: 16048,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jose Allen',
        subTitle: 'jose.allen@abc.co',
        profilePhoto: null,
        id: 16366,
      },
    ],
  },
  {
    employee: {
      id: 16284,
      companyId: 3,
      displayName: 'Erik Scott',
      designation: 'Designer, ceramics/pottery',
      ownerType: null,
      employeeFunction: null,
      email: 'erik.scott@abc.co',
      personalEmail: 'erik.scott@abc.co',
      workEmail: 'erik.scott@abc.co',
      preferredName: 'Erik',
    },
    id: 484,
    publisherSelectedEmployees: [
      {
        label: 'Linda Burns',
        subTitle: 'linda.burns@abc.co',
        profilePhoto: null,
        id: 16032,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michele Gibson',
        subTitle: 'michele.gibson@abc.co',
        profilePhoto: null,
        id: 16182,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Erica Miller',
        subTitle: 'erica.miller@abc.co',
        profilePhoto: null,
        id: 16384,
      },
    ],
  },
  {
    employee: {
      id: 16285,
      companyId: 1,
      displayName: 'Kara Davis',
      designation: 'Chartered certified accountant',
      ownerType: null,
      employeeFunction: null,
      email: 'kara.davis@abc.co',
      personalEmail: 'kara.davis@abc.co',
      workEmail: 'kara.davis@abc.co',
      preferredName: 'Kara',
    },
    id: 485,
    publisherSelectedEmployees: [
      {
        label: 'Jasmine King',
        subTitle: 'jasmine.king@abc.co',
        profilePhoto: null,
        id: 16335,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Elizabeth Sutton',
        subTitle: 'elizabeth.sutton@abc.co',
        profilePhoto: null,
        id: 16145,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sherry Decker',
        subTitle: 'sherry.decker@abc.co',
        profilePhoto: null,
        id: 16033,
      },
    ],
  },
  {
    employee: {
      id: 16286,
      companyId: 2,
      displayName: 'Brent Rodgers',
      designation: 'Conservator, furniture',
      ownerType: null,
      employeeFunction: null,
      email: 'brent.rodgers@abc.co',
      personalEmail: 'brent.rodgers@abc.co',
      workEmail: 'brent.rodgers@abc.co',
      preferredName: 'Brent',
    },
    id: 486,
    publisherSelectedEmployees: [
      {
        label: 'Parker Hill',
        subTitle: 'parker.hill@abc.co',
        profilePhoto: null,
        id: 16165,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jill Miller',
        subTitle: 'jill.miller@abc.co',
        profilePhoto: null,
        id: 16398,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Bobby Franklin',
        subTitle: 'bobby.franklin@abc.co',
        profilePhoto: null,
        id: 16278,
      },
    ],
  },
  {
    employee: {
      id: 16287,
      companyId: 3,
      displayName: 'Laurie Hoffman',
      designation: 'Landscape architect',
      ownerType: null,
      employeeFunction: null,
      email: 'laurie.hoffman@abc.co',
      personalEmail: 'laurie.hoffman@abc.co',
      workEmail: 'laurie.hoffman@abc.co',
      preferredName: 'Laurie',
    },
    id: 487,
    publisherSelectedEmployees: [
      {
        label: 'Ashley Singleton',
        subTitle: 'ashley.singleton@abc.co',
        profilePhoto: null,
        id: 16353,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Laura Riley',
        subTitle: 'laura.riley@abc.co',
        profilePhoto: null,
        id: 16062,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Susan Smith',
        subTitle: 'susan.smith@abc.co',
        profilePhoto: null,
        id: 16361,
      },
    ],
  },
  {
    employee: {
      id: 16288,
      companyId: 1,
      displayName: 'Jennifer Russo',
      designation: 'Pharmacologist',
      ownerType: null,
      employeeFunction: null,
      email: 'jennifer.russo@abc.co',
      personalEmail: 'jennifer.russo@abc.co',
      workEmail: 'jennifer.russo@abc.co',
      preferredName: 'Jennifer',
    },
    id: 488,
    publisherSelectedEmployees: [
      {
        label: 'Danielle Odonnell',
        subTitle: 'danielle.odonnell@abc.co',
        profilePhoto: null,
        id: 16075,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Tiffany Watson',
        subTitle: 'tiffany.watson@abc.co',
        profilePhoto: null,
        id: 16392,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Hunter Kramer',
        subTitle: 'hunter.kramer@abc.co',
        profilePhoto: null,
        id: 16271,
      },
    ],
  },
  {
    employee: {
      id: 16289,
      companyId: 2,
      displayName: 'Michelle Schmitt',
      designation: 'Tourism officer',
      ownerType: null,
      employeeFunction: null,
      email: 'michelle.schmitt@abc.co',
      personalEmail: 'michelle.schmitt@abc.co',
      workEmail: 'michelle.schmitt@abc.co',
      preferredName: 'Michelle',
    },
    id: 489,
    publisherSelectedEmployees: [
      {
        label: 'Jamie Kerr',
        subTitle: 'jamie.kerr@abc.co',
        profilePhoto: null,
        id: 16176,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Patricia Peterson',
        subTitle: 'patricia.peterson@abc.co',
        profilePhoto: null,
        id: 16027,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sean Wyatt',
        subTitle: 'sean.wyatt@abc.co',
        profilePhoto: null,
        id: 16326,
      },
    ],
  },
  {
    employee: {
      id: 16290,
      companyId: 3,
      displayName: 'Brian Romero',
      designation: 'Designer, fashion/clothing',
      ownerType: null,
      employeeFunction: null,
      email: 'brian.romero@abc.co',
      personalEmail: 'brian.romero@abc.co',
      workEmail: 'brian.romero@abc.co',
      preferredName: 'Brian',
    },
    id: 490,
    publisherSelectedEmployees: [
      {
        label: 'Juan Reyes',
        subTitle: 'juan.reyes@abc.co',
        profilePhoto: null,
        id: 16208,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Linda Ramirez',
        subTitle: 'linda.ramirez@abc.co',
        profilePhoto: null,
        id: 16269,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'David Martinez',
        subTitle: 'david.martinez@abc.co',
        profilePhoto: null,
        id: 16163,
      },
    ],
  },
  {
    employee: {
      id: 16291,
      companyId: 1,
      displayName: 'Courtney Rodriguez',
      designation: 'Surveyor, commercial/residential',
      ownerType: null,
      employeeFunction: null,
      email: 'courtney.rodriguez@abc.co',
      personalEmail: 'courtney.rodriguez@abc.co',
      workEmail: 'courtney.rodriguez@abc.co',
      preferredName: 'Courtney',
    },
    id: 491,
    publisherSelectedEmployees: [
      {
        label: 'James Martin',
        subTitle: 'james.martin@abc.co',
        profilePhoto: null,
        id: 16031,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kathryn Farrell',
        subTitle: 'kathryn.farrell@abc.co',
        profilePhoto: null,
        id: 16059,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sherry Decker',
        subTitle: 'sherry.decker@abc.co',
        profilePhoto: null,
        id: 16033,
      },
    ],
  },
  {
    employee: {
      id: 16292,
      companyId: 2,
      displayName: 'Phillip Andrews',
      designation: 'Pilot, airline',
      ownerType: null,
      employeeFunction: null,
      email: 'phillip.andrews@abc.co',
      personalEmail: 'phillip.andrews@abc.co',
      workEmail: 'phillip.andrews@abc.co',
      preferredName: 'Phillip',
    },
    id: 492,
    publisherSelectedEmployees: [
      {
        label: 'Dwayne Gilmore',
        subTitle: 'dwayne.gilmore@abc.co',
        profilePhoto: null,
        id: 16202,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Miss Patricia Gibson',
        subTitle: 'miss.patricia.gibson@abc.co',
        profilePhoto: null,
        id: 16110,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Zachary Taylor',
        subTitle: 'zachary.taylor@abc.co',
        profilePhoto: null,
        id: 16022,
      },
    ],
  },
  {
    employee: {
      id: 16293,
      companyId: 3,
      displayName: 'Vanessa Cardenas',
      designation: 'Visual merchandiser',
      ownerType: null,
      employeeFunction: null,
      email: 'vanessa.cardenas@abc.co',
      personalEmail: 'vanessa.cardenas@abc.co',
      workEmail: 'vanessa.cardenas@abc.co',
      preferredName: 'Vanessa',
    },
    id: 493,
    publisherSelectedEmployees: [
      {
        label: 'Amy Edwards',
        subTitle: 'amy.edwards@abc.co',
        profilePhoto: null,
        id: 16058,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Parker Hill',
        subTitle: 'parker.hill@abc.co',
        profilePhoto: null,
        id: 16165,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jason Bauer',
        subTitle: 'jason.bauer@abc.co',
        profilePhoto: null,
        id: 16364,
      },
    ],
  },
  {
    employee: {
      id: 16294,
      companyId: 1,
      displayName: 'Kristin Lynch',
      designation: 'Geologist, engineering',
      ownerType: null,
      employeeFunction: null,
      email: 'kristin.lynch@abc.co',
      personalEmail: 'kristin.lynch@abc.co',
      workEmail: 'kristin.lynch@abc.co',
      preferredName: 'Kristin',
    },
    id: 494,
    publisherSelectedEmployees: [
      {
        label: 'James Hernandez',
        subTitle: 'james.hernandez@abc.co',
        profilePhoto: null,
        id: 16122,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jessica Fowler',
        subTitle: 'jessica.fowler@abc.co',
        profilePhoto: null,
        id: 16387,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kathryn Farrell',
        subTitle: 'kathryn.farrell@abc.co',
        profilePhoto: null,
        id: 16059,
      },
    ],
  },
  {
    employee: {
      id: 16295,
      companyId: 2,
      displayName: 'Donald Farmer',
      designation: 'Librarian, academic',
      ownerType: null,
      employeeFunction: null,
      email: 'donald.farmer@abc.co',
      personalEmail: 'donald.farmer@abc.co',
      workEmail: 'donald.farmer@abc.co',
      preferredName: 'Donald',
    },
    id: 495,
    publisherSelectedEmployees: [
      {
        label: 'John Jones',
        subTitle: 'john.jones@abc.co',
        profilePhoto: null,
        id: 16035,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jonathan Glass MD',
        subTitle: 'jonathan.glass.md@abc.co',
        profilePhoto: null,
        id: 16382,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Lisa Gibbs',
        subTitle: 'lisa.gibbs@abc.co',
        profilePhoto: null,
        id: 16175,
      },
    ],
  },
  {
    employee: {
      id: 16296,
      companyId: 3,
      displayName: 'Christopher Thomas',
      designation: 'Oncologist',
      ownerType: null,
      employeeFunction: null,
      email: 'christopher.thomas@abc.co',
      personalEmail: 'christopher.thomas@abc.co',
      workEmail: 'christopher.thomas@abc.co',
      preferredName: 'Christopher',
    },
    id: 496,
    publisherSelectedEmployees: [
      {
        label: 'Diana May',
        subTitle: 'diana.may@abc.co',
        profilePhoto: null,
        id: 16092,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'James Lewis',
        subTitle: 'james.lewis@abc.co',
        profilePhoto: null,
        id: 16133,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Andrew Lucas',
        subTitle: 'andrew.lucas@abc.co',
        profilePhoto: null,
        id: 16378,
      },
    ],
  },
  {
    employee: {
      id: 16297,
      companyId: 1,
      displayName: 'Patrick Bonilla',
      designation: 'Chemist, analytical',
      ownerType: null,
      employeeFunction: null,
      email: 'patrick.bonilla@abc.co',
      personalEmail: 'patrick.bonilla@abc.co',
      workEmail: 'patrick.bonilla@abc.co',
      preferredName: 'Patrick',
    },
    id: 497,
    publisherSelectedEmployees: [
      {
        label: 'Willie Durham',
        subTitle: 'willie.durham@abc.co',
        profilePhoto: null,
        id: 16205,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Leslie Bell',
        subTitle: 'leslie.bell@abc.co',
        profilePhoto: null,
        id: 16324,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Michael Miller',
        subTitle: 'michael.miller@abc.co',
        profilePhoto: null,
        id: 16338,
      },
    ],
  },
  {
    employee: {
      id: 16298,
      companyId: 2,
      displayName: 'Cindy Barnes',
      designation: 'Licensed conveyancer',
      ownerType: null,
      employeeFunction: null,
      email: 'cindy.barnes@abc.co',
      personalEmail: 'cindy.barnes@abc.co',
      workEmail: 'cindy.barnes@abc.co',
      preferredName: 'Cindy',
    },
    id: 498,
    publisherSelectedEmployees: [
      {
        label: 'Erica Miller',
        subTitle: 'erica.miller@abc.co',
        profilePhoto: null,
        id: 16384,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'David Brown',
        subTitle: 'david.brown@abc.co',
        profilePhoto: null,
        id: 16040,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kimberly Acosta',
        subTitle: 'kimberly.acosta@abc.co',
        profilePhoto: null,
        id: 16362,
      },
    ],
  },
  {
    employee: {
      id: 16299,
      companyId: 3,
      displayName: 'Eric Nguyen',
      designation: 'Tax inspector',
      ownerType: null,
      employeeFunction: null,
      email: 'eric.nguyen@abc.co',
      personalEmail: 'eric.nguyen@abc.co',
      workEmail: 'eric.nguyen@abc.co',
      preferredName: 'Eric',
    },
    id: 499,
    publisherSelectedEmployees: [
      {
        label: 'Ronald Ross',
        subTitle: 'ronald.ross@abc.co',
        profilePhoto: null,
        id: 16283,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Marcus Richards',
        subTitle: 'marcus.richards@abc.co',
        profilePhoto: null,
        id: 16279,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Christopher Gonzalez',
        subTitle: 'christopher.gonzalez@abc.co',
        profilePhoto: null,
        id: 16351,
      },
    ],
  },
  {
    employee: {
      id: 16300,
      companyId: 1,
      displayName: 'Sophia Moore',
      designation: 'Waste management officer',
      ownerType: null,
      employeeFunction: null,
      email: 'sophia.moore@abc.co',
      personalEmail: 'sophia.moore@abc.co',
      workEmail: 'sophia.moore@abc.co',
      preferredName: 'Sophia',
    },
    id: 500,
    publisherSelectedEmployees: [
      {
        label: 'Alex Hernandez',
        subTitle: 'alex.hernandez@abc.co',
        profilePhoto: null,
        id: 16138,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Shawn Ramirez',
        subTitle: 'shawn.ramirez@abc.co',
        profilePhoto: null,
        id: 16134,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Andrew Ferrell',
        subTitle: 'andrew.ferrell@abc.co',
        profilePhoto: null,
        id: 16256,
      },
    ],
  },
  {
    employee: {
      id: 16301,
      companyId: 2,
      displayName: 'Brad Ramos',
      designation: 'Photographer',
      ownerType: null,
      employeeFunction: null,
      email: 'brad.ramos@abc.co',
      personalEmail: 'brad.ramos@abc.co',
      workEmail: 'brad.ramos@abc.co',
      preferredName: 'Brad',
    },
    id: 501,
    publisherSelectedEmployees: [
      {
        label: 'Charles Pitts',
        subTitle: 'charles.pitts@abc.co',
        profilePhoto: null,
        id: 16220,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'David Bradley',
        subTitle: 'david.bradley@abc.co',
        profilePhoto: null,
        id: 16034,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Monica Herrera',
        subTitle: 'monica.herrera@abc.co',
        profilePhoto: null,
        id: 16008,
      },
    ],
  },
  {
    employee: {
      id: 16302,
      companyId: 3,
      displayName: 'Mr. Donald Fischer',
      designation: 'Clothing/textile technologist',
      ownerType: null,
      employeeFunction: null,
      email: 'mr..donald.fischer@abc.co',
      personalEmail: 'mr..donald.fischer@abc.co',
      workEmail: 'mr..donald.fischer@abc.co',
      preferredName: 'Mr.',
    },
    id: 502,
    publisherSelectedEmployees: [
      {
        label: 'Deborah Miller',
        subTitle: 'deborah.miller@abc.co',
        profilePhoto: null,
        id: 16179,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Dwayne Gilmore',
        subTitle: 'dwayne.gilmore@abc.co',
        profilePhoto: null,
        id: 16202,
      },
    ],
  },
  {
    employee: {
      id: 16303,
      companyId: 1,
      displayName: 'Brian Gregory',
      designation: 'Therapist, horticultural',
      ownerType: null,
      employeeFunction: null,
      email: 'brian.gregory@abc.co',
      personalEmail: 'brian.gregory@abc.co',
      workEmail: 'brian.gregory@abc.co',
      preferredName: 'Brian',
    },
    id: 503,
    publisherSelectedEmployees: [
      {
        label: 'James Powers',
        subTitle: 'james.powers@abc.co',
        profilePhoto: null,
        id: 16065,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Victor Vaughn',
        subTitle: 'victor.vaughn@abc.co',
        profilePhoto: null,
        id: 16234,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Brian Fitzgerald',
        subTitle: 'brian.fitzgerald@abc.co',
        profilePhoto: null,
        id: 16394,
      },
    ],
  },
  {
    employee: {
      id: 16304,
      companyId: 2,
      displayName: 'Mr. Andrew Foster',
      designation: 'Tour manager',
      ownerType: null,
      employeeFunction: null,
      email: 'mr..andrew.foster@abc.co',
      personalEmail: 'mr..andrew.foster@abc.co',
      workEmail: 'mr..andrew.foster@abc.co',
      preferredName: 'Mr.',
    },
    id: 504,
    publisherSelectedEmployees: [
      {
        label: 'Michael Miller',
        subTitle: 'michael.miller@abc.co',
        profilePhoto: null,
        id: 16338,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Allison Hill',
        subTitle: 'allison.hill@abc.co',
        profilePhoto: null,
        id: 16000,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jonathan Young',
        subTitle: 'jonathan.young@abc.co',
        profilePhoto: null,
        id: 16357,
      },
    ],
  },
  {
    employee: {
      id: 16305,
      companyId: 3,
      displayName: 'Dan Dougherty',
      designation: 'Copywriter, advertising',
      ownerType: null,
      employeeFunction: null,
      email: 'dan.dougherty@abc.co',
      personalEmail: 'dan.dougherty@abc.co',
      workEmail: 'dan.dougherty@abc.co',
      preferredName: 'Dan',
    },
    id: 505,
    publisherSelectedEmployees: [
      {
        label: 'William Wilson',
        subTitle: 'william.wilson@abc.co',
        profilePhoto: null,
        id: 16096,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jasmine King',
        subTitle: 'jasmine.king@abc.co',
        profilePhoto: null,
        id: 16335,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Alicia Hubbard',
        subTitle: 'alicia.hubbard@abc.co',
        profilePhoto: null,
        id: 16191,
      },
    ],
  },
  {
    employee: {
      id: 16306,
      companyId: 1,
      displayName: 'Donna Wilson',
      designation: 'Research scientist (medical)',
      ownerType: null,
      employeeFunction: null,
      email: 'donna.wilson@abc.co',
      personalEmail: 'donna.wilson@abc.co',
      workEmail: 'donna.wilson@abc.co',
      preferredName: 'Donna',
    },
    id: 506,
    publisherSelectedEmployees: [
      {
        label: 'Seth Reese',
        subTitle: 'seth.reese@abc.co',
        profilePhoto: null,
        id: 16315,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Allison Hill',
        subTitle: 'allison.hill@abc.co',
        profilePhoto: null,
        id: 16000,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Andrea Young',
        subTitle: 'andrea.young@abc.co',
        profilePhoto: null,
        id: 16043,
      },
    ],
  },
  {
    employee: {
      id: 16307,
      companyId: 2,
      displayName: 'Casey James',
      designation: 'Event organiser',
      ownerType: null,
      employeeFunction: null,
      email: 'casey.james@abc.co',
      personalEmail: 'casey.james@abc.co',
      workEmail: 'casey.james@abc.co',
      preferredName: 'Casey',
    },
    id: 507,
    publisherSelectedEmployees: [
      {
        label: 'David Davidson',
        subTitle: 'david.davidson@abc.co',
        profilePhoto: null,
        id: 16352,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brian Romero',
        subTitle: 'brian.romero@abc.co',
        profilePhoto: null,
        id: 16290,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Stephanie Lucas',
        subTitle: 'stephanie.lucas@abc.co',
        profilePhoto: null,
        id: 16242,
      },
    ],
  },
  {
    employee: {
      id: 16308,
      companyId: 3,
      displayName: 'Sandra Drake',
      designation: 'Building surveyor',
      ownerType: null,
      employeeFunction: null,
      email: 'sandra.drake@abc.co',
      personalEmail: 'sandra.drake@abc.co',
      workEmail: 'sandra.drake@abc.co',
      preferredName: 'Sandra',
    },
    id: 508,
    publisherSelectedEmployees: [
      {
        label: 'Kristen Patterson',
        subTitle: 'kristen.patterson@abc.co',
        profilePhoto: null,
        id: 16078,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Diane Beck',
        subTitle: 'diane.beck@abc.co',
        profilePhoto: null,
        id: 16107,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Carolyn Daniel',
        subTitle: 'carolyn.daniel@abc.co',
        profilePhoto: null,
        id: 16014,
      },
    ],
  },
  {
    employee: {
      id: 16309,
      companyId: 1,
      displayName: 'Patrick Graham',
      designation: 'Psychiatric nurse',
      ownerType: null,
      employeeFunction: null,
      email: 'patrick.graham@abc.co',
      personalEmail: 'patrick.graham@abc.co',
      workEmail: 'patrick.graham@abc.co',
      preferredName: 'Patrick',
    },
    id: 509,
    publisherSelectedEmployees: [
      {
        label: 'Elizabeth Sutton',
        subTitle: 'elizabeth.sutton@abc.co',
        profilePhoto: null,
        id: 16145,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Patrick Graham',
        subTitle: 'patrick.graham@abc.co',
        profilePhoto: null,
        id: 16309,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Pamela Jackson',
        subTitle: 'pamela.jackson@abc.co',
        profilePhoto: null,
        id: 16140,
      },
    ],
  },
  {
    employee: {
      id: 16310,
      companyId: 2,
      displayName: 'Shannon Johnston',
      designation: 'Teacher, secondary school',
      ownerType: null,
      employeeFunction: null,
      email: 'shannon.johnston@abc.co',
      personalEmail: 'shannon.johnston@abc.co',
      workEmail: 'shannon.johnston@abc.co',
      preferredName: 'Shannon',
    },
    id: 510,
    publisherSelectedEmployees: [
      {
        label: 'Austin Osborne',
        subTitle: 'austin.osborne@abc.co',
        profilePhoto: null,
        id: 16390,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jackie Tran',
        subTitle: 'jackie.tran@abc.co',
        profilePhoto: null,
        id: 16161,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Seth Reese',
        subTitle: 'seth.reese@abc.co',
        profilePhoto: null,
        id: 16315,
      },
    ],
  },
  {
    employee: {
      id: 16311,
      companyId: 3,
      displayName: 'Mark Roberts',
      designation: 'Ophthalmologist',
      ownerType: null,
      employeeFunction: null,
      email: 'mark.roberts@abc.co',
      personalEmail: 'mark.roberts@abc.co',
      workEmail: 'mark.roberts@abc.co',
      preferredName: 'Mark',
    },
    id: 511,
    publisherSelectedEmployees: [
      {
        label: 'Zachary Moore',
        subTitle: 'zachary.moore@abc.co',
        profilePhoto: null,
        id: 16342,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'George Miranda',
        subTitle: 'george.miranda@abc.co',
        profilePhoto: null,
        id: 16344,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Joel Baxter',
        subTitle: 'joel.baxter@abc.co',
        profilePhoto: null,
        id: 16050,
      },
    ],
  },
  {
    employee: {
      id: 16312,
      companyId: 1,
      displayName: 'Frederick Solis',
      designation: 'Waste management officer',
      ownerType: null,
      employeeFunction: null,
      email: 'frederick.solis@abc.co',
      personalEmail: 'frederick.solis@abc.co',
      workEmail: 'frederick.solis@abc.co',
      preferredName: 'Frederick',
    },
    id: 512,
    publisherSelectedEmployees: [
      {
        label: 'Sarah Rivera',
        subTitle: 'sarah.rivera@abc.co',
        profilePhoto: null,
        id: 16093,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mr. Donald Fischer',
        subTitle: 'mr..donald.fischer@abc.co',
        profilePhoto: null,
        id: 16302,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Deborah Miller',
        subTitle: 'deborah.miller@abc.co',
        profilePhoto: null,
        id: 16179,
      },
    ],
  },
  {
    employee: {
      id: 16313,
      companyId: 2,
      displayName: 'Michael Cox',
      designation: 'Press sub',
      ownerType: null,
      employeeFunction: null,
      email: 'michael.cox@abc.co',
      personalEmail: 'michael.cox@abc.co',
      workEmail: 'michael.cox@abc.co',
      preferredName: 'Michael',
    },
    id: 513,
    publisherSelectedEmployees: [
      {
        label: 'Kyle Reed',
        subTitle: 'kyle.reed@abc.co',
        profilePhoto: null,
        id: 16095,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Patrick Moore',
        subTitle: 'patrick.moore@abc.co',
        profilePhoto: null,
        id: 16259,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sandra Gilbert',
        subTitle: 'sandra.gilbert@abc.co',
        profilePhoto: null,
        id: 16260,
      },
    ],
  },
  {
    employee: {
      id: 16314,
      companyId: 3,
      displayName: 'Dana Chapman',
      designation: 'Scientist, research (physical sciences)',
      ownerType: null,
      employeeFunction: null,
      email: 'dana.chapman@abc.co',
      personalEmail: 'dana.chapman@abc.co',
      workEmail: 'dana.chapman@abc.co',
      preferredName: 'Dana',
    },
    id: 514,
    publisherSelectedEmployees: [
      {
        label: 'Dan Dougherty',
        subTitle: 'dan.dougherty@abc.co',
        profilePhoto: null,
        id: 16305,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kimberly Acosta',
        subTitle: 'kimberly.acosta@abc.co',
        profilePhoto: null,
        id: 16362,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Gary Santiago',
        subTitle: 'gary.santiago@abc.co',
        profilePhoto: null,
        id: 16195,
      },
    ],
  },
  {
    employee: {
      id: 16315,
      companyId: 1,
      displayName: 'Seth Reese',
      designation: 'Environmental consultant',
      ownerType: null,
      employeeFunction: null,
      email: 'seth.reese@abc.co',
      personalEmail: 'seth.reese@abc.co',
      workEmail: 'seth.reese@abc.co',
      preferredName: 'Seth',
    },
    id: 515,
    publisherSelectedEmployees: [
      {
        label: 'Eric Sanders',
        subTitle: 'eric.sanders@abc.co',
        profilePhoto: null,
        id: 16377,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Samantha Morse',
        subTitle: 'samantha.morse@abc.co',
        profilePhoto: null,
        id: 16186,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jason Bauer',
        subTitle: 'jason.bauer@abc.co',
        profilePhoto: null,
        id: 16364,
      },
    ],
  },
  {
    employee: {
      id: 16316,
      companyId: 2,
      displayName: 'Christopher Dixon',
      designation: 'Clothing/textile technologist',
      ownerType: null,
      employeeFunction: null,
      email: 'christopher.dixon@abc.co',
      personalEmail: 'christopher.dixon@abc.co',
      workEmail: 'christopher.dixon@abc.co',
      preferredName: 'Christopher',
    },
    id: 516,
    publisherSelectedEmployees: [
      {
        label: 'Bob Pitts',
        subTitle: 'bob.pitts@abc.co',
        profilePhoto: null,
        id: 16229,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'David Martinez',
        subTitle: 'david.martinez@abc.co',
        profilePhoto: null,
        id: 16163,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sara Calhoun',
        subTitle: 'sara.calhoun@abc.co',
        profilePhoto: null,
        id: 16130,
      },
    ],
  },
  {
    employee: {
      id: 16317,
      companyId: 3,
      displayName: 'Cheyenne Parsons',
      designation: 'Make',
      ownerType: null,
      employeeFunction: null,
      email: 'cheyenne.parsons@abc.co',
      personalEmail: 'cheyenne.parsons@abc.co',
      workEmail: 'cheyenne.parsons@abc.co',
      preferredName: 'Cheyenne',
    },
    id: 517,
    publisherSelectedEmployees: [
      {
        label: 'Devin Schaefer',
        subTitle: 'devin.schaefer@abc.co',
        profilePhoto: null,
        id: 16015,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michael Reyes',
        subTitle: 'michael.reyes@abc.co',
        profilePhoto: null,
        id: 16088,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Cindy Barnes',
        subTitle: 'cindy.barnes@abc.co',
        profilePhoto: null,
        id: 16298,
      },
    ],
  },
  {
    employee: {
      id: 16318,
      companyId: 1,
      displayName: 'Sabrina Briggs',
      designation: 'Fashion designer',
      ownerType: null,
      employeeFunction: null,
      email: 'sabrina.briggs@abc.co',
      personalEmail: 'sabrina.briggs@abc.co',
      workEmail: 'sabrina.briggs@abc.co',
      preferredName: 'Sabrina',
    },
    id: 518,
    publisherSelectedEmployees: [
      {
        label: 'Mary Thompson',
        subTitle: 'mary.thompson@abc.co',
        profilePhoto: null,
        id: 16320,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'David Thompson',
        subTitle: 'david.thompson@abc.co',
        profilePhoto: null,
        id: 16319,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kathleen Aguilar',
        subTitle: 'kathleen.aguilar@abc.co',
        profilePhoto: null,
        id: 16230,
      },
    ],
  },
  {
    employee: {
      id: 16319,
      companyId: 2,
      displayName: 'David Thompson',
      designation: 'Designer, ceramics/pottery',
      ownerType: null,
      employeeFunction: null,
      email: 'david.thompson@abc.co',
      personalEmail: 'david.thompson@abc.co',
      workEmail: 'david.thompson@abc.co',
      preferredName: 'David',
    },
    id: 519,
    publisherSelectedEmployees: [
      {
        label: 'Ashley Wise',
        subTitle: 'ashley.wise@abc.co',
        profilePhoto: null,
        id: 16343,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jennifer Brown',
        subTitle: 'jennifer.brown@abc.co',
        profilePhoto: null,
        id: 16024,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Timothy Walls',
        subTitle: 'timothy.walls@abc.co',
        profilePhoto: null,
        id: 16066,
      },
    ],
  },
  {
    employee: {
      id: 16320,
      companyId: 3,
      displayName: 'Mary Thompson',
      designation: 'Research officer, political party',
      ownerType: null,
      employeeFunction: null,
      email: 'mary.thompson@abc.co',
      personalEmail: 'mary.thompson@abc.co',
      workEmail: 'mary.thompson@abc.co',
      preferredName: 'Mary',
    },
    id: 520,
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 16001,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christopher Hensley',
        subTitle: 'christopher.hensley@abc.co',
        profilePhoto: null,
        id: 16118,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Amanda Diaz',
        subTitle: 'amanda.diaz@abc.co',
        profilePhoto: null,
        id: 16243,
      },
    ],
  },
  {
    employee: {
      id: 16321,
      companyId: 1,
      displayName: 'Justin Riley',
      designation: 'Systems analyst',
      ownerType: null,
      employeeFunction: null,
      email: 'justin.riley@abc.co',
      personalEmail: 'justin.riley@abc.co',
      workEmail: 'justin.riley@abc.co',
      preferredName: 'Justin',
    },
    id: 521,
    publisherSelectedEmployees: [
      {
        label: 'Steven Cooper',
        subTitle: 'steven.cooper@abc.co',
        profilePhoto: null,
        id: 16330,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Amanda Diaz',
        subTitle: 'amanda.diaz@abc.co',
        profilePhoto: null,
        id: 16346,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'David Walsh',
        subTitle: 'david.walsh@abc.co',
        profilePhoto: null,
        id: 16119,
      },
    ],
  },
  {
    employee: {
      id: 16322,
      companyId: 2,
      displayName: 'Victoria Morris',
      designation: 'Interpreter',
      ownerType: null,
      employeeFunction: null,
      email: 'victoria.morris@abc.co',
      personalEmail: 'victoria.morris@abc.co',
      workEmail: 'victoria.morris@abc.co',
      preferredName: 'Victoria',
    },
    id: 522,
    publisherSelectedEmployees: [
      {
        label: 'Jennifer Brown',
        subTitle: 'jennifer.brown@abc.co',
        profilePhoto: null,
        id: 16024,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Amanda Jones',
        subTitle: 'amanda.jones@abc.co',
        profilePhoto: null,
        id: 16224,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Katherine Miller',
        subTitle: 'katherine.miller@abc.co',
        profilePhoto: null,
        id: 16188,
      },
    ],
  },
  {
    employee: {
      id: 16323,
      companyId: 3,
      displayName: 'Barry Ramos',
      designation: 'Immunologist',
      ownerType: null,
      employeeFunction: null,
      email: 'barry.ramos@abc.co',
      personalEmail: 'barry.ramos@abc.co',
      workEmail: 'barry.ramos@abc.co',
      preferredName: 'Barry',
    },
    id: 523,
    publisherSelectedEmployees: [
      {
        label: 'Susan Brooks',
        subTitle: 'susan.brooks@abc.co',
        profilePhoto: null,
        id: 16143,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jackie Tran',
        subTitle: 'jackie.tran@abc.co',
        profilePhoto: null,
        id: 16161,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jerry Ramirez',
        subTitle: 'jerry.ramirez@abc.co',
        profilePhoto: null,
        id: 16004,
      },
    ],
  },
  {
    employee: {
      id: 16324,
      companyId: 1,
      displayName: 'Leslie Bell',
      designation: 'Buyer, retail',
      ownerType: null,
      employeeFunction: null,
      email: 'leslie.bell@abc.co',
      personalEmail: 'leslie.bell@abc.co',
      workEmail: 'leslie.bell@abc.co',
      preferredName: 'Leslie',
    },
    id: 524,
    publisherSelectedEmployees: [
      {
        label: 'Tim Patton',
        subTitle: 'tim.patton@abc.co',
        profilePhoto: null,
        id: 16086,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Patrick Graham',
        subTitle: 'patrick.graham@abc.co',
        profilePhoto: null,
        id: 16309,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Joseph Knight',
        subTitle: 'joseph.knight@abc.co',
        profilePhoto: null,
        id: 16228,
      },
    ],
  },
  {
    employee: {
      id: 16325,
      companyId: 2,
      displayName: 'Jesse Brown',
      designation: 'Historic buildings inspector/conservation officer',
      ownerType: null,
      employeeFunction: null,
      email: 'jesse.brown@abc.co',
      personalEmail: 'jesse.brown@abc.co',
      workEmail: 'jesse.brown@abc.co',
      preferredName: 'Jesse',
    },
    id: 525,
    publisherSelectedEmployees: [
      {
        label: 'Christopher Gonzalez',
        subTitle: 'christopher.gonzalez@abc.co',
        profilePhoto: null,
        id: 16351,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Dakota Moody',
        subTitle: 'dakota.moody@abc.co',
        profilePhoto: null,
        id: 16376,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'George Miranda',
        subTitle: 'george.miranda@abc.co',
        profilePhoto: null,
        id: 16344,
      },
    ],
  },
  {
    employee: {
      id: 16326,
      companyId: 3,
      displayName: 'Sean Wyatt',
      designation: 'Volunteer coordinator',
      ownerType: null,
      employeeFunction: null,
      email: 'sean.wyatt@abc.co',
      personalEmail: 'sean.wyatt@abc.co',
      workEmail: 'sean.wyatt@abc.co',
      preferredName: 'Sean',
    },
    id: 526,
    publisherSelectedEmployees: [
      {
        label: 'Jerry Ramirez',
        subTitle: 'jerry.ramirez@abc.co',
        profilePhoto: null,
        id: 16004,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Phillip Nelson',
        subTitle: 'phillip.nelson@abc.co',
        profilePhoto: null,
        id: 16354,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Pamela Romero',
        subTitle: 'pamela.romero@abc.co',
        profilePhoto: null,
        id: 16029,
      },
    ],
  },
  {
    employee: {
      id: 16327,
      companyId: 1,
      displayName: 'Janice Carpenter',
      designation: 'Architectural technologist',
      ownerType: null,
      employeeFunction: null,
      email: 'janice.carpenter@abc.co',
      personalEmail: 'janice.carpenter@abc.co',
      workEmail: 'janice.carpenter@abc.co',
      preferredName: 'Janice',
    },
    id: 527,
    publisherSelectedEmployees: [
      {
        label: 'Cynthia Rowe',
        subTitle: 'cynthia.rowe@abc.co',
        profilePhoto: null,
        id: 16215,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'James Lewis',
        subTitle: 'james.lewis@abc.co',
        profilePhoto: null,
        id: 16133,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Cheyenne Parsons',
        subTitle: 'cheyenne.parsons@abc.co',
        profilePhoto: null,
        id: 16317,
      },
    ],
  },
  {
    employee: {
      id: 16328,
      companyId: 2,
      displayName: 'Robert Pearson',
      designation: 'IT technical support officer',
      ownerType: null,
      employeeFunction: null,
      email: 'robert.pearson@abc.co',
      personalEmail: 'robert.pearson@abc.co',
      workEmail: 'robert.pearson@abc.co',
      preferredName: 'Robert',
    },
    id: 528,
    publisherSelectedEmployees: [
      {
        label: 'Cheyenne Gregory',
        subTitle: 'cheyenne.gregory@abc.co',
        profilePhoto: null,
        id: 16349,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'April Booth',
        subTitle: 'april.booth@abc.co',
        profilePhoto: null,
        id: 16199,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Thomas Bradley',
        subTitle: 'thomas.bradley@abc.co',
        profilePhoto: null,
        id: 16018,
      },
    ],
  },
  {
    employee: {
      id: 16329,
      companyId: 3,
      displayName: 'Kathryn Rosario',
      designation: 'Production designer, theatre/television/film',
      ownerType: null,
      employeeFunction: null,
      email: 'kathryn.rosario@abc.co',
      personalEmail: 'kathryn.rosario@abc.co',
      workEmail: 'kathryn.rosario@abc.co',
      preferredName: 'Kathryn',
    },
    id: 529,
    publisherSelectedEmployees: [
      {
        label: 'Linda Ramirez',
        subTitle: 'linda.ramirez@abc.co',
        profilePhoto: null,
        id: 16269,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'James Martin',
        subTitle: 'james.martin@abc.co',
        profilePhoto: null,
        id: 16031,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'William Wilson',
        subTitle: 'william.wilson@abc.co',
        profilePhoto: null,
        id: 16096,
      },
    ],
  },
  {
    employee: {
      id: 16330,
      companyId: 1,
      displayName: 'Steven Cooper',
      designation: 'Chartered accountant',
      ownerType: null,
      employeeFunction: null,
      email: 'steven.cooper@abc.co',
      personalEmail: 'steven.cooper@abc.co',
      workEmail: 'steven.cooper@abc.co',
      preferredName: 'Steven',
    },
    id: 530,
    publisherSelectedEmployees: [
      {
        label: 'Brad Ramos',
        subTitle: 'brad.ramos@abc.co',
        profilePhoto: null,
        id: 16301,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Thomas Bradley',
        subTitle: 'thomas.bradley@abc.co',
        profilePhoto: null,
        id: 16018,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Amanda Jones',
        subTitle: 'amanda.jones@abc.co',
        profilePhoto: null,
        id: 16224,
      },
    ],
  },
  {
    employee: {
      id: 16331,
      companyId: 2,
      displayName: 'Carrie Wright',
      designation: 'Primary school teacher',
      ownerType: null,
      employeeFunction: null,
      email: 'carrie.wright@abc.co',
      personalEmail: 'carrie.wright@abc.co',
      workEmail: 'carrie.wright@abc.co',
      preferredName: 'Carrie',
    },
    id: 531,
    publisherSelectedEmployees: [
      {
        label: 'Jackie Tran',
        subTitle: 'jackie.tran@abc.co',
        profilePhoto: null,
        id: 16161,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Stephen Taylor',
        subTitle: 'stephen.taylor@abc.co',
        profilePhoto: null,
        id: 16257,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'George Miranda',
        subTitle: 'george.miranda@abc.co',
        profilePhoto: null,
        id: 16344,
      },
    ],
  },
  {
    employee: {
      id: 16332,
      companyId: 3,
      displayName: 'Kelly Bishop MD',
      designation: 'Heritage manager',
      ownerType: null,
      employeeFunction: null,
      email: 'kelly.bishop.md@abc.co',
      personalEmail: 'kelly.bishop.md@abc.co',
      workEmail: 'kelly.bishop.md@abc.co',
      preferredName: 'Kelly',
    },
    id: 532,
    publisherSelectedEmployees: [
      {
        label: 'Cheyenne Parsons',
        subTitle: 'cheyenne.parsons@abc.co',
        profilePhoto: null,
        id: 16317,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'David Sheppard',
        subTitle: 'david.sheppard@abc.co',
        profilePhoto: null,
        id: 16348,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Morgan Munoz',
        subTitle: 'morgan.munoz@abc.co',
        profilePhoto: null,
        id: 16189,
      },
    ],
  },
  {
    employee: {
      id: 16333,
      companyId: 1,
      displayName: 'Raymond Shelton',
      designation: 'Associate Professor',
      ownerType: null,
      employeeFunction: null,
      email: 'raymond.shelton@abc.co',
      personalEmail: 'raymond.shelton@abc.co',
      workEmail: 'raymond.shelton@abc.co',
      preferredName: 'Raymond',
    },
    id: 533,
    publisherSelectedEmployees: [
      {
        label: 'Kevin Pena',
        subTitle: 'kevin.pena@abc.co',
        profilePhoto: null,
        id: 16105,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Emily Douglas',
        subTitle: 'emily.douglas@abc.co',
        profilePhoto: null,
        id: 16337,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Charles Pitts',
        subTitle: 'charles.pitts@abc.co',
        profilePhoto: null,
        id: 16220,
      },
    ],
  },
  {
    employee: {
      id: 16334,
      companyId: 2,
      displayName: 'Maria Jones',
      designation: 'Chief Marketing Officer',
      ownerType: null,
      employeeFunction: null,
      email: 'maria.jones@abc.co',
      personalEmail: 'maria.jones@abc.co',
      workEmail: 'maria.jones@abc.co',
      preferredName: 'Maria',
    },
    id: 534,
    publisherSelectedEmployees: [
      {
        label: 'Michael Stafford',
        subTitle: 'michael.stafford@abc.co',
        profilePhoto: null,
        id: 16112,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Emily Douglas',
        subTitle: 'emily.douglas@abc.co',
        profilePhoto: null,
        id: 16337,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jeffrey Potts',
        subTitle: 'jeffrey.potts@abc.co',
        profilePhoto: null,
        id: 16355,
      },
    ],
  },
  {
    employee: {
      id: 16335,
      companyId: 3,
      displayName: 'Jasmine King',
      designation: 'Toxicologist',
      ownerType: null,
      employeeFunction: null,
      email: 'jasmine.king@abc.co',
      personalEmail: 'jasmine.king@abc.co',
      workEmail: 'jasmine.king@abc.co',
      preferredName: 'Jasmine',
    },
    id: 535,
    publisherSelectedEmployees: [
      {
        label: 'Sarah Rivera',
        subTitle: 'sarah.rivera@abc.co',
        profilePhoto: null,
        id: 16093,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Alexandra Le',
        subTitle: 'alexandra.le@abc.co',
        profilePhoto: null,
        id: 16026,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Andrew Berg',
        subTitle: 'andrew.berg@abc.co',
        profilePhoto: null,
        id: 16386,
      },
    ],
  },
  {
    employee: {
      id: 16336,
      companyId: 1,
      displayName: 'Felicia Aguilar',
      designation: 'Counsellor',
      ownerType: null,
      employeeFunction: null,
      email: 'felicia.aguilar@abc.co',
      personalEmail: 'felicia.aguilar@abc.co',
      workEmail: 'felicia.aguilar@abc.co',
      preferredName: 'Felicia',
    },
    id: 536,
    publisherSelectedEmployees: [
      {
        label: 'Angelica Keith',
        subTitle: 'angelica.keith@abc.co',
        profilePhoto: null,
        id: 16153,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'David Scott',
        subTitle: 'david.scott@abc.co',
        profilePhoto: null,
        id: 16231,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Kelly Bishop MD',
        subTitle: 'kelly.bishop.md@abc.co',
        profilePhoto: null,
        id: 16332,
      },
    ],
  },
  {
    employee: {
      id: 16337,
      companyId: 2,
      displayName: 'Emily Douglas',
      designation: "Nurse, children's",
      ownerType: null,
      employeeFunction: null,
      email: 'emily.douglas@abc.co',
      personalEmail: 'emily.douglas@abc.co',
      workEmail: 'emily.douglas@abc.co',
      preferredName: 'Emily',
    },
    id: 537,
    publisherSelectedEmployees: [
      {
        label: 'Rachel Weber',
        subTitle: 'rachel.weber@abc.co',
        profilePhoto: null,
        id: 16183,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Janice Carpenter',
        subTitle: 'janice.carpenter@abc.co',
        profilePhoto: null,
        id: 16327,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sarah Morgan',
        subTitle: 'sarah.morgan@abc.co',
        profilePhoto: null,
        id: 16210,
      },
    ],
  },
  {
    employee: {
      id: 16338,
      companyId: 3,
      displayName: 'Michael Miller',
      designation: 'Surveyor, land/geomatics',
      ownerType: null,
      employeeFunction: null,
      email: 'michael.miller@abc.co',
      personalEmail: 'michael.miller@abc.co',
      workEmail: 'michael.miller@abc.co',
      preferredName: 'Michael',
    },
    id: 538,
    publisherSelectedEmployees: [
      {
        label: 'Julie Roberts',
        subTitle: 'julie.roberts@abc.co',
        profilePhoto: null,
        id: 16232,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Erik Scott',
        subTitle: 'erik.scott@abc.co',
        profilePhoto: null,
        id: 16284,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Laura Riley',
        subTitle: 'laura.riley@abc.co',
        profilePhoto: null,
        id: 16062,
      },
    ],
  },
  {
    employee: {
      id: 16339,
      companyId: 1,
      displayName: 'Rickey Li',
      designation: 'Secretary/administrator',
      ownerType: null,
      employeeFunction: null,
      email: 'rickey.li@abc.co',
      personalEmail: 'rickey.li@abc.co',
      workEmail: 'rickey.li@abc.co',
      preferredName: 'Rickey',
    },
    id: 539,
    publisherSelectedEmployees: [
      {
        label: 'Robert Contreras',
        subTitle: 'robert.contreras@abc.co',
        profilePhoto: null,
        id: 16115,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Amy Hernandez',
        subTitle: 'amy.hernandez@abc.co',
        profilePhoto: null,
        id: 16173,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Andrea Young',
        subTitle: 'andrea.young@abc.co',
        profilePhoto: null,
        id: 16043,
      },
    ],
  },
  {
    employee: {
      id: 16340,
      companyId: 2,
      displayName: 'Michael Romero',
      designation: 'Adult nurse',
      ownerType: null,
      employeeFunction: null,
      email: 'michael.romero@abc.co',
      personalEmail: 'michael.romero@abc.co',
      workEmail: 'michael.romero@abc.co',
      preferredName: 'Michael',
    },
    id: 540,
    publisherSelectedEmployees: [
      {
        label: 'Christopher Williams',
        subTitle: 'christopher.williams@abc.co',
        profilePhoto: null,
        id: 16272,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Nicholas Adams',
        subTitle: 'nicholas.adams@abc.co',
        profilePhoto: null,
        id: 16152,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Carlos Whitney',
        subTitle: 'carlos.whitney@abc.co',
        profilePhoto: null,
        id: 16077,
      },
    ],
  },
  {
    employee: {
      id: 16341,
      companyId: 3,
      displayName: 'Christopher Lewis',
      designation: 'Radiographer, diagnostic',
      ownerType: null,
      employeeFunction: null,
      email: 'christopher.lewis@abc.co',
      personalEmail: 'christopher.lewis@abc.co',
      workEmail: 'christopher.lewis@abc.co',
      preferredName: 'Christopher',
    },
    id: 541,
    publisherSelectedEmployees: [
      {
        label: 'Kristin Lynch',
        subTitle: 'kristin.lynch@abc.co',
        profilePhoto: null,
        id: 16294,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Pamela Jackson',
        subTitle: 'pamela.jackson@abc.co',
        profilePhoto: null,
        id: 16140,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Robert Evans',
        subTitle: 'robert.evans@abc.co',
        profilePhoto: null,
        id: 16071,
      },
    ],
  },
  {
    employee: {
      id: 16342,
      companyId: 1,
      displayName: 'Zachary Moore',
      designation: 'Hotel manager',
      ownerType: null,
      employeeFunction: null,
      email: 'zachary.moore@abc.co',
      personalEmail: 'zachary.moore@abc.co',
      workEmail: 'zachary.moore@abc.co',
      preferredName: 'Zachary',
    },
    id: 542,
    publisherSelectedEmployees: [
      {
        label: 'George Miranda',
        subTitle: 'george.miranda@abc.co',
        profilePhoto: null,
        id: 16344,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Aaron Gomez',
        subTitle: 'aaron.gomez@abc.co',
        profilePhoto: null,
        id: 16367,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Leonard Holland',
        subTitle: 'leonard.holland@abc.co',
        profilePhoto: null,
        id: 16254,
      },
    ],
  },
  {
    employee: {
      id: 16343,
      companyId: 2,
      displayName: 'Ashley Wise',
      designation: 'Secretary/administrator',
      ownerType: null,
      employeeFunction: null,
      email: 'ashley.wise@abc.co',
      personalEmail: 'ashley.wise@abc.co',
      workEmail: 'ashley.wise@abc.co',
      preferredName: 'Ashley',
    },
    id: 543,
    publisherSelectedEmployees: [
      {
        label: 'Maria Henry',
        subTitle: 'maria.henry@abc.co',
        profilePhoto: null,
        id: 16159,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Ariana Jennings',
        subTitle: 'ariana.jennings@abc.co',
        profilePhoto: null,
        id: 16262,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Dwayne Gilmore',
        subTitle: 'dwayne.gilmore@abc.co',
        profilePhoto: null,
        id: 16202,
      },
    ],
  },
  {
    employee: {
      id: 16344,
      companyId: 3,
      displayName: 'George Miranda',
      designation: 'Conservator, museum/gallery',
      ownerType: null,
      employeeFunction: null,
      email: 'george.miranda@abc.co',
      personalEmail: 'george.miranda@abc.co',
      workEmail: 'george.miranda@abc.co',
      preferredName: 'George',
    },
    id: 544,
    publisherSelectedEmployees: [
      {
        label: 'Robert Evans',
        subTitle: 'robert.evans@abc.co',
        profilePhoto: null,
        id: 16071,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Susan Wilson',
        subTitle: 'susan.wilson@abc.co',
        profilePhoto: null,
        id: 16395,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jeffrey Potts',
        subTitle: 'jeffrey.potts@abc.co',
        profilePhoto: null,
        id: 16355,
      },
    ],
  },
  {
    employee: {
      id: 16345,
      companyId: 1,
      displayName: 'Brittany White',
      designation: 'Diagnostic radiographer',
      ownerType: null,
      employeeFunction: null,
      email: 'brittany.white@abc.co',
      personalEmail: 'brittany.white@abc.co',
      workEmail: 'brittany.white@abc.co',
      preferredName: 'Brittany',
    },
    id: 545,
    publisherSelectedEmployees: [
      {
        label: 'Susan Brooks',
        subTitle: 'susan.brooks@abc.co',
        profilePhoto: null,
        id: 16143,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Cody Cox',
        subTitle: 'cody.cox@abc.co',
        profilePhoto: null,
        id: 16200,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Timothy Kane',
        subTitle: 'timothy.kane@abc.co',
        profilePhoto: null,
        id: 16214,
      },
    ],
  },
  {
    employee: {
      id: 16346,
      companyId: 2,
      displayName: 'Amanda Diaz',
      designation: 'Field seismologist',
      ownerType: null,
      employeeFunction: null,
      email: 'amanda.diaz@abc.co',
      personalEmail: 'amanda.diaz@abc.co',
      workEmail: 'amanda.diaz@abc.co',
      preferredName: 'Amanda',
    },
    id: 546,
    publisherSelectedEmployees: [
      {
        label: 'Jonathan Young',
        subTitle: 'jonathan.young@abc.co',
        profilePhoto: null,
        id: 16357,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kendra Sanders',
        subTitle: 'kendra.sanders@abc.co',
        profilePhoto: null,
        id: 16393,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Dan Dougherty',
        subTitle: 'dan.dougherty@abc.co',
        profilePhoto: null,
        id: 16305,
      },
    ],
  },
  {
    employee: {
      id: 16347,
      companyId: 3,
      displayName: 'Lisa Goodwin',
      designation: 'Production assistant, radio',
      ownerType: null,
      employeeFunction: null,
      email: 'lisa.goodwin@abc.co',
      personalEmail: 'lisa.goodwin@abc.co',
      workEmail: 'lisa.goodwin@abc.co',
      preferredName: 'Lisa',
    },
    id: 547,
    publisherSelectedEmployees: [
      {
        label: 'Travis Johnson',
        subTitle: 'travis.johnson@abc.co',
        profilePhoto: null,
        id: 16391,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Andrew Graham',
        subTitle: 'andrew.graham@abc.co',
        profilePhoto: null,
        id: 16097,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Ronald Ross',
        subTitle: 'ronald.ross@abc.co',
        profilePhoto: null,
        id: 16283,
      },
    ],
  },
  {
    employee: {
      id: 16348,
      companyId: 1,
      displayName: 'David Sheppard',
      designation: 'Psychotherapist, child',
      ownerType: null,
      employeeFunction: null,
      email: 'david.sheppard@abc.co',
      personalEmail: 'david.sheppard@abc.co',
      workEmail: 'david.sheppard@abc.co',
      preferredName: 'David',
    },
    id: 548,
    publisherSelectedEmployees: [
      {
        label: 'Allen Rogers',
        subTitle: 'allen.rogers@abc.co',
        profilePhoto: null,
        id: 16129,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Dana Chapman',
        subTitle: 'dana.chapman@abc.co',
        profilePhoto: null,
        id: 16314,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Terry Coffey',
        subTitle: 'terry.coffey@abc.co',
        profilePhoto: null,
        id: 16247,
      },
    ],
  },
  {
    employee: {
      id: 16349,
      companyId: 2,
      displayName: 'Cheyenne Gregory',
      designation: 'Teacher, English as a foreign language',
      ownerType: null,
      employeeFunction: null,
      email: 'cheyenne.gregory@abc.co',
      personalEmail: 'cheyenne.gregory@abc.co',
      workEmail: 'cheyenne.gregory@abc.co',
      preferredName: 'Cheyenne',
    },
    id: 549,
    publisherSelectedEmployees: [
      {
        label: 'Connor West',
        subTitle: 'connor.west@abc.co',
        profilePhoto: null,
        id: 16049,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Nathan Freeman',
        subTitle: 'nathan.freeman@abc.co',
        profilePhoto: null,
        id: 16158,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Richard Walter',
        subTitle: 'richard.walter@abc.co',
        profilePhoto: null,
        id: 16245,
      },
    ],
  },
  {
    employee: {
      id: 16350,
      companyId: 3,
      displayName: 'Mrs. Diane Reyes',
      designation: 'Secretary, company',
      ownerType: null,
      employeeFunction: null,
      email: 'mrs..diane.reyes@abc.co',
      personalEmail: 'mrs..diane.reyes@abc.co',
      workEmail: 'mrs..diane.reyes@abc.co',
      preferredName: 'Mrs.',
    },
    id: 550,
    publisherSelectedEmployees: [
      {
        label: 'Gina Wilson',
        subTitle: 'gina.wilson@abc.co',
        profilePhoto: null,
        id: 16248,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sherry Wood',
        subTitle: 'sherry.wood@abc.co',
        profilePhoto: null,
        id: 16069,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Patrick Bonilla',
        subTitle: 'patrick.bonilla@abc.co',
        profilePhoto: null,
        id: 16297,
      },
    ],
  },
  {
    employee: {
      id: 16351,
      companyId: 1,
      displayName: 'Christopher Gonzalez',
      designation: 'Trade union research officer',
      ownerType: null,
      employeeFunction: null,
      email: 'christopher.gonzalez@abc.co',
      personalEmail: 'christopher.gonzalez@abc.co',
      workEmail: 'christopher.gonzalez@abc.co',
      preferredName: 'Christopher',
    },
    id: 551,
    publisherSelectedEmployees: [
      {
        label: 'Janice Carpenter',
        subTitle: 'janice.carpenter@abc.co',
        profilePhoto: null,
        id: 16327,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Dakota Moody',
        subTitle: 'dakota.moody@abc.co',
        profilePhoto: null,
        id: 16376,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Linda Burns',
        subTitle: 'linda.burns@abc.co',
        profilePhoto: null,
        id: 16032,
      },
    ],
  },
  {
    employee: {
      id: 16352,
      companyId: 2,
      displayName: 'David Davidson',
      designation: 'Meteorologist',
      ownerType: null,
      employeeFunction: null,
      email: 'david.davidson@abc.co',
      personalEmail: 'david.davidson@abc.co',
      workEmail: 'david.davidson@abc.co',
      preferredName: 'David',
    },
    id: 552,
    publisherSelectedEmployees: [
      {
        label: 'Cody Williams',
        subTitle: 'cody.williams@abc.co',
        profilePhoto: null,
        id: 16171,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Hunter Kramer',
        subTitle: 'hunter.kramer@abc.co',
        profilePhoto: null,
        id: 16271,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Joseph Hill',
        subTitle: 'joseph.hill@abc.co',
        profilePhoto: null,
        id: 16168,
      },
    ],
  },
  {
    employee: {
      id: 16353,
      companyId: 3,
      displayName: 'Ashley Singleton',
      designation: 'Company secretary',
      ownerType: null,
      employeeFunction: null,
      email: 'ashley.singleton@abc.co',
      personalEmail: 'ashley.singleton@abc.co',
      workEmail: 'ashley.singleton@abc.co',
      preferredName: 'Ashley',
    },
    id: 553,
    publisherSelectedEmployees: [
      {
        label: 'Roy Torres',
        subTitle: 'roy.torres@abc.co',
        profilePhoto: null,
        id: 16104,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jesse Flowers',
        subTitle: 'jesse.flowers@abc.co',
        profilePhoto: null,
        id: 16012,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Joshua Holland',
        subTitle: 'joshua.holland@abc.co',
        profilePhoto: null,
        id: 16184,
      },
    ],
  },
  {
    employee: {
      id: 16354,
      companyId: 1,
      displayName: 'Phillip Nelson',
      designation: 'Scientific laboratory technician',
      ownerType: null,
      employeeFunction: null,
      email: 'phillip.nelson@abc.co',
      personalEmail: 'phillip.nelson@abc.co',
      workEmail: 'phillip.nelson@abc.co',
      preferredName: 'Phillip',
    },
    id: 554,
    publisherSelectedEmployees: [
      {
        label: 'Bobby Franklin',
        subTitle: 'bobby.franklin@abc.co',
        profilePhoto: null,
        id: 16278,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'David Thompson',
        subTitle: 'david.thompson@abc.co',
        profilePhoto: null,
        id: 16319,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Crystal Pham',
        subTitle: 'crystal.pham@abc.co',
        profilePhoto: null,
        id: 16240,
      },
    ],
  },
  {
    employee: {
      id: 16355,
      companyId: 2,
      displayName: 'Jeffrey Potts',
      designation: 'Environmental education officer',
      ownerType: null,
      employeeFunction: null,
      email: 'jeffrey.potts@abc.co',
      personalEmail: 'jeffrey.potts@abc.co',
      workEmail: 'jeffrey.potts@abc.co',
      preferredName: 'Jeffrey',
    },
    id: 555,
    publisherSelectedEmployees: [
      {
        label: 'Jesse Flowers',
        subTitle: 'jesse.flowers@abc.co',
        profilePhoto: null,
        id: 16012,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Nicholas Mcbride',
        subTitle: 'nicholas.mcbride@abc.co',
        profilePhoto: null,
        id: 16048,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Marie Christian',
        subTitle: 'marie.christian@abc.co',
        profilePhoto: null,
        id: 16222,
      },
    ],
  },
  {
    employee: {
      id: 16356,
      companyId: 3,
      displayName: 'Stacey Arias',
      designation: 'Patent examiner',
      ownerType: null,
      employeeFunction: null,
      email: 'stacey.arias@abc.co',
      personalEmail: 'stacey.arias@abc.co',
      workEmail: 'stacey.arias@abc.co',
      preferredName: 'Stacey',
    },
    id: 556,
    publisherSelectedEmployees: [
      {
        label: 'Courtney Rodriguez',
        subTitle: 'courtney.rodriguez@abc.co',
        profilePhoto: null,
        id: 16291,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Joshua Holland',
        subTitle: 'joshua.holland@abc.co',
        profilePhoto: null,
        id: 16184,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Brent Jordan',
        subTitle: 'brent.jordan@abc.co',
        profilePhoto: null,
        id: 16046,
      },
    ],
  },
  {
    employee: {
      id: 16357,
      companyId: 1,
      displayName: 'Jonathan Young',
      designation: 'Ceramics designer',
      ownerType: null,
      employeeFunction: null,
      email: 'jonathan.young@abc.co',
      personalEmail: 'jonathan.young@abc.co',
      workEmail: 'jonathan.young@abc.co',
      preferredName: 'Jonathan',
    },
    id: 557,
    publisherSelectedEmployees: [
      {
        label: 'Ross Price',
        subTitle: 'ross.price@abc.co',
        profilePhoto: null,
        id: 16124,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Diane Beck',
        subTitle: 'diane.beck@abc.co',
        profilePhoto: null,
        id: 16107,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Justin Riley',
        subTitle: 'justin.riley@abc.co',
        profilePhoto: null,
        id: 16321,
      },
    ],
  },
  {
    employee: {
      id: 16358,
      companyId: 2,
      displayName: 'Alfred Galvan',
      designation: 'Legal executive',
      ownerType: null,
      employeeFunction: null,
      email: 'alfred.galvan@abc.co',
      personalEmail: 'alfred.galvan@abc.co',
      workEmail: 'alfred.galvan@abc.co',
      preferredName: 'Alfred',
    },
    id: 558,
    publisherSelectedEmployees: [
      {
        label: 'James Hernandez',
        subTitle: 'james.hernandez@abc.co',
        profilePhoto: null,
        id: 16122,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jacob Hunter',
        subTitle: 'jacob.hunter@abc.co',
        profilePhoto: null,
        id: 16147,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Christopher Thomas',
        subTitle: 'christopher.thomas@abc.co',
        profilePhoto: null,
        id: 16296,
      },
    ],
  },
  {
    employee: {
      id: 16359,
      companyId: 3,
      displayName: 'Brenda Mitchell',
      designation: 'Public house manager',
      ownerType: null,
      employeeFunction: null,
      email: 'brenda.mitchell@abc.co',
      personalEmail: 'brenda.mitchell@abc.co',
      workEmail: 'brenda.mitchell@abc.co',
      preferredName: 'Brenda',
    },
    id: 559,
    publisherSelectedEmployees: [
      {
        label: 'Hunter Kramer',
        subTitle: 'hunter.kramer@abc.co',
        profilePhoto: null,
        id: 16271,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Emily Smith',
        subTitle: 'emily.smith@abc.co',
        profilePhoto: null,
        id: 16204,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Janice Carpenter',
        subTitle: 'janice.carpenter@abc.co',
        profilePhoto: null,
        id: 16327,
      },
    ],
  },
  {
    employee: {
      id: 16360,
      companyId: 1,
      displayName: 'Brenda Thornton',
      designation: 'Production assistant, radio',
      ownerType: null,
      employeeFunction: null,
      email: 'brenda.thornton@abc.co',
      personalEmail: 'brenda.thornton@abc.co',
      workEmail: 'brenda.thornton@abc.co',
      preferredName: 'Brenda',
    },
    id: 560,
    publisherSelectedEmployees: [
      {
        label: 'Lisa Gibbs',
        subTitle: 'lisa.gibbs@abc.co',
        profilePhoto: null,
        id: 16175,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Andrew Graham',
        subTitle: 'andrew.graham@abc.co',
        profilePhoto: null,
        id: 16097,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Barry Ramos',
        subTitle: 'barry.ramos@abc.co',
        profilePhoto: null,
        id: 16323,
      },
    ],
  },
  {
    employee: {
      id: 16361,
      companyId: 2,
      displayName: 'Susan Smith',
      designation: 'Engineer, structural',
      ownerType: null,
      employeeFunction: null,
      email: 'susan.smith@abc.co',
      personalEmail: 'susan.smith@abc.co',
      workEmail: 'susan.smith@abc.co',
      preferredName: 'Susan',
    },
    id: 561,
    publisherSelectedEmployees: [
      {
        label: 'Evelyn Williams',
        subTitle: 'evelyn.williams@abc.co',
        profilePhoto: null,
        id: 16373,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Leslie Bell',
        subTitle: 'leslie.bell@abc.co',
        profilePhoto: null,
        id: 16324,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jose Allen',
        subTitle: 'jose.allen@abc.co',
        profilePhoto: null,
        id: 16366,
      },
    ],
  },
  {
    employee: {
      id: 16362,
      companyId: 3,
      displayName: 'Kimberly Acosta',
      designation: 'Secretary, company',
      ownerType: null,
      employeeFunction: null,
      email: 'kimberly.acosta@abc.co',
      personalEmail: 'kimberly.acosta@abc.co',
      workEmail: 'kimberly.acosta@abc.co',
      preferredName: 'Kimberly',
    },
    id: 562,
    publisherSelectedEmployees: [
      {
        label: 'Carlos Walls',
        subTitle: 'carlos.walls@abc.co',
        profilePhoto: null,
        id: 16044,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Stacey Arias',
        subTitle: 'stacey.arias@abc.co',
        profilePhoto: null,
        id: 16356,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Nicholas Sheppard',
        subTitle: 'nicholas.sheppard@abc.co',
        profilePhoto: null,
        id: 16150,
      },
    ],
  },
  {
    employee: {
      id: 16363,
      companyId: 1,
      displayName: 'Ricardo Young',
      designation: 'Community development worker',
      ownerType: null,
      employeeFunction: null,
      email: 'ricardo.young@abc.co',
      personalEmail: 'ricardo.young@abc.co',
      workEmail: 'ricardo.young@abc.co',
      preferredName: 'Ricardo',
    },
    id: 563,
    publisherSelectedEmployees: [
      {
        label: 'Betty Alvarez',
        subTitle: 'betty.alvarez@abc.co',
        profilePhoto: null,
        id: 16036,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Eric Nguyen',
        subTitle: 'eric.nguyen@abc.co',
        profilePhoto: null,
        id: 16299,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Pamela Jackson',
        subTitle: 'pamela.jackson@abc.co',
        profilePhoto: null,
        id: 16140,
      },
    ],
  },
  {
    employee: {
      id: 16364,
      companyId: 2,
      displayName: 'Jason Bauer',
      designation: 'Programmer, systems',
      ownerType: null,
      employeeFunction: null,
      email: 'jason.bauer@abc.co',
      personalEmail: 'jason.bauer@abc.co',
      workEmail: 'jason.bauer@abc.co',
      preferredName: 'Jason',
    },
    id: 564,
    publisherSelectedEmployees: [
      {
        label: 'Pamela Thompson',
        subTitle: 'pamela.thompson@abc.co',
        profilePhoto: null,
        id: 16192,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Austin Osborne',
        subTitle: 'austin.osborne@abc.co',
        profilePhoto: null,
        id: 16390,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Michael Stafford',
        subTitle: 'michael.stafford@abc.co',
        profilePhoto: null,
        id: 16112,
      },
    ],
  },
  {
    employee: {
      id: 16365,
      companyId: 3,
      displayName: 'Russell Porter',
      designation: 'Social worker',
      ownerType: null,
      employeeFunction: null,
      email: 'russell.porter@abc.co',
      personalEmail: 'russell.porter@abc.co',
      workEmail: 'russell.porter@abc.co',
      preferredName: 'Russell',
    },
    id: 565,
    publisherSelectedEmployees: [
      {
        label: 'Patrick Rivera',
        subTitle: 'patrick.rivera@abc.co',
        profilePhoto: null,
        id: 16162,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Zachary Ferrell',
        subTitle: 'zachary.ferrell@abc.co',
        profilePhoto: null,
        id: 16067,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
  },
  {
    employee: {
      id: 16366,
      companyId: 1,
      displayName: 'Jose Allen',
      designation: 'Cytogeneticist',
      ownerType: null,
      employeeFunction: null,
      email: 'jose.allen@abc.co',
      personalEmail: 'jose.allen@abc.co',
      workEmail: 'jose.allen@abc.co',
      preferredName: 'Jose',
    },
    id: 566,
    publisherSelectedEmployees: [
      {
        label: 'Crystal Robinson',
        subTitle: 'crystal.robinson@abc.co',
        profilePhoto: null,
        id: 16041,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Sophia Moore',
        subTitle: 'sophia.moore@abc.co',
        profilePhoto: null,
        id: 16300,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Michael Roberts',
        subTitle: 'michael.roberts@abc.co',
        profilePhoto: null,
        id: 16196,
      },
    ],
  },
  {
    employee: {
      id: 16367,
      companyId: 2,
      displayName: 'Aaron Gomez',
      designation: 'Teacher, English as a foreign language',
      ownerType: null,
      employeeFunction: null,
      email: 'aaron.gomez@abc.co',
      personalEmail: 'aaron.gomez@abc.co',
      workEmail: 'aaron.gomez@abc.co',
      preferredName: 'Aaron',
    },
    id: 567,
    publisherSelectedEmployees: [
      {
        label: 'Christopher Hensley',
        subTitle: 'christopher.hensley@abc.co',
        profilePhoto: null,
        id: 16118,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michael Miller',
        subTitle: 'michael.miller@abc.co',
        profilePhoto: null,
        id: 16338,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Elizabeth Sutton',
        subTitle: 'elizabeth.sutton@abc.co',
        profilePhoto: null,
        id: 16145,
      },
    ],
  },
  {
    employee: {
      id: 16368,
      companyId: 3,
      displayName: 'Matthew Miller',
      designation: 'Media planner',
      ownerType: null,
      employeeFunction: null,
      email: 'matthew.miller@abc.co',
      personalEmail: 'matthew.miller@abc.co',
      workEmail: 'matthew.miller@abc.co',
      preferredName: 'Matthew',
    },
    id: 568,
    publisherSelectedEmployees: [
      {
        label: 'Maria Brown',
        subTitle: 'maria.brown@abc.co',
        profilePhoto: null,
        id: 16263,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Maria Jones',
        subTitle: 'maria.jones@abc.co',
        profilePhoto: null,
        id: 16334,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Austin Osborne',
        subTitle: 'austin.osborne@abc.co',
        profilePhoto: null,
        id: 16390,
      },
    ],
  },
  {
    employee: {
      id: 16369,
      companyId: 1,
      displayName: 'Joseph Romero',
      designation: 'Runner, broadcasting/film/video',
      ownerType: null,
      employeeFunction: null,
      email: 'joseph.romero@abc.co',
      personalEmail: 'joseph.romero@abc.co',
      workEmail: 'joseph.romero@abc.co',
      preferredName: 'Joseph',
    },
    id: 569,
    publisherSelectedEmployees: [
      {
        label: 'Elizabeth Ortiz',
        subTitle: 'elizabeth.ortiz@abc.co',
        profilePhoto: null,
        id: 16255,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'James Powers',
        subTitle: 'james.powers@abc.co',
        profilePhoto: null,
        id: 16065,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Robert Costa',
        subTitle: 'robert.costa@abc.co',
        profilePhoto: null,
        id: 16194,
      },
    ],
  },
  {
    employee: {
      id: 16370,
      companyId: 2,
      displayName: 'Jeanette Harrison',
      designation: 'Naval architect',
      ownerType: null,
      employeeFunction: null,
      email: 'jeanette.harrison@abc.co',
      personalEmail: 'jeanette.harrison@abc.co',
      workEmail: 'jeanette.harrison@abc.co',
      preferredName: 'Jeanette',
    },
    id: 570,
    publisherSelectedEmployees: [
      {
        label: 'George Miranda',
        subTitle: 'george.miranda@abc.co',
        profilePhoto: null,
        id: 16344,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Nathan Freeman',
        subTitle: 'nathan.freeman@abc.co',
        profilePhoto: null,
        id: 16158,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Zachary Taylor',
        subTitle: 'zachary.taylor@abc.co',
        profilePhoto: null,
        id: 16022,
      },
    ],
  },
  {
    employee: {
      id: 16371,
      companyId: 3,
      displayName: 'Mrs. Alexis Kramer',
      designation: 'Location manager',
      ownerType: null,
      employeeFunction: null,
      email: 'mrs..alexis.kramer@abc.co',
      personalEmail: 'mrs..alexis.kramer@abc.co',
      workEmail: 'mrs..alexis.kramer@abc.co',
      preferredName: 'Mrs.',
    },
    id: 571,
    publisherSelectedEmployees: [
      {
        label: 'Mrs. Rachel Gibson',
        subTitle: 'mrs..rachel.gibson@abc.co',
        profilePhoto: null,
        id: 16055,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michelle Schmitt',
        subTitle: 'michelle.schmitt@abc.co',
        profilePhoto: null,
        id: 16289,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Cody Cox',
        subTitle: 'cody.cox@abc.co',
        profilePhoto: null,
        id: 16200,
      },
    ],
  },
  {
    employee: {
      id: 16372,
      companyId: 1,
      displayName: 'Matthew Garcia',
      designation: 'Television camera operator',
      ownerType: null,
      employeeFunction: null,
      email: 'matthew.garcia@abc.co',
      personalEmail: 'matthew.garcia@abc.co',
      workEmail: 'matthew.garcia@abc.co',
      preferredName: 'Matthew',
    },
    id: 572,
    publisherSelectedEmployees: [
      {
        label: 'Aaron Gomez',
        subTitle: 'aaron.gomez@abc.co',
        profilePhoto: null,
        id: 16367,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Michael Berger',
        subTitle: 'michael.berger@abc.co',
        profilePhoto: null,
        id: 16226,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Alicia Gilmore',
        subTitle: 'alicia.gilmore@abc.co',
        profilePhoto: null,
        id: 16125,
      },
    ],
  },
  {
    employee: {
      id: 16373,
      companyId: 2,
      displayName: 'Evelyn Williams',
      designation: 'Sports coach',
      ownerType: null,
      employeeFunction: null,
      email: 'evelyn.williams@abc.co',
      personalEmail: 'evelyn.williams@abc.co',
      workEmail: 'evelyn.williams@abc.co',
      preferredName: 'Evelyn',
    },
    id: 573,
    publisherSelectedEmployees: [
      {
        label: 'Joel Baxter',
        subTitle: 'joel.baxter@abc.co',
        profilePhoto: null,
        id: 16050,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Stephanie Lucas',
        subTitle: 'stephanie.lucas@abc.co',
        profilePhoto: null,
        id: 16242,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jamie Kerr',
        subTitle: 'jamie.kerr@abc.co',
        profilePhoto: null,
        id: 16176,
      },
    ],
  },
  {
    employee: {
      id: 16374,
      companyId: 3,
      displayName: 'Marvin Greer',
      designation: 'Psychologist, forensic',
      ownerType: null,
      employeeFunction: null,
      email: 'marvin.greer@abc.co',
      personalEmail: 'marvin.greer@abc.co',
      workEmail: 'marvin.greer@abc.co',
      preferredName: 'Marvin',
    },
    id: 574,
    publisherSelectedEmployees: [
      {
        label: 'Rickey Li',
        subTitle: 'rickey.li@abc.co',
        profilePhoto: null,
        id: 16339,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Marie Christian',
        subTitle: 'marie.christian@abc.co',
        profilePhoto: null,
        id: 16222,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sherry Decker',
        subTitle: 'sherry.decker@abc.co',
        profilePhoto: null,
        id: 16033,
      },
    ],
  },
  {
    employee: {
      id: 16375,
      companyId: 1,
      displayName: 'Mrs. Catherine Taylor',
      designation: 'Programmer, systems',
      ownerType: null,
      employeeFunction: null,
      email: 'mrs..catherine.taylor@abc.co',
      personalEmail: 'mrs..catherine.taylor@abc.co',
      workEmail: 'mrs..catherine.taylor@abc.co',
      preferredName: 'Mrs.',
    },
    id: 575,
    publisherSelectedEmployees: [
      {
        label: 'Eugene Higgins',
        subTitle: 'eugene.higgins@abc.co',
        profilePhoto: null,
        id: 16223,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Tyler Garcia',
        subTitle: 'tyler.garcia@abc.co',
        profilePhoto: null,
        id: 16178,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Marie Christian',
        subTitle: 'marie.christian@abc.co',
        profilePhoto: null,
        id: 16222,
      },
    ],
  },
  {
    employee: {
      id: 16376,
      companyId: 2,
      displayName: 'Dakota Moody',
      designation: 'Architectural technologist',
      ownerType: null,
      employeeFunction: null,
      email: 'dakota.moody@abc.co',
      personalEmail: 'dakota.moody@abc.co',
      workEmail: 'dakota.moody@abc.co',
      preferredName: 'Dakota',
    },
    id: 576,
    publisherSelectedEmployees: [
      {
        label: 'Brenda Thornton',
        subTitle: 'brenda.thornton@abc.co',
        profilePhoto: null,
        id: 16360,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Brian Gould',
        subTitle: 'brian.gould@abc.co',
        profilePhoto: null,
        id: 16139,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Thomas Bradley',
        subTitle: 'thomas.bradley@abc.co',
        profilePhoto: null,
        id: 16018,
      },
    ],
  },
  {
    employee: {
      id: 16377,
      companyId: 3,
      displayName: 'Eric Sanders',
      designation: 'Speech and language therapist',
      ownerType: null,
      employeeFunction: null,
      email: 'eric.sanders@abc.co',
      personalEmail: 'eric.sanders@abc.co',
      workEmail: 'eric.sanders@abc.co',
      preferredName: 'Eric',
    },
    id: 577,
    publisherSelectedEmployees: [
      {
        label: 'Brian Gregory',
        subTitle: 'brian.gregory@abc.co',
        profilePhoto: null,
        id: 16303,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Alfred Galvan',
        subTitle: 'alfred.galvan@abc.co',
        profilePhoto: null,
        id: 16358,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Robert Pearson',
        subTitle: 'robert.pearson@abc.co',
        profilePhoto: null,
        id: 16328,
      },
    ],
  },
  {
    employee: {
      id: 16378,
      companyId: 1,
      displayName: 'Andrew Lucas',
      designation: 'Higher education lecturer',
      ownerType: null,
      employeeFunction: null,
      email: 'andrew.lucas@abc.co',
      personalEmail: 'andrew.lucas@abc.co',
      workEmail: 'andrew.lucas@abc.co',
      preferredName: 'Andrew',
    },
    id: 578,
    publisherSelectedEmployees: [
      {
        label: 'Jeanette Harrison',
        subTitle: 'jeanette.harrison@abc.co',
        profilePhoto: null,
        id: 16370,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kylie Williams',
        subTitle: 'kylie.williams@abc.co',
        profilePhoto: null,
        id: 16146,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Melissa Martinez',
        subTitle: 'melissa.martinez@abc.co',
        profilePhoto: null,
        id: 16169,
      },
    ],
  },
  {
    employee: {
      id: 16379,
      companyId: 2,
      displayName: 'Richard Glenn',
      designation: 'Learning disability nurse',
      ownerType: null,
      employeeFunction: null,
      email: 'richard.glenn@abc.co',
      personalEmail: 'richard.glenn@abc.co',
      workEmail: 'richard.glenn@abc.co',
      preferredName: 'Richard',
    },
    id: 579,
    publisherSelectedEmployees: [
      {
        label: 'Elizabeth Fowler',
        subTitle: 'elizabeth.fowler@abc.co',
        profilePhoto: null,
        id: 16030,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Cindy Hayes',
        subTitle: 'cindy.hayes@abc.co',
        profilePhoto: null,
        id: 16282,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jasmine King',
        subTitle: 'jasmine.king@abc.co',
        profilePhoto: null,
        id: 16335,
      },
    ],
  },
  {
    employee: {
      id: 16380,
      companyId: 3,
      displayName: 'Robert Kim',
      designation: 'Office manager',
      ownerType: null,
      employeeFunction: null,
      email: 'robert.kim@abc.co',
      personalEmail: 'robert.kim@abc.co',
      workEmail: 'robert.kim@abc.co',
      preferredName: 'Robert',
    },
    id: 580,
    publisherSelectedEmployees: [
      {
        label: 'Patrick Moore',
        subTitle: 'patrick.moore@abc.co',
        profilePhoto: null,
        id: 16259,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Allison Hill',
        subTitle: 'allison.hill@abc.co',
        profilePhoto: null,
        id: 16000,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Brenda Mitchell',
        subTitle: 'brenda.mitchell@abc.co',
        profilePhoto: null,
        id: 16359,
      },
    ],
  },
  {
    employee: {
      id: 16381,
      companyId: 1,
      displayName: 'Stephanie Hughes',
      designation: 'Embryologist, clinical',
      ownerType: null,
      employeeFunction: null,
      email: 'stephanie.hughes@abc.co',
      personalEmail: 'stephanie.hughes@abc.co',
      workEmail: 'stephanie.hughes@abc.co',
      preferredName: 'Stephanie',
    },
    id: 581,
    publisherSelectedEmployees: [
      {
        label: 'Christine Wright',
        subTitle: 'christine.wright@abc.co',
        profilePhoto: null,
        id: 16082,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Charles Pitts',
        subTitle: 'charles.pitts@abc.co',
        profilePhoto: null,
        id: 16220,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jill Miller',
        subTitle: 'jill.miller@abc.co',
        profilePhoto: null,
        id: 16398,
      },
    ],
  },
  {
    employee: {
      id: 16382,
      companyId: 2,
      displayName: 'Jonathan Glass MD',
      designation: 'Charity fundraiser',
      ownerType: null,
      employeeFunction: null,
      email: 'jonathan.glass.md@abc.co',
      personalEmail: 'jonathan.glass.md@abc.co',
      workEmail: 'jonathan.glass.md@abc.co',
      preferredName: 'Jonathan',
    },
    id: 582,
    publisherSelectedEmployees: [
      {
        label: 'David Scott',
        subTitle: 'david.scott@abc.co',
        profilePhoto: null,
        id: 16231,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Richard Baker',
        subTitle: 'richard.baker@abc.co',
        profilePhoto: null,
        id: 16221,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Donald Farmer',
        subTitle: 'donald.farmer@abc.co',
        profilePhoto: null,
        id: 16295,
      },
    ],
  },
  {
    employee: {
      id: 16383,
      companyId: 3,
      displayName: 'Angela Morrison',
      designation: 'Education administrator',
      ownerType: null,
      employeeFunction: null,
      email: 'angela.morrison@abc.co',
      personalEmail: 'angela.morrison@abc.co',
      workEmail: 'angela.morrison@abc.co',
      preferredName: 'Angela',
    },
    id: 583,
    publisherSelectedEmployees: [
      {
        label: 'Jonathan Wilkerson',
        subTitle: 'jonathan.wilkerson@abc.co',
        profilePhoto: null,
        id: 16019,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Christopher Lewis',
        subTitle: 'christopher.lewis@abc.co',
        profilePhoto: null,
        id: 16341,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Richard Baker',
        subTitle: 'richard.baker@abc.co',
        profilePhoto: null,
        id: 16221,
      },
    ],
  },
  {
    employee: {
      id: 16384,
      companyId: 1,
      displayName: 'Erica Miller',
      designation: 'Hotel manager',
      ownerType: null,
      employeeFunction: null,
      email: 'erica.miller@abc.co',
      personalEmail: 'erica.miller@abc.co',
      workEmail: 'erica.miller@abc.co',
      preferredName: 'Erica',
    },
    id: 584,
    publisherSelectedEmployees: [
      {
        label: 'Chad Jones',
        subTitle: 'chad.jones@abc.co',
        profilePhoto: null,
        id: 16397,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Zachary Taylor',
        subTitle: 'zachary.taylor@abc.co',
        profilePhoto: null,
        id: 16022,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Ms. Rebecca Rodriguez',
        subTitle: 'ms..rebecca.rodriguez@abc.co',
        profilePhoto: null,
        id: 16270,
      },
    ],
  },
  {
    employee: {
      id: 16385,
      companyId: 2,
      displayName: 'Lance Simmons',
      designation: 'Producer, radio',
      ownerType: null,
      employeeFunction: null,
      email: 'lance.simmons@abc.co',
      personalEmail: 'lance.simmons@abc.co',
      workEmail: 'lance.simmons@abc.co',
      preferredName: 'Lance',
    },
    id: 585,
    publisherSelectedEmployees: [
      {
        label: 'Kathleen Aguilar',
        subTitle: 'kathleen.aguilar@abc.co',
        profilePhoto: null,
        id: 16230,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Seth Reese',
        subTitle: 'seth.reese@abc.co',
        profilePhoto: null,
        id: 16315,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jeffrey Potts',
        subTitle: 'jeffrey.potts@abc.co',
        profilePhoto: null,
        id: 16355,
      },
    ],
  },
  {
    employee: {
      id: 16386,
      companyId: 3,
      displayName: 'Andrew Berg',
      designation: 'Manufacturing engineer',
      ownerType: null,
      employeeFunction: null,
      email: 'andrew.berg@abc.co',
      personalEmail: 'andrew.berg@abc.co',
      workEmail: 'andrew.berg@abc.co',
      preferredName: 'Andrew',
    },
    id: 586,
    publisherSelectedEmployees: [
      {
        label: 'Dean Santiago',
        subTitle: 'dean.santiago@abc.co',
        profilePhoto: null,
        id: 16064,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Russell Porter',
        subTitle: 'russell.porter@abc.co',
        profilePhoto: null,
        id: 16365,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Daniel Fowler',
        subTitle: 'daniel.fowler@abc.co',
        profilePhoto: null,
        id: 16265,
      },
    ],
  },
  {
    employee: {
      id: 16387,
      companyId: 1,
      displayName: 'Jessica Fowler',
      designation: 'Barista',
      ownerType: null,
      employeeFunction: null,
      email: 'jessica.fowler@abc.co',
      personalEmail: 'jessica.fowler@abc.co',
      workEmail: 'jessica.fowler@abc.co',
      preferredName: 'Jessica',
    },
    id: 587,
    publisherSelectedEmployees: [
      {
        label: 'Robert Savage',
        subTitle: 'robert.savage@abc.co',
        profilePhoto: null,
        id: 16090,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Bryan Charles',
        subTitle: 'bryan.charles@abc.co',
        profilePhoto: null,
        id: 16264,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Mason Johnson',
        subTitle: 'mason.johnson@abc.co',
        profilePhoto: null,
        id: 16276,
      },
    ],
  },
  {
    employee: {
      id: 16388,
      companyId: 2,
      displayName: 'Mark Cox',
      designation: 'Designer, jewellery',
      ownerType: null,
      employeeFunction: null,
      email: 'mark.cox@abc.co',
      personalEmail: 'mark.cox@abc.co',
      workEmail: 'mark.cox@abc.co',
      preferredName: 'Mark',
    },
    id: 588,
    publisherSelectedEmployees: [
      {
        label: 'Nichole Alvarez',
        subTitle: 'nichole.alvarez@abc.co',
        profilePhoto: null,
        id: 16273,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kimberly Acosta',
        subTitle: 'kimberly.acosta@abc.co',
        profilePhoto: null,
        id: 16362,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jason Daniels',
        subTitle: 'jason.daniels@abc.co',
        profilePhoto: null,
        id: 16123,
      },
    ],
  },
  {
    employee: {
      id: 16389,
      companyId: 3,
      displayName: 'Brenda Lawson',
      designation: 'Primary school teacher',
      ownerType: null,
      employeeFunction: null,
      email: 'brenda.lawson@abc.co',
      personalEmail: 'brenda.lawson@abc.co',
      workEmail: 'brenda.lawson@abc.co',
      preferredName: 'Brenda',
    },
    id: 589,
    publisherSelectedEmployees: [
      {
        label: 'Jacob Ramos',
        subTitle: 'jacob.ramos@abc.co',
        profilePhoto: null,
        id: 16261,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Mr. Jeremiah Reeves',
        subTitle: 'mr..jeremiah.reeves@abc.co',
        profilePhoto: null,
        id: 16120,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sara Calhoun',
        subTitle: 'sara.calhoun@abc.co',
        profilePhoto: null,
        id: 16130,
      },
    ],
  },
  {
    employee: {
      id: 16390,
      companyId: 1,
      displayName: 'Austin Osborne',
      designation: 'Medical technical officer',
      ownerType: null,
      employeeFunction: null,
      email: 'austin.osborne@abc.co',
      personalEmail: 'austin.osborne@abc.co',
      workEmail: 'austin.osborne@abc.co',
      preferredName: 'Austin',
    },
    id: 590,
    publisherSelectedEmployees: [
      {
        label: 'Curtis Johnson',
        subTitle: 'curtis.johnson@abc.co',
        profilePhoto: null,
        id: 16109,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Jason Henry',
        subTitle: 'jason.henry@abc.co',
        profilePhoto: null,
        id: 16148,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'David Walsh',
        subTitle: 'david.walsh@abc.co',
        profilePhoto: null,
        id: 16119,
      },
    ],
  },
  {
    employee: {
      id: 16391,
      companyId: 2,
      displayName: 'Travis Johnson',
      designation: 'Designer, exhibition/display',
      ownerType: null,
      employeeFunction: null,
      email: 'travis.johnson@abc.co',
      personalEmail: 'travis.johnson@abc.co',
      workEmail: 'travis.johnson@abc.co',
      preferredName: 'Travis',
    },
    id: 591,
    publisherSelectedEmployees: [
      {
        label: 'Willie Durham',
        subTitle: 'willie.durham@abc.co',
        profilePhoto: null,
        id: 16205,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kendra Sanders',
        subTitle: 'kendra.sanders@abc.co',
        profilePhoto: null,
        id: 16393,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Nichole Alvarez',
        subTitle: 'nichole.alvarez@abc.co',
        profilePhoto: null,
        id: 16273,
      },
    ],
  },
  {
    employee: {
      id: 16392,
      companyId: 3,
      displayName: 'Tiffany Watson',
      designation: 'Camera operator',
      ownerType: null,
      employeeFunction: null,
      email: 'tiffany.watson@abc.co',
      personalEmail: 'tiffany.watson@abc.co',
      workEmail: 'tiffany.watson@abc.co',
      preferredName: 'Tiffany',
    },
    id: 592,
    publisherSelectedEmployees: [
      {
        label: 'Kristin Lynch',
        subTitle: 'kristin.lynch@abc.co',
        profilePhoto: null,
        id: 16294,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Courtney Velasquez',
        subTitle: 'courtney.velasquez@abc.co',
        profilePhoto: null,
        id: 16089,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Lisa Goodwin',
        subTitle: 'lisa.goodwin@abc.co',
        profilePhoto: null,
        id: 16347,
      },
    ],
  },
  {
    employee: {
      id: 16393,
      companyId: 1,
      displayName: 'Kendra Sanders',
      designation: 'Health promotion specialist',
      ownerType: null,
      employeeFunction: null,
      email: 'kendra.sanders@abc.co',
      personalEmail: 'kendra.sanders@abc.co',
      workEmail: 'kendra.sanders@abc.co',
      preferredName: 'Kendra',
    },
    id: 593,
    publisherSelectedEmployees: [
      {
        label: 'Ross Price',
        subTitle: 'ross.price@abc.co',
        profilePhoto: null,
        id: 16124,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Trevor Walker',
        subTitle: 'trevor.walker@abc.co',
        profilePhoto: null,
        id: 16136,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Jackie Tran',
        subTitle: 'jackie.tran@abc.co',
        profilePhoto: null,
        id: 16161,
      },
    ],
  },
  {
    employee: {
      id: 16394,
      companyId: 2,
      displayName: 'Brian Fitzgerald',
      designation: 'Restaurant manager',
      ownerType: null,
      employeeFunction: null,
      email: 'brian.fitzgerald@abc.co',
      personalEmail: 'brian.fitzgerald@abc.co',
      workEmail: 'brian.fitzgerald@abc.co',
      preferredName: 'Brian',
    },
    id: 594,
    publisherSelectedEmployees: [
      {
        label: 'Nicole Vaughn',
        subTitle: 'nicole.vaughn@abc.co',
        profilePhoto: null,
        id: 16038,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Kathryn Rosario',
        subTitle: 'kathryn.rosario@abc.co',
        profilePhoto: null,
        id: 16329,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Elizabeth Spence DDS',
        subTitle: 'elizabeth.spence.dds@abc.co',
        profilePhoto: null,
        id: 16237,
      },
    ],
  },
  {
    employee: {
      id: 16395,
      companyId: 3,
      displayName: 'Susan Wilson',
      designation: 'Gaffer',
      ownerType: null,
      employeeFunction: null,
      email: 'susan.wilson@abc.co',
      personalEmail: 'susan.wilson@abc.co',
      workEmail: 'susan.wilson@abc.co',
      preferredName: 'Susan',
    },
    id: 595,
    publisherSelectedEmployees: [
      {
        label: 'Ross Price',
        subTitle: 'ross.price@abc.co',
        profilePhoto: null,
        id: 16124,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Maria Moore',
        subTitle: 'maria.moore@abc.co',
        profilePhoto: null,
        id: 16206,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Evelyn Williams',
        subTitle: 'evelyn.williams@abc.co',
        profilePhoto: null,
        id: 16373,
      },
    ],
  },
  {
    employee: {
      id: 16396,
      companyId: 1,
      displayName: 'Cindy Carr',
      designation: 'Recycling officer',
      ownerType: null,
      employeeFunction: null,
      email: 'cindy.carr@abc.co',
      personalEmail: 'cindy.carr@abc.co',
      workEmail: 'cindy.carr@abc.co',
      preferredName: 'Cindy',
    },
    id: 596,
    publisherSelectedEmployees: [
      {
        label: 'Leslie Bell',
        subTitle: 'leslie.bell@abc.co',
        profilePhoto: null,
        id: 16324,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Benjamin Beck',
        subTitle: 'benjamin.beck@abc.co',
        profilePhoto: null,
        id: 16099,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Sherry Decker',
        subTitle: 'sherry.decker@abc.co',
        profilePhoto: null,
        id: 16033,
      },
    ],
  },
  {
    employee: {
      id: 16397,
      companyId: 2,
      displayName: 'Chad Jones',
      designation: 'Drilling engineer',
      ownerType: null,
      employeeFunction: null,
      email: 'chad.jones@abc.co',
      personalEmail: 'chad.jones@abc.co',
      workEmail: 'chad.jones@abc.co',
      preferredName: 'Chad',
    },
    id: 597,
    publisherSelectedEmployees: [
      {
        label: 'Nicholas Mcbride',
        subTitle: 'nicholas.mcbride@abc.co',
        profilePhoto: null,
        id: 16048,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Joshua Gibson',
        subTitle: 'joshua.gibson@abc.co',
        profilePhoto: null,
        id: 16251,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Lance Hoffman',
        subTitle: 'lance.hoffman@abc.co',
        profilePhoto: null,
        id: 16003,
      },
    ],
  },
  {
    employee: {
      id: 16398,
      companyId: 3,
      displayName: 'Jill Miller',
      designation: 'IT consultant',
      ownerType: null,
      employeeFunction: null,
      email: 'jill.miller@abc.co',
      personalEmail: 'jill.miller@abc.co',
      workEmail: 'jill.miller@abc.co',
      preferredName: 'Jill',
    },
    id: 598,
    publisherSelectedEmployees: [
      {
        label: 'Robert Savage',
        subTitle: 'robert.savage@abc.co',
        profilePhoto: null,
        id: 16090,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Elizabeth Ward',
        subTitle: 'elizabeth.ward@abc.co',
        profilePhoto: null,
        id: 16167,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Joel Baxter',
        subTitle: 'joel.baxter@abc.co',
        profilePhoto: null,
        id: 16050,
      },
    ],
  },
  {
    employee: {
      id: 16399,
      companyId: 1,
      displayName: 'Michelle Pierce',
      designation: 'Horticultural therapist',
      ownerType: null,
      employeeFunction: null,
      email: 'michelle.pierce@abc.co',
      personalEmail: 'michelle.pierce@abc.co',
      workEmail: 'michelle.pierce@abc.co',
      preferredName: 'Michelle',
    },
    id: 599,
    publisherSelectedEmployees: [
      {
        label: 'Jasmine King',
        subTitle: 'jasmine.king@abc.co',
        profilePhoto: null,
        id: 16335,
      },
    ],
    proposerSelectedEmployees: [
      {
        label: 'Amanda Diaz',
        subTitle: 'amanda.diaz@abc.co',
        profilePhoto: null,
        id: 16243,
      },
    ],
    approverSelectedEmployees: [
      {
        label: 'Desiree Smith',
        subTitle: 'desiree.smith@abc.co',
        profilePhoto: null,
        id: 16157,
      },
    ],
  },
];

// Mock data for CurrentPayDetailsTreeTable (moved from component)
export const MOCK_HIERARCHICAL_ROW_DATA = [
  {
    id: '10000001',
    function: {
      displayName: 'Pancake Holdings Inc.',
      subtitle: '',
      isGroup: true,
      level: 'ORG',
      displayLevel: null,
    },
    hierarchy: ['10000001'],
    currentPayroll: '5497085',
    percentageIncrease: '4',
    totalNewBudget: '5716968',
    publisherSelectedEmployees: [
      {
        label: 'Allison Hill',
        subTitle: 'allison.hill@abc.co',
        profilePhoto: null,
        id: 16000,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000002',
    function: {
      displayName: 'Pancake Holdings - New York',
      subtitle: 'Code: #GCO',
      isGroup: true,
      level: 'COMPANY',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002'],
    currentPayroll: '1940310',
    percentageIncrease: '0',
    totalNewBudget: '1940310',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000003',
    function: {
      displayName: 'Pancake Holdings - Chicago',
      subtitle: 'Code: #HTN',
      isGroup: true,
      level: 'COMPANY',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003'],
    currentPayroll: '1956775',
    percentageIncrease: '0',
    totalNewBudget: '1956775',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000004',
    function: {
      displayName: 'Pancake Holdings - San Francisco',
      subtitle: 'Code: #TPJ',
      isGroup: true,
      level: 'COMPANY',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000004'],
    currentPayroll: '1500000',
    percentageIncrease: '6.7',
    totalNewBudget: '1600000',
    publisherSelectedEmployees: [
      {
        label: 'Caitlin Henderson',
        subTitle: 'caitlin.henderson@abc.co',
        profilePhoto: null,
        id: 16005,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000005',
    function: {
      displayName: 'Marketing',
      subtitle: '',
      isGroup: true,
      level: 'DIVISION',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005'],
    currentPayroll: '981870',
    percentageIncrease: '0',
    totalNewBudget: '981870',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000018',
    function: {
      displayName: 'Research and Development',
      subtitle: '',
      isGroup: true,
      level: 'DIVISION',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018'],
    currentPayroll: '958440',
    percentageIncrease: '0',
    totalNewBudget: '958440',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000031',
    function: {
      displayName: 'Marketing',
      subtitle: '',
      isGroup: true,
      level: 'DIVISION',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031'],
    currentPayroll: '982380',
    percentageIncrease: '0',
    totalNewBudget: '982380',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000044',
    function: {
      displayName: 'Research and Development',
      subtitle: '',
      isGroup: true,
      level: 'DIVISION',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044'],
    currentPayroll: '974395',
    percentageIncrease: '0',
    totalNewBudget: '974395',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000006',
    function: {
      displayName: 'West Coast Ops',
      subtitle: '',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000006'],
    currentPayroll: '322300',
    percentageIncrease: '0',
    totalNewBudget: '322300',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000010',
    function: {
      displayName: 'Midwest Retail',
      subtitle: '',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000010'],
    currentPayroll: '332400',
    percentageIncrease: '0',
    totalNewBudget: '332400',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000014',
    function: {
      displayName: 'Southeast Logistics',
      subtitle: '',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000014'],
    currentPayroll: '327170',
    percentageIncrease: '0',
    totalNewBudget: '327170',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000019',
    function: {
      displayName: 'West Coast Ops',
      subtitle: '',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000019'],
    currentPayroll: '324665',
    percentageIncrease: '0',
    totalNewBudget: '324665',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000023',
    function: {
      displayName: 'Midwest Retail',
      subtitle: '',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000023'],
    currentPayroll: '310780',
    percentageIncrease: '0',
    totalNewBudget: '310780',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000027',
    function: {
      displayName: 'Southeast Logistics',
      subtitle: '',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000027'],
    currentPayroll: '322995',
    percentageIncrease: '0',
    totalNewBudget: '322995',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000032',
    function: {
      displayName: 'West Coast Ops',
      subtitle: '',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000032'],
    currentPayroll: '328970',
    percentageIncrease: '0',
    totalNewBudget: '328970',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000036',
    function: {
      displayName: 'Midwest Retail',
      subtitle: '',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000036'],
    currentPayroll: '320900',
    percentageIncrease: '0',
    totalNewBudget: '320900',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000040',
    function: {
      displayName: 'Southeast Logistics',
      subtitle: '',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000040'],
    currentPayroll: '332510',
    percentageIncrease: '0',
    totalNewBudget: '332510',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000045',
    function: {
      displayName: 'West Coast Ops',
      subtitle: '',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000045'],
    currentPayroll: '334510',
    percentageIncrease: '0',
    totalNewBudget: '334510',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000049',
    function: {
      displayName: 'Midwest Retail',
      subtitle: '',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000049'],
    currentPayroll: '326750',
    percentageIncrease: '0',
    totalNewBudget: '326750',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000053',
    function: {
      displayName: 'Southeast Logistics',
      subtitle: '',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000053'],
    currentPayroll: '313135',
    percentageIncrease: '0',
    totalNewBudget: '313135',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000007',
    function: {
      displayName: 'Operations',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000006', '10000007'],
    currentPayroll: '100000',
    percentageIncrease: '6.2',
    totalNewBudget: '106200',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000008',
    function: {
      displayName: 'Human Resources',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000006', '10000008'],
    currentPayroll: '100000',
    percentageIncrease: '9.1',
    totalNewBudget: '109100',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000009',
    function: {
      displayName: 'Finance and Accounting',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000006', '10000009'],
    currentPayroll: '100000',
    percentageIncrease: '7.0',
    totalNewBudget: '107000',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000011',
    function: {
      displayName: 'Operations',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000010', '10000011'],
    currentPayroll: '105000',
    percentageIncrease: '6.3',
    totalNewBudget: '111615',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000012',
    function: {
      displayName: 'Human Resources',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000010', '10000012'],
    currentPayroll: '100000',
    percentageIncrease: '5.6',
    totalNewBudget: '105600',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000013',
    function: {
      displayName: 'Finance and Accounting',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000010', '10000013'],
    currentPayroll: '105000',
    percentageIncrease: '9.7',
    totalNewBudget: '115185',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000015',
    function: {
      displayName: 'Operations',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000014', '10000015'],
    currentPayroll: '105000',
    percentageIncrease: '9.4',
    totalNewBudget: '114870',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000016',
    function: {
      displayName: 'Human Resources',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000014', '10000016'],
    currentPayroll: '95000',
    percentageIncrease: '10.0',
    totalNewBudget: '104500',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000017',
    function: {
      displayName: 'Finance and Accounting',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000014', '10000017'],
    currentPayroll: '100000',
    percentageIncrease: '7.8',
    totalNewBudget: '107800',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000020',
    function: {
      displayName: 'Operations',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000019', '10000020'],
    currentPayroll: '105000',
    percentageIncrease: '5.1',
    totalNewBudget: '110355',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000021',
    function: {
      displayName: 'Human Resources',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000019', '10000021'],
    currentPayroll: '95000',
    percentageIncrease: '9.8',
    totalNewBudget: '104310',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000022',
    function: {
      displayName: 'Finance and Accounting',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000019', '10000022'],
    currentPayroll: '100000',
    percentageIncrease: '10.0',
    totalNewBudget: '110000',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000024',
    function: {
      displayName: 'Operations',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000023', '10000024'],
    currentPayroll: '95000',
    percentageIncrease: '8.7',
    totalNewBudget: '103265',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000025',
    function: {
      displayName: 'Human Resources',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000023', '10000025'],
    currentPayroll: '95000',
    percentageIncrease: '7.7',
    totalNewBudget: '102315',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000026',
    function: {
      displayName: 'Finance and Accounting',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000023', '10000026'],
    currentPayroll: '100000',
    percentageIncrease: '5.2',
    totalNewBudget: '105200',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000028',
    function: {
      displayName: 'Operations',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000027', '10000028'],
    currentPayroll: '100000',
    percentageIncrease: '6.4',
    totalNewBudget: '106400',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000029',
    function: {
      displayName: 'Human Resources',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000027', '10000029'],
    currentPayroll: '95000',
    percentageIncrease: '9.4',
    totalNewBudget: '103930',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000030',
    function: {
      displayName: 'Finance and Accounting',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000027', '10000030'],
    currentPayroll: '105000',
    percentageIncrease: '7.3',
    totalNewBudget: '112665',
    publisherSelectedEmployees: [
      {
        label: 'Brian Yang',
        subTitle: 'brian.yang@abc.co',
        profilePhoto: null,
        id: 160001,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000033',
    function: {
      displayName: 'Operations',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000032', '10000033'],
    currentPayroll: '100000',
    percentageIncrease: '9.7',
    totalNewBudget: '109700',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000034',
    function: {
      displayName: 'Human Resources',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000032', '10000034'],
    currentPayroll: '100000',
    percentageIncrease: '8.6',
    totalNewBudget: '108600',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000035',
    function: {
      displayName: 'Finance and Accounting',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000032', '10000035'],
    currentPayroll: '105000',
    percentageIncrease: '5.4',
    totalNewBudget: '110670',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000037',
    function: {
      displayName: 'Operations',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000036', '10000037'],
    currentPayroll: '100000',
    percentageIncrease: '7.4',
    totalNewBudget: '107400',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000038',
    function: {
      displayName: 'Human Resources',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000036', '10000038'],
    currentPayroll: '100000',
    percentageIncrease: '5.5',
    totalNewBudget: '105500',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000039',
    function: {
      displayName: 'Finance and Accounting',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000036', '10000039'],
    currentPayroll: '100000',
    percentageIncrease: '8.0',
    totalNewBudget: '108000',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000041',
    function: {
      displayName: 'Operations',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000040', '10000041'],
    currentPayroll: '100000',
    percentageIncrease: '5.5',
    totalNewBudget: '105500',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000042',
    function: {
      displayName: 'Human Resources',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000040', '10000042'],
    currentPayroll: '105000',
    percentageIncrease: '6.8',
    totalNewBudget: '112140',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000043',
    function: {
      displayName: 'Finance and Accounting',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000040', '10000043'],
    currentPayroll: '105000',
    percentageIncrease: '9.4',
    totalNewBudget: '114870',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000046',
    function: {
      displayName: 'Operations',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000045', '10000046'],
    currentPayroll: '100000',
    percentageIncrease: '7.5',
    totalNewBudget: '107500',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000047',
    function: {
      displayName: 'Human Resources',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000045', '10000047'],
    currentPayroll: '105000',
    percentageIncrease: '8.2',
    totalNewBudget: '113610',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000048',
    function: {
      displayName: 'Finance and Accounting',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000045', '10000048'],
    currentPayroll: '105000',
    percentageIncrease: '8.0',
    totalNewBudget: '113400',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000050',
    function: {
      displayName: 'Operations',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000049', '10000050'],
    currentPayroll: '100000',
    percentageIncrease: '5.2',
    totalNewBudget: '105200',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000051',
    function: {
      displayName: 'Human Resources',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000049', '10000051'],
    currentPayroll: '105000',
    percentageIncrease: '5.4',
    totalNewBudget: '110670',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000052',
    function: {
      displayName: 'Finance and Accounting',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000049', '10000052'],
    currentPayroll: '105000',
    percentageIncrease: '5.6',
    totalNewBudget: '110880',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000054',
    function: {
      displayName: 'Operations',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000053', '10000054'],
    currentPayroll: '95000',
    percentageIncrease: '9.8',
    totalNewBudget: '104310',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000055',
    function: {
      displayName: 'Human Resources',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000053', '10000055'],
    currentPayroll: '95000',
    percentageIncrease: '7.5',
    totalNewBudget: '102125',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
  {
    id: '10000056',
    function: {
      displayName: 'Finance and Accounting',
      subtitle: '',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000053', '10000056'],
    currentPayroll: '100000',
    percentageIncrease: '6.7',
    totalNewBudget: '106700',
    publisherSelectedEmployees: [
      {
        label: 'Javier Johnson',
        subTitle: 'javier.johnson@abc.co',
        profilePhoto: null,
        id: 16002,
      },
    ],
    proposerSelectedEmployees: [],
    approverSelectedEmployees: [],
  },
];

export const MOCK_APPROVER_WISE_ROW_DATA = {
  rows: [
    {
      employee: {
        id: 16072,
        companyId: 1,
        displayName: 'Brandy Wilson',

        designation: 'Clinical biochemist',
        ownerType: null,
        employeeFunction: null,
        email: 'brandy.wilson@abc.co',
        personalEmail: 'brandy.wilson@abc.co',
        workEmail: 'brandy.wilson@abc.co',
        preferredName: 'Brandy',
      },
      id: 500,
    },
    {
      employee: {
        id: 16337,
        companyId: 2,
        displayName: 'Emily Douglas',

        designation: "Nurse, children's",
        ownerType: null,
        employeeFunction: null,
        email: 'emily.douglas@abc.co',
        personalEmail: 'emily.douglas@abc.co',
        workEmail: 'emily.douglas@abc.co',
        preferredName: 'Emily',
      },
      id: 501,
    },
    {
      employee: {
        id: 16321,
        companyId: 1,
        displayName: 'Justin Riley',

        designation: 'Systems analyst',
        ownerType: null,
        employeeFunction: null,
        email: 'justin.riley@abc.co',
        personalEmail: 'justin.riley@abc.co',
        workEmail: 'justin.riley@abc.co',
        preferredName: 'Justin',
      },
      id: 502,
    },
    {
      employee: {
        id: 16033,
        companyId: 1,
        displayName: 'Sherry Decker',

        designation: 'Information systems manager',
        ownerType: null,
        employeeFunction: null,
        email: 'sherry.decker@abc.co',
        personalEmail: 'sherry.decker@abc.co',
        workEmail: 'sherry.decker@abc.co',
        preferredName: 'Sherry',
      },
      id: 503,
    },
    {
      employee: {
        id: 16190,
        companyId: 2,
        displayName: 'Vernon Huff',

        designation: 'Teaching laboratory technician',
        ownerType: null,
        employeeFunction: null,
        email: 'vernon.huff@abc.co',
        personalEmail: 'vernon.huff@abc.co',
        workEmail: 'vernon.huff@abc.co',
        preferredName: 'Vernon',
      },
      id: 504,
    },
    {
      employee: {
        id: 16366,
        companyId: 1,
        displayName: 'Jose Allen',

        designation: 'Cytogeneticist',
        ownerType: null,
        employeeFunction: null,
        email: 'jose.allen@abc.co',
        personalEmail: 'jose.allen@abc.co',
        workEmail: 'jose.allen@abc.co',
        preferredName: 'Jose',
      },
      id: 505,
    },
    {
      employee: {
        id: 16208,
        companyId: 2,
        displayName: 'Juan Reyes',

        designation: 'Tour manager',
        ownerType: null,
        employeeFunction: null,
        email: 'juan.reyes@abc.co',
        personalEmail: 'juan.reyes@abc.co',
        workEmail: 'juan.reyes@abc.co',
        preferredName: 'Juan',
      },
      id: 506,
    },
    {
      employee: {
        id: 16094,
        companyId: 2,
        displayName: 'Wesley White',

        designation: 'Geochemist',
        ownerType: null,
        employeeFunction: null,
        email: 'wesley.white@abc.co',
        personalEmail: 'wesley.white@abc.co',
        workEmail: 'wesley.white@abc.co',
        preferredName: 'Wesley',
      },
      id: 507,
    },
    {
      employee: {
        id: 16395,
        companyId: 3,
        displayName: 'Susan Wilson',

        designation: 'Gaffer',
        ownerType: null,
        employeeFunction: null,
        email: 'susan.wilson@abc.co',
        personalEmail: 'susan.wilson@abc.co',
        workEmail: 'susan.wilson@abc.co',
        preferredName: 'Susan',
      },
      id: 508,
    },
    {
      employee: {
        id: 16051,
        companyId: 1,
        displayName: 'Scott Pierce',

        designation: 'Arts administrator',
        ownerType: null,
        employeeFunction: null,
        email: 'scott.pierce@abc.co',
        personalEmail: 'scott.pierce@abc.co',
        workEmail: 'scott.pierce@abc.co',
        preferredName: 'Scott',
      },
      id: 509,
    },
    {
      employee: {
        id: 16209,
        companyId: 3,
        displayName: 'Sherry Shields',

        designation: 'Health and safety adviser',
        ownerType: null,
        employeeFunction: null,
        email: 'sherry.shields@abc.co',
        personalEmail: 'sherry.shields@abc.co',
        workEmail: 'sherry.shields@abc.co',
        preferredName: 'Sherry',
      },
      id: 510,
    },
    {
      employee: {
        id: 16364,
        companyId: 2,
        displayName: 'Jason Bauer',

        designation: 'Programmer, systems',
        ownerType: null,
        employeeFunction: null,
        email: 'jason.bauer@abc.co',
        personalEmail: 'jason.bauer@abc.co',
        workEmail: 'jason.bauer@abc.co',
        preferredName: 'Jason',
      },
      id: 511,
    },
    {
      employee: {
        id: 16226,
        companyId: 2,
        displayName: 'Michael Berger',

        designation: 'Armed forces training and education officer',
        ownerType: null,
        employeeFunction: null,
        email: 'michael.berger@abc.co',
        personalEmail: 'michael.berger@abc.co',
        workEmail: 'michael.berger@abc.co',
        preferredName: 'Michael',
      },
      id: 512,
    },
    {
      employee: {
        id: 16056,
        companyId: 3,
        displayName: 'Monica Logan',

        designation: 'Radiographer, therapeutic',
        ownerType: null,
        employeeFunction: null,
        email: 'monica.logan@abc.co',
        personalEmail: 'monica.logan@abc.co',
        workEmail: 'monica.logan@abc.co',
        preferredName: 'Monica',
      },
      id: 513,
    },
    {
      employee: {
        id: 16232,
        companyId: 2,
        displayName: 'Julie Roberts',

        designation: 'Sports coach',
        ownerType: null,
        employeeFunction: null,
        email: 'julie.roberts@abc.co',
        personalEmail: 'julie.roberts@abc.co',
        workEmail: 'julie.roberts@abc.co',
        preferredName: 'Julie',
      },
      id: 514,
    },
    {
      employee: {
        id: 16315,
        companyId: 1,
        displayName: 'Seth Reese',

        designation: 'Environmental consultant',
        ownerType: null,
        employeeFunction: null,
        email: 'seth.reese@abc.co',
        personalEmail: 'seth.reese@abc.co',
        workEmail: 'seth.reese@abc.co',
        preferredName: 'Seth',
      },
      id: 515,
    },
    {
      employee: {
        id: 16388,
        companyId: 2,
        displayName: 'Mark Cox',

        designation: 'Designer, jewellery',
        ownerType: null,
        employeeFunction: null,
        email: 'mark.cox@abc.co',
        personalEmail: 'mark.cox@abc.co',
        workEmail: 'mark.cox@abc.co',
        preferredName: 'Mark',
      },
      id: 516,
    },
    {
      employee: {
        id: 16352,
        companyId: 2,
        displayName: 'David Davidson',

        designation: 'Meteorologist',
        ownerType: null,
        employeeFunction: null,
        email: 'david.davidson@abc.co',
        personalEmail: 'david.davidson@abc.co',
        workEmail: 'david.davidson@abc.co',
        preferredName: 'David',
      },
      id: 517,
    },
    {
      employee: {
        id: 16122,
        companyId: 3,
        displayName: 'James Hernandez',

        designation: 'Engineer, site',
        ownerType: null,
        employeeFunction: null,
        email: 'james.hernandez@abc.co',
        personalEmail: 'james.hernandez@abc.co',
        workEmail: 'james.hernandez@abc.co',
        preferredName: 'James',
      },
      id: 518,
    },
    {
      employee: {
        id: 16228,
        companyId: 1,
        displayName: 'Joseph Knight',

        designation: 'Education administrator',
        ownerType: null,
        employeeFunction: null,
        email: 'joseph.knight@abc.co',
        personalEmail: 'joseph.knight@abc.co',
        workEmail: 'joseph.knight@abc.co',
        preferredName: 'Joseph',
      },
      id: 519,
    },
    {
      employee: {
        id: 16077,
        companyId: 3,
        displayName: 'Carlos Whitney',

        designation: 'Designer, television/film set',
        ownerType: null,
        employeeFunction: null,
        email: 'carlos.whitney@abc.co',
        personalEmail: 'carlos.whitney@abc.co',
        workEmail: 'carlos.whitney@abc.co',
        preferredName: 'Carlos',
      },
      id: 520,
    },
    {
      employee: {
        id: 16035,
        companyId: 3,
        displayName: 'John Jones',

        designation: 'Site engineer',
        ownerType: null,
        employeeFunction: null,
        email: 'john.jones@abc.co',
        personalEmail: 'john.jones@abc.co',
        workEmail: 'john.jones@abc.co',
        preferredName: 'John',
      },
      id: 521,
    },
    {
      employee: {
        id: 16186,
        companyId: 1,
        displayName: 'Samantha Morse',

        designation: 'Print production planner',
        ownerType: null,
        employeeFunction: null,
        email: 'samantha.morse@abc.co',
        personalEmail: 'samantha.morse@abc.co',
        workEmail: 'samantha.morse@abc.co',
        preferredName: 'Samantha',
      },
      id: 522,
    },
    {
      employee: {
        id: 16199,
        companyId: 2,
        displayName: 'April Booth',

        designation: 'Psychologist, counselling',
        ownerType: null,
        employeeFunction: null,
        email: 'april.booth@abc.co',
        personalEmail: 'april.booth@abc.co',
        workEmail: 'april.booth@abc.co',
        preferredName: 'April',
      },
      id: 523,
    },
    {
      employee: {
        id: 16103,
        companyId: 2,
        displayName: 'Stephanie Gilbert',

        designation: 'Illustrator',
        ownerType: null,
        employeeFunction: null,
        email: 'stephanie.gilbert@abc.co',
        personalEmail: 'stephanie.gilbert@abc.co',
        workEmail: 'stephanie.gilbert@abc.co',
        preferredName: 'Stephanie',
      },
      id: 524,
    },
    {
      employee: {
        id: 16179,
        companyId: 3,
        displayName: 'Deborah Miller',

        designation: 'Film/video editor',
        ownerType: null,
        employeeFunction: null,
        email: 'deborah.miller@abc.co',
        personalEmail: 'deborah.miller@abc.co',
        workEmail: 'deborah.miller@abc.co',
        preferredName: 'Deborah',
      },
      id: 525,
    },
    {
      employee: {
        id: 16178,
        companyId: 2,
        displayName: 'Tyler Garcia',

        designation: 'Engineer, maintenance (IT)',
        ownerType: null,
        employeeFunction: null,
        email: 'tyler.garcia@abc.co',
        personalEmail: 'tyler.garcia@abc.co',
        workEmail: 'tyler.garcia@abc.co',
        preferredName: 'Tyler',
      },
      id: 526,
    },
    {
      employee: {
        id: 16100,
        companyId: 2,
        displayName: 'Mary Martinez',

        designation: 'Hydrologist',
        ownerType: null,
        employeeFunction: null,
        email: 'mary.martinez@abc.co',
        personalEmail: 'mary.martinez@abc.co',
        workEmail: 'mary.martinez@abc.co',
        preferredName: 'Mary',
      },
      id: 527,
    },
    {
      employee: {
        id: 16126,
        companyId: 1,
        displayName: 'Aaron Bell',

        designation: 'Newspaper journalist',
        ownerType: null,
        employeeFunction: null,
        email: 'aaron.bell@abc.co',
        personalEmail: 'aaron.bell@abc.co',
        workEmail: 'aaron.bell@abc.co',
        preferredName: 'Aaron',
      },
      id: 528,
    },
    {
      employee: {
        id: 16333,
        companyId: 1,
        displayName: 'Raymond Shelton',

        designation: 'Associate Professor',
        ownerType: null,
        employeeFunction: null,
        email: 'raymond.shelton@abc.co',
        personalEmail: 'raymond.shelton@abc.co',
        workEmail: 'raymond.shelton@abc.co',
        preferredName: 'Raymond',
      },
      id: 529,
    },
  ],
  pivotFields: null,
};

export const MOCK_CREATE_GUIDELINE_ROW_DATA = [
  {
    id: '10000001',
    function: {
      displayName: 'Pancake Holdings Inc.',
      subtitle: '',
      isGroup: true,
      level: 'ORG',
      displayLevel: null,
    },
    hierarchy: ['10000001'],
    isInEditMode: false,
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000002',
    function: {
      displayName: 'Pancake Holdings - New York',
      subtitle: 'Code: #IQW',
      isGroup: true,
      level: 'COMPANY',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002'],
    label: 'Same as org guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000003',
    function: {
      displayName: 'Pancake Holdings - Chicago',
      subtitle: 'Code: #AKG',
      isGroup: true,
      level: 'COMPANY',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003'],
    label: 'Same as org guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000004',
    function: {
      displayName: 'Pancake Holdings - San Francisco',
      subtitle: 'Code: #ACW',
      isGroup: true,
      level: 'COMPANY',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000004'],
    label: 'Same as org guidelines',
    currentPayroll: '1500000',
    percentageIncrease: '6.7',
    totalNewBudget: '1600000',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000005',
    function: {
      displayName: 'Marketing',
      isGroup: true,
      level: 'DIVISION',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005'],
    label: 'Same as company guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000018',
    function: {
      displayName: 'Research and Development',
      isGroup: true,
      level: 'DIVISION',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018'],
    label: 'Same as company guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000031',
    function: {
      displayName: 'Marketing',
      isGroup: true,
      level: 'DIVISION',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031'],
    label: 'Same as company guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000044',
    function: {
      displayName: 'Research and Development',
      isGroup: true,
      level: 'DIVISION',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044'],
    label: 'Same as company guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000006',
    function: {
      displayName: 'West Coast Ops',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000006'],
    label: 'Same as division guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000010',
    function: {
      displayName: 'Midwest Retail',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000010'],
    label: 'Same as division guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000014',
    function: {
      displayName: 'Southeast Logistics',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000014'],
    label: 'Same as division guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000019',
    function: {
      displayName: 'West Coast Ops',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000019'],
    label: 'Same as division guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000023',
    function: {
      displayName: 'Midwest Retail',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000023'],
    label: 'Same as division guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000027',
    function: {
      displayName: 'Southeast Logistics',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000027'],
    label: 'Same as division guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000032',
    function: {
      displayName: 'West Coast Ops',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000032'],
    label: '',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
    isInEditMode: false,
  },
  {
    id: '10000036',
    function: {
      displayName: 'Midwest Retail',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000036'],
    label: 'Same as division guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000040',
    function: {
      displayName: 'Southeast Logistics',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000040'],
    label: 'Same as division guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000045',
    function: {
      displayName: 'West Coast Ops',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000045'],
    label: 'Same as division guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000049',
    function: {
      displayName: 'Midwest Retail',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000049'],
    label: 'Same as division guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000053',
    function: {
      displayName: 'Southeast Logistics',
      isGroup: true,
      level: 'BU',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000053'],
    label: 'Same as division guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000007',
    function: {
      displayName: 'Operations',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000006', '10000007'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000008',
    function: {
      displayName: 'Human Resources',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000006', '10000008'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000009',
    function: {
      displayName: 'Finance and Accounting',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000006', '10000009'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000011',
    function: {
      displayName: 'Operations',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000010', '10000011'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000012',
    function: {
      displayName: 'Human Resources',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000010', '10000012'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000013',
    function: {
      displayName: 'Finance and Accounting',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000010', '10000013'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000015',
    function: {
      displayName: 'Operations',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000014', '10000015'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000016',
    function: {
      displayName: 'Human Resources',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000014', '10000016'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000017',
    function: {
      displayName: 'Finance and Accounting',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000005', '10000014', '10000017'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000020',
    function: {
      displayName: 'Operations',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000019', '10000020'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000021',
    function: {
      displayName: 'Human Resources',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000019', '10000021'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000022',
    function: {
      displayName: 'Finance and Accounting',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000019', '10000022'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000024',
    function: {
      displayName: 'Operations',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000023', '10000024'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000025',
    function: {
      displayName: 'Human Resources',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000023', '10000025'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000026',
    function: {
      displayName: 'Finance and Accounting',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000023', '10000026'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000028',
    function: {
      displayName: 'Operations',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000027', '10000028'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000029',
    function: {
      displayName: 'Human Resources',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000027', '10000029'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000030',
    function: {
      displayName: 'Finance and Accounting',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000002', '10000018', '10000027', '10000030'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000033',
    function: {
      displayName: 'Operations',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000032', '10000033'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000034',
    function: {
      displayName: 'Human Resources',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000032', '10000034'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000035',
    function: {
      displayName: 'Finance and Accounting',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000032', '10000035'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000037',
    function: {
      displayName: 'Operations',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000036', '10000037'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000038',
    function: {
      displayName: 'Human Resources',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000036', '10000038'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000039',
    function: {
      displayName: 'Finance and Accounting',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000036', '10000039'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000041',
    function: {
      displayName: 'Operations',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000040', '10000041'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000042',
    function: {
      displayName: 'Human Resources',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000040', '10000042'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000043',
    function: {
      displayName: 'Finance and Accounting',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000031', '10000040', '10000043'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000046',
    function: {
      displayName: 'Operations',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000045', '10000046'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000047',
    function: {
      displayName: 'Human Resources',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000045', '10000047'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000048',
    function: {
      displayName: 'Finance and Accounting',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000045', '10000048'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000050',
    function: {
      displayName: 'Operations',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000049', '10000050'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000051',
    function: {
      displayName: 'Human Resources',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000049', '10000051'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000052',
    function: {
      displayName: 'Finance and Accounting',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000049', '10000052'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000054',
    function: {
      displayName: 'Operations',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000053', '10000054'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000055',
    function: {
      displayName: 'Human Resources',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000053', '10000055'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
  {
    id: '10000056',
    function: {
      displayName: 'Finance and Accounting',
      isGroup: false,
      level: 'DEPARTMENT',
      displayLevel: null,
    },
    hierarchy: ['10000001', '10000003', '10000044', '10000053', '10000056'],
    label: 'Same as BU guidelines',
    performance: {
      needsImprovement: {
        minValue: 2,
        maxValue: 3,
      },
      meetsExpectations: {
        minValue: 3,
        maxValue: 4,
      },
      exceedsExpectations: {
        minValue: 4,
        maxValue: 5,
      },
      outstanding: {
        minValue: 5,
        maxValue: 6,
      },
    },
  },
];

export const MOCK_CREATE_GUIDELINE_COLUMNS = [
  {
    columnId: 'label',
    displayName: 'Label',
    description: 'Label',
    columnType: AGGRID_COLUMN_TYPES.SIMPLE_TEXT,
  },
  {
    columnId: 'minValue',
    displayName: 'Min value',
    description: 'Min value',
    columnType: AGGRID_COLUMN_TYPES.SIMPLE_TEXT,
  },
  {
    columnId: 'maxValue',
    displayName: 'Max value',
    description: 'Max value',
    columnType: AGGRID_COLUMN_TYPES.SIMPLE_TEXT,
  },
];
